import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BooleanType: any;
  CustomData: any;
  Date: any;
  DateTime: any;
  FloatType: any;
  IntType: any;
  ItemId: any;
  JsonField: any;
  MetaTagAttributes: any;
  UploadId: any;
};

export type ArticleModelContentBlocksField = ImageRecord | VideoRecord;

export type ArticleModelContentField = {
  __typename?: 'ArticleModelContentField';
  blocks: Array<ArticleModelContentBlocksField>;
  links: Array<ArticleModelContentLinksField>;
  value: Scalars['JsonField'];
};

export type ArticleModelContentLinksField = BigTilesComponentRecord | ColumnContentComponentRecord | ExternalVideoRecord | FaqComponentRecord | FeaturedBlogPostComponentRecord | HeroImageComponentRecord | HomepageHeroComponentRecord | LinksAsCardsComponentRecord | ProductsSliderComponentRecord | RichTextComponentRecord | SmallTilesComponentRecord | SplitContentComponentRecord | SplitHeroComponentRecord;

/** Linking fields */
export enum ArticleModelFieldsReferencingBlogSectionModel {
  article_section = 'article_section'
}

export type ArticleModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ArticleModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ArticleModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _stage?: InputMaybe<RegularWorkflowWorkflowStageFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  content?: InputMaybe<StructuredTextFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  featuredProductDirection?: InputMaybe<StringFilter>;
  featuredProducts?: InputMaybe<LinksFilter>;
  heroVisual?: InputMaybe<FileFilter>;
  id?: InputMaybe<ItemIdFilter>;
  publishedDate?: InputMaybe<DateFilter>;
  section?: InputMaybe<LinkFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ArticleModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  featuredProductDirection_ASC = 'featuredProductDirection_ASC',
  featuredProductDirection_DESC = 'featuredProductDirection_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedDate_ASC = 'publishedDate_ASC',
  publishedDate_DESC = 'publishedDate_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Article (article) */
export type ArticleRecord = RecordInterface & {
  __typename?: 'ArticleRecord';
  _allReferencingBlogSections: Array<BlogSectionRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingBlogSectionsMeta: CollectionMetadata;
  _allReferencingFeaturedBlogPostComponents: Array<FeaturedBlogPostComponentRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingFeaturedBlogPostComponentsMeta: CollectionMetadata;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _stage: RegularWorkflowWorkflowStage;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  components?: Maybe<ComponentsWrapperRecord>;
  content?: Maybe<ArticleModelContentField>;
  createdAt: Scalars['DateTime'];
  featuredProductDirection?: Maybe<Scalars['String']>;
  featuredProducts: Array<ProductRecord>;
  heroVisual?: Maybe<FileField>;
  id: Scalars['ItemId'];
  publishedDate?: Maybe<Scalars['Date']>;
  section?: Maybe<BlogSectionRecord>;
  seo?: Maybe<SeoRecord>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Article (article) */
export type ArticleRecord_allReferencingBlogSectionsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BlogSectionModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BlogSectionModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenBlogSectionAndArticle>;
};


/** Record of type Article (article) */
export type ArticleRecord_allReferencingBlogSectionsMetaArgs = {
  filter?: InputMaybe<BlogSectionModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenBlogSectionAndArticle>;
};


/** Record of type Article (article) */
export type ArticleRecord_allReferencingFeaturedBlogPostComponentsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FeaturedBlogPostComponentModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FeaturedBlogPostComponentModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenFeaturedBlogPostComponentAndArticle>;
};


/** Record of type Article (article) */
export type ArticleRecord_allReferencingFeaturedBlogPostComponentsMetaArgs = {
  filter?: InputMaybe<FeaturedBlogPostComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenFeaturedBlogPostComponentAndArticle>;
};


/** Record of type Article (article) */
export type ArticleRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Products Banner (bestseller_banner) */
export type BestsellerBannerRecord = RecordInterface & {
  __typename?: 'BestsellerBannerRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  header?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  products: Array<ProductRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Products Banner (bestseller_banner) */
export type BestsellerBannerRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Big Tile (big_tile) */
export type BigTileRecord = RecordInterface & {
  __typename?: 'BigTileRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  analyticsType?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<FileField>;
  createdAt: Scalars['DateTime'];
  foregroundImages: Array<FileField>;
  header?: Maybe<Scalars['String']>;
  headerColor?: Maybe<ColorField>;
  id: Scalars['ItemId'];
  linkButton?: Maybe<BottonLinkWithColorRecord>;
  links: Array<LinkRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Big Tile (big_tile) */
export type BigTileRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type BigTilesComponentModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<BigTilesComponentModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BigTilesComponentModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  backgroundColor?: InputMaybe<ColorFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum BigTilesComponentModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Big Tiles Component (big_tiles_component) */
export type BigTilesComponentRecord = RecordInterface & {
  __typename?: 'BigTilesComponentRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundColor?: Maybe<ColorField>;
  bigTiles: Array<BigTileRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Big Tiles Component (big_tiles_component) */
export type BigTilesComponentRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Big Tiles Section (big_tiles_section) */
export type BigTilesSectionRecord = RecordInterface & {
  __typename?: 'BigTilesSectionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  bigTiles: Array<BigTileRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
};


/** Block of type Big Tiles Section (big_tiles_section) */
export type BigTilesSectionRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Blog Page (blog_page) */
export type BlogPageRecord = RecordInterface & {
  __typename?: 'BlogPageRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  bodyNewsletter?: Maybe<NewsletterRecord>;
  components?: Maybe<ComponentsWrapperRecord>;
  createdAt: Scalars['DateTime'];
  heroVisual?: Maybe<FileField>;
  id: Scalars['ItemId'];
  pageTitle?: Maybe<Scalars['String']>;
  seo?: Maybe<SeoRecord>;
  topNewsletter?: Maybe<NewsletterRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Blog Page (blog_page) */
export type BlogPageRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Linking fields */
export enum BlogSectionModelFieldsReferencingArticleModel {
  blogSection_mainArticle = 'blogSection_mainArticle',
  blogSection_secondaryArticles = 'blogSection_secondaryArticles'
}

export type BlogSectionModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogSectionModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogSectionModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  filterText?: InputMaybe<StringFilter>;
  heroVisual?: InputMaybe<FileFilter>;
  id?: InputMaybe<ItemIdFilter>;
  mainArticle?: InputMaybe<LinkFilter>;
  mainArticleSummary?: InputMaybe<StructuredTextFilter>;
  mainArticleTitle?: InputMaybe<StructuredTextFilter>;
  mainArticleTitleText?: InputMaybe<StringFilter>;
  secondaryArticles?: InputMaybe<LinksFilter>;
  seoold?: InputMaybe<SeoFilter>;
  shouldAppearAsCategoryFilter?: InputMaybe<BooleanFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type BlogSectionModelMainArticleSummaryField = {
  __typename?: 'BlogSectionModelMainArticleSummaryField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type BlogSectionModelMainArticleTitleField = {
  __typename?: 'BlogSectionModelMainArticleTitleField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export enum BlogSectionModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  filterText_ASC = 'filterText_ASC',
  filterText_DESC = 'filterText_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  mainArticleTitleText_ASC = 'mainArticleTitleText_ASC',
  mainArticleTitleText_DESC = 'mainArticleTitleText_DESC',
  shouldAppearAsCategoryFilter_ASC = 'shouldAppearAsCategoryFilter_ASC',
  shouldAppearAsCategoryFilter_DESC = 'shouldAppearAsCategoryFilter_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Blog Section (blog_section) */
export type BlogSectionRecord = RecordInterface & {
  __typename?: 'BlogSectionRecord';
  _allReferencingArticles: Array<ArticleRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingArticlesMeta: CollectionMetadata;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  filterText?: Maybe<Scalars['String']>;
  heroVisual?: Maybe<FileField>;
  id: Scalars['ItemId'];
  mainArticle?: Maybe<ArticleRecord>;
  mainArticleSummary?: Maybe<BlogSectionModelMainArticleSummaryField>;
  mainArticleTitle?: Maybe<BlogSectionModelMainArticleTitleField>;
  mainArticleTitleText?: Maybe<Scalars['String']>;
  secondaryArticles: Array<ArticleRecord>;
  seo?: Maybe<SeoRecord>;
  seoold?: Maybe<SeoField>;
  shouldAppearAsCategoryFilter?: Maybe<Scalars['BooleanType']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Blog Section (blog_section) */
export type BlogSectionRecord_allReferencingArticlesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ArticleModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ArticleModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenArticleAndBlogSection>;
};


/** Record of type Blog Section (blog_section) */
export type BlogSectionRecord_allReferencingArticlesMetaArgs = {
  filter?: InputMaybe<ArticleModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenArticleAndBlogSection>;
};


/** Record of type Blog Section (blog_section) */
export type BlogSectionRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Boolean fields */
export type BooleanFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['BooleanType']>;
};

/** Block of type Button Link With Color (botton_link_with_color) */
export type BottonLinkWithColorRecord = RecordInterface & {
  __typename?: 'BottonLinkWithColorRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundColor?: Maybe<ColorField>;
  color?: Maybe<ColorField>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};


/** Block of type Button Link With Color (botton_link_with_color) */
export type BottonLinkWithColorRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Bundle Item (bundle_item) */
export type BundleItemRecord = RecordInterface & {
  __typename?: 'BundleItemRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  amount?: Maybe<Scalars['IntType']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Bundle Item (bundle_item) */
export type BundleItemRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Button With Position (button_with_position) */
export type ButtonWithPositionRecord = RecordInterface & {
  __typename?: 'ButtonWithPositionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundColor?: Maybe<ColorField>;
  buttonText?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  horizontalPosition?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  textColor?: Maybe<ColorField>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
  verticalPosition?: Maybe<Scalars['String']>;
};


/** Block of type Button With Position (button_with_position) */
export type ButtonWithPositionRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Cart Page (cart_page) */
export type CartPageRecord = RecordInterface & {
  __typename?: 'CartPageRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  checkoutPaymentImages: Array<FileField>;
  components?: Maybe<ComponentsWrapperRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  seo?: Maybe<SeoRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Cart Page (cart_page) */
export type CartPageRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  count: Scalars['IntType'];
};

export type CollectionPageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<CollectionPageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CollectionPageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum CollectionPageModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Collection Page (collection_page) */
export type CollectionPageRecord = RecordInterface & {
  __typename?: 'CollectionPageRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  components?: Maybe<ComponentsWrapperRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  seo?: Maybe<SeoRecord>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Collection Page (collection_page) */
export type CollectionPageRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export enum ColorBucketType {
  black = 'black',
  blue = 'blue',
  brown = 'brown',
  cyan = 'cyan',
  green = 'green',
  grey = 'grey',
  orange = 'orange',
  pink = 'pink',
  purple = 'purple',
  red = 'red',
  white = 'white',
  yellow = 'yellow'
}

export type ColorField = {
  __typename?: 'ColorField';
  alpha: Scalars['IntType'];
  blue: Scalars['IntType'];
  cssRgb: Scalars['String'];
  green: Scalars['IntType'];
  hex: Scalars['String'];
  red: Scalars['IntType'];
};

/** Specifies how to filter Color fields */
export type ColorFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
};

/** Block of type Column Content Block (column_content_block) */
export type ColumnContentBlockRecord = RecordInterface & {
  __typename?: 'ColumnContentBlockRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  alignContent?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<ColorField>;
  centerItemContent?: Maybe<Scalars['BooleanType']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  itemWidth?: Maybe<Scalars['String']>;
  mediaItems: Array<MediaWithTextRecord>;
  showItemNumber?: Maybe<Scalars['BooleanType']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Column Content Block (column_content_block) */
export type ColumnContentBlockRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ColumnContentComponentModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ColumnContentComponentModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ColumnContentComponentModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  alignContent?: InputMaybe<StringFilter>;
  backgroundColor?: InputMaybe<ColorFilter>;
  centerItemContent?: InputMaybe<BooleanFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  itemWidth?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  showItemNumber?: InputMaybe<BooleanFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ColumnContentComponentModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  alignContent_ASC = 'alignContent_ASC',
  alignContent_DESC = 'alignContent_DESC',
  centerItemContent_ASC = 'centerItemContent_ASC',
  centerItemContent_DESC = 'centerItemContent_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  itemWidth_ASC = 'itemWidth_ASC',
  itemWidth_DESC = 'itemWidth_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  showItemNumber_ASC = 'showItemNumber_ASC',
  showItemNumber_DESC = 'showItemNumber_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Column Content Component (column_content_component) */
export type ColumnContentComponentRecord = RecordInterface & {
  __typename?: 'ColumnContentComponentRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  alignContent?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<ColorField>;
  centerItemContent?: Maybe<Scalars['BooleanType']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  itemWidth?: Maybe<Scalars['String']>;
  mediaItems: Array<MediaWithTextRecord>;
  name?: Maybe<Scalars['String']>;
  showItemNumber?: Maybe<Scalars['BooleanType']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Column Content Component (column_content_component) */
export type ColumnContentComponentRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ComponentsWrapperModelComponentsField = BigTilesComponentRecord | ColumnContentComponentRecord | ExternalVideoRecord | FaqComponentRecord | FeaturedBlogPostComponentRecord | HeroImageComponentRecord | HomepageHeroComponentRecord | LinksAsCardsComponentRecord | NewsletterRecord | ProductListComponentRecord | ProductsSliderComponentRecord | RichTextComponentRecord | SmallTilesComponentRecord | SplitContentComponentRecord | SplitHeroComponentRecord | TabsComponentRecord;

/** Block of type Components Wrapper (components_wrapper) */
export type ComponentsWrapperRecord = RecordInterface & {
  __typename?: 'ComponentsWrapperRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  components: Array<ComponentsWrapperModelComponentsField>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
};


/** Block of type Components Wrapper (components_wrapper) */
export type ComponentsWrapperRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by creation datetime */
export type CreatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']>;
};

/** Block of type Custom Cylinder (custom_cylinder) */
export type CustomCylinderRecord = RecordInterface & {
  __typename?: 'CustomCylinderRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  buttonText?: Maybe<Scalars['String']>;
  buttonUrl?: Maybe<Scalars['String']>;
  compatibleMachines: Array<ProductRecord>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  price?: Maybe<Scalars['IntType']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Custom Cylinder (custom_cylinder) */
export type CustomCylinderRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Custom Mobile Header Link (custom_mobile_header_link) */
export type CustomMobileHeaderLinkRecord = RecordInterface & {
  __typename?: 'CustomMobileHeaderLinkRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  color?: Maybe<ColorField>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  openMenu?: Maybe<Scalars['BooleanType']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};


/** Block of type Custom Mobile Header Link (custom_mobile_header_link) */
export type CustomMobileHeaderLinkRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Cylinder Frequency Option (cylinder_frequency_option) */
export type CylinderFrequencyOptionRecord = RecordInterface & {
  __typename?: 'CylinderFrequencyOptionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  periodLengthNumber?: Maybe<Scalars['IntType']>;
  periodLengthText?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Cylinder Frequency Option (cylinder_frequency_option) */
export type CylinderFrequencyOptionRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Cylinder Quantity Option (cylinder_quantity_option) */
export type CylinderQuantityOptionRecord = RecordInterface & {
  __typename?: 'CylinderQuantityOptionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  amount?: Maybe<Scalars['IntType']>;
  createdAt: Scalars['DateTime'];
  extraText?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  promotionalText?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Cylinder Quantity Option (cylinder_quantity_option) */
export type CylinderQuantityOptionRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CylinderTypeModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<CylinderTypeModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CylinderTypeModelFilter>>>;
  bigImage?: InputMaybe<FileFilter>;
  blueBoxText?: InputMaybe<StringFilter>;
  compatibleMachines?: InputMaybe<LinksFilter>;
  description?: InputMaybe<StringFilter>;
  gtin?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  lowestPriceText?: InputMaybe<StringFilter>;
  thumbnailImage?: InputMaybe<FileFilter>;
  title?: InputMaybe<StringFilter>;
};

/** Block of type Cylinder Type (cylinder_type) */
export type CylinderTypeRecord = RecordInterface & {
  __typename?: 'CylinderTypeRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  bigImage?: Maybe<FileField>;
  blueBoxText?: Maybe<Scalars['String']>;
  compatibleMachines: Array<ProductRecord>;
  createdAt: Scalars['DateTime'];
  cylinderTextDescription: Array<TextDescriptionRecord>;
  description?: Maybe<Scalars['String']>;
  gtin?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  lowestPriceText?: Maybe<Scalars['String']>;
  spareCylinder?: Maybe<ExtraCylinderRecord>;
  thumbnailImage?: Maybe<FileField>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Cylinder Type (cylinder_type) */
export type CylinderTypeRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Date fields */
export type DateFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['Date']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['Date']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['Date']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['Date']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['Date']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['Date']>;
};

/** Record of type Desktop Header (desktop_header) */
export type DesktopHeaderRecord = RecordInterface & {
  __typename?: 'DesktopHeaderRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _stage: RegularWorkflowWorkflowStage;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  leftDropdownItems: Array<HeaderLeftDropdownItemRecord>;
  middleLinks: Array<LinkRecord>;
  promotionalBar?: Maybe<Scalars['String']>;
  promotionalBarBackgroundColor?: Maybe<ColorField>;
  promotionalBarLink?: Maybe<Scalars['String']>;
  promotionalBarTextColor?: Maybe<ColorField>;
  rightLinks: Array<LinkRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Desktop Header (desktop_header) */
export type DesktopHeaderRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Error Page (error_page) */
export type ErrorPageRecord = RecordInterface & {
  __typename?: 'ErrorPageRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  linkText?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Error Page (error_page) */
export type ErrorPageRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ExternalVideoModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ExternalVideoModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ExternalVideoModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  fullPageWidth?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<ItemIdFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  videoUrl?: InputMaybe<VideoFilter>;
};

export enum ExternalVideoModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fullPageWidth_ASC = 'fullPageWidth_ASC',
  fullPageWidth_DESC = 'fullPageWidth_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type External Video Component (external_video) */
export type ExternalVideoRecord = RecordInterface & {
  __typename?: 'ExternalVideoRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  fullPageWidth?: Maybe<Scalars['BooleanType']>;
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
  videoUrl?: Maybe<VideoField>;
};


/** Record of type External Video Component (external_video) */
export type ExternalVideoRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Extra Cylinder (extra_cylinder) */
export type ExtraCylinderRecord = RecordInterface & {
  __typename?: 'ExtraCylinderRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  gtin?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  lowestPriceText?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['FloatType']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Extra Cylinder (extra_cylinder) */
export type ExtraCylinderRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FaqComponentModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FaqComponentModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FaqComponentModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum FaqComponentModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Faq Component (faq_component) */
export type FaqComponentRecord = RecordInterface & {
  __typename?: 'FaqComponentRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  questions: Array<FaqQuestionRecord>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Faq Component (faq_component) */
export type FaqComponentRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FaqQuestionModelAnswerField = {
  __typename?: 'FaqQuestionModelAnswerField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Faq Question (faq_question) */
export type FaqQuestionRecord = RecordInterface & {
  __typename?: 'FaqQuestionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  answer?: Maybe<FaqQuestionModelAnswerField>;
  button?: Maybe<LinkRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  question?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Faq Question (faq_question) */
export type FaqQuestionRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type FAQ (faq) */
export type FaqRecord = RecordInterface & {
  __typename?: 'FaqRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  questions: Array<FaqQuestionRecord>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type FAQ (faq) */
export type FaqRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export enum FaviconType {
  appleTouchIcon = 'appleTouchIcon',
  icon = 'icon',
  msApplication = 'msApplication'
}

/** Linking fields */
export enum FeaturedBlogPostComponentModelFieldsReferencingArticleModel {
  featuredBlogPostComponent_articles = 'featuredBlogPostComponent_articles'
}

export type FeaturedBlogPostComponentModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FeaturedBlogPostComponentModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FeaturedBlogPostComponentModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  articles?: InputMaybe<LinksFilter>;
  backgroundColor?: InputMaybe<ColorFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  header?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  subHeader?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum FeaturedBlogPostComponentModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  header_ASC = 'header_ASC',
  header_DESC = 'header_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  subHeader_ASC = 'subHeader_ASC',
  subHeader_DESC = 'subHeader_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Featured Blog Post Component (featured_blog_post_component) */
export type FeaturedBlogPostComponentRecord = RecordInterface & {
  __typename?: 'FeaturedBlogPostComponentRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  articles: Array<ArticleRecord>;
  backgroundColor?: Maybe<ColorField>;
  createdAt: Scalars['DateTime'];
  header?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  subHeader?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Featured Blog Post Component (featured_blog_post_component) */
export type FeaturedBlogPostComponentRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Featured Product (featured_product) */
export type FeaturedProductRecord = RecordInterface & {
  __typename?: 'FeaturedProductRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
};


/** Block of type Featured Product (featured_product) */
export type FeaturedProductRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FileField = FileFieldInterface & {
  __typename?: 'FileField';
  _createdAt: Scalars['DateTime'];
  /** The DatoCMS URL where you can edit this entity. To use this field, you need to set a X-Base-Editing-Url header in the request */
  _editingUrl?: Maybe<Scalars['String']>;
  _updatedAt: Scalars['DateTime'];
  alt?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  basename: Scalars['String'];
  blurUpThumb?: Maybe<Scalars['String']>;
  blurhash?: Maybe<Scalars['String']>;
  colors: Array<ColorField>;
  copyright?: Maybe<Scalars['String']>;
  customData: Scalars['CustomData'];
  exifInfo: Scalars['CustomData'];
  filename: Scalars['String'];
  focalPoint?: Maybe<focalPoint>;
  format: Scalars['String'];
  height?: Maybe<Scalars['IntType']>;
  id: Scalars['UploadId'];
  md5: Scalars['String'];
  mimeType: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  responsiveImage?: Maybe<ResponsiveImage>;
  size: Scalars['IntType'];
  smartTags: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  thumbhash?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  video?: Maybe<UploadVideoField>;
  width?: Maybe<Scalars['IntType']>;
};


export type FileFieldaltArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldblurUpThumbArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
  punch?: Scalars['Float'];
  quality?: Scalars['Int'];
  size?: Scalars['Int'];
};


export type FileFieldcustomDataArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldfocalPointArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldresponsiveImageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  imgixParams?: InputMaybe<ImgixParams>;
  locale?: InputMaybe<SiteLocale>;
  sizes?: InputMaybe<Scalars['String']>;
};


export type FileFieldtitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldurlArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
};

export type FileFieldInterface = {
  _createdAt: Scalars['DateTime'];
  /** The DatoCMS URL where you can edit this entity. To use this field, you need to set a X-Base-Editing-Url header in the request */
  _editingUrl?: Maybe<Scalars['String']>;
  _updatedAt: Scalars['DateTime'];
  alt?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  basename: Scalars['String'];
  blurUpThumb?: Maybe<Scalars['String']>;
  blurhash?: Maybe<Scalars['String']>;
  colors: Array<ColorField>;
  copyright?: Maybe<Scalars['String']>;
  customData: Scalars['CustomData'];
  exifInfo: Scalars['CustomData'];
  filename: Scalars['String'];
  focalPoint?: Maybe<focalPoint>;
  format: Scalars['String'];
  height?: Maybe<Scalars['IntType']>;
  id: Scalars['UploadId'];
  md5: Scalars['String'];
  mimeType: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  responsiveImage?: Maybe<ResponsiveImage>;
  size: Scalars['IntType'];
  smartTags: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  thumbhash?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  video?: Maybe<UploadVideoField>;
  width?: Maybe<Scalars['IntType']>;
};


export type FileFieldInterfacealtArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldInterfaceblurUpThumbArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
  punch?: Scalars['Float'];
  quality?: Scalars['Int'];
  size?: Scalars['Int'];
};


export type FileFieldInterfacecustomDataArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldInterfacefocalPointArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldInterfaceresponsiveImageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  imgixParams?: InputMaybe<ImgixParams>;
  locale?: InputMaybe<SiteLocale>;
  sizes?: InputMaybe<Scalars['String']>;
};


export type FileFieldInterfacetitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldInterfaceurlArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
};

/** Specifies how to filter Single-file/image fields */
export type FileFilter = {
  /** Search for records with an exact match. The specified value must be an Upload ID */
  eq?: InputMaybe<Scalars['UploadId']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records that have one of the specified uploads */
  in?: InputMaybe<Array<InputMaybe<Scalars['UploadId']>>>;
  /** Exclude records with an exact match. The specified value must be an Upload ID */
  neq?: InputMaybe<Scalars['UploadId']>;
  /** Filter records that do not have one of the specified uploads */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']>>>;
};

/** Specifies how to filter Floating-point fields */
export type FloatFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['FloatType']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['FloatType']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['FloatType']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['FloatType']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['FloatType']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['FloatType']>;
};

export type FooterModelCopyrightInfoField = {
  __typename?: 'FooterModelCopyrightInfoField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Record of type Footer (footer) */
export type FooterRecord = RecordInterface & {
  __typename?: 'FooterRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _stage: RegularWorkflowWorkflowStage;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  copyrightInfo?: Maybe<FooterModelCopyrightInfoField>;
  createdAt: Scalars['DateTime'];
  firstColumnHeading?: Maybe<Scalars['String']>;
  firstColumnLinks: Array<LinkRecord>;
  id: Scalars['ItemId'];
  newsletter?: Maybe<NewsletterRecord>;
  secondColumnHeading?: Maybe<Scalars['String']>;
  secondColumnLinks: Array<LinkRecord>;
  socialMediaLinks: Array<ImageLinkRecord>;
  thirdColumnHeading?: Maybe<Scalars['String']>;
  thirdColumnLinks: Array<LinkRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Footer (footer) */
export type FooterRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Multiple files/images field */
export type GalleryFilter = {
  /** Filter records that have all of the specified uploads. The specified values must be Upload IDs */
  allIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']>>>;
  /** Filter records that have one of the specified uploads. The specified values must be Upload IDs */
  anyIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']>>>;
  /** Search for records with an exact match. The specified values must be Upload IDs */
  eq?: InputMaybe<Array<InputMaybe<Scalars['UploadId']>>>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records that do not have any of the specified uploads. The specified values must be Upload IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']>>>;
};

/** Record of type Gas Exchange Page (gas_exchange_page) */
export type GasExchangePageRecord = RecordInterface & {
  __typename?: 'GasExchangePageRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  bottlesSelect?: Maybe<NumericSelectRecord>;
  components?: Maybe<ComponentsWrapperRecord>;
  createdAt: Scalars['DateTime'];
  customCylinders: Array<CustomCylinderRecord>;
  cylinders: Array<ProductRecord>;
  gasSelectorText?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  lowestPriceText?: Maybe<Scalars['String']>;
  pageBackgroundColor?: Maybe<ColorField>;
  peopleSelect?: Maybe<NumericSelectRecord>;
  recommendedCylindersText?: Maybe<Scalars['String']>;
  seo?: Maybe<SeoRecord>;
  title?: Maybe<PageTitleRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Gas Exchange Page (gas_exchange_page) */
export type GasExchangePageRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type GlobalSeoField = {
  __typename?: 'GlobalSeoField';
  facebookPageUrl?: Maybe<Scalars['String']>;
  fallbackSeo?: Maybe<SeoField>;
  siteName?: Maybe<Scalars['String']>;
  titleSuffix?: Maybe<Scalars['String']>;
  twitterAccount?: Maybe<Scalars['String']>;
};

/** Block of type Header Image Link (header_image_link) */
export type HeaderImageLinkRecord = RecordInterface & {
  __typename?: 'HeaderImageLinkRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  text?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};


/** Block of type Header Image Link (header_image_link) */
export type HeaderImageLinkRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Header Image Link with Color (header_image_link_with_color) */
export type HeaderImageLinkWithColorRecord = RecordInterface & {
  __typename?: 'HeaderImageLinkWithColorRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundColor?: Maybe<ColorField>;
  createdAt: Scalars['DateTime'];
  customTextColor?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  linkText?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};


/** Block of type Header Image Link with Color (header_image_link_with_color) */
export type HeaderImageLinkWithColorRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Header Left Dropdown Item (header_left_dropdown_item) */
export type HeaderLeftDropdownItemRecord = RecordInterface & {
  __typename?: 'HeaderLeftDropdownItemRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  headerLeftSingleDropdown: Array<HeaderImageLinkWithColorRecord>;
  id: Scalars['ItemId'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Header Left Dropdown Item (header_left_dropdown_item) */
export type HeaderLeftDropdownItemRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type HeroImageComponentModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeroImageComponentModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeroImageComponentModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  analyticsPromoName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  link?: InputMaybe<StringFilter>;
  media?: InputMaybe<FileFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum HeroImageComponentModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  analyticsPromoName_ASC = 'analyticsPromoName_ASC',
  analyticsPromoName_DESC = 'analyticsPromoName_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  link_ASC = 'link_ASC',
  link_DESC = 'link_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Hero Image Component (hero_image_component) */
export type HeroImageComponentRecord = RecordInterface & {
  __typename?: 'HeroImageComponentRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  analyticsPromoName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  link?: Maybe<Scalars['String']>;
  media?: Maybe<FileField>;
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Hero Image Component (hero_image_component) */
export type HeroImageComponentRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Hero Image Section (hero_image_section) */
export type HeroImageSectionRecord = RecordInterface & {
  __typename?: 'HeroImageSectionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  link?: Maybe<Scalars['String']>;
  media?: Maybe<FileField>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Hero Image Section (hero_image_section) */
export type HeroImageSectionRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Hero (hero) */
export type HeroRecord = RecordInterface & {
  __typename?: 'HeroRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundImage?: Maybe<FileField>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  horizontalPosition?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  imageXCenter?: Maybe<Scalars['IntType']>;
  imageYCenter?: Maybe<Scalars['IntType']>;
  link?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  textColor?: Maybe<ColorField>;
  updatedAt: Scalars['DateTime'];
  verticalPosition?: Maybe<Scalars['String']>;
};


/** Block of type Hero (hero) */
export type HeroRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Home Page (home_page) */
export type HomePageRecord = RecordInterface & {
  __typename?: 'HomePageRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  components?: Maybe<ComponentsWrapperRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  seo?: Maybe<SeoRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Home Page (home_page) */
export type HomePageRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type HomepageHeroComponentModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<HomepageHeroComponentModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HomepageHeroComponentModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  analyticsPromoName?: InputMaybe<StringFilter>;
  backgroundImage?: InputMaybe<FileFilter>;
  backgroundImageClickLink?: InputMaybe<StringFilter>;
  buttonBackgroundColor?: InputMaybe<ColorFilter>;
  buttonTextColor?: InputMaybe<ColorFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  header?: InputMaybe<StringFilter>;
  headerFontSize?: InputMaybe<StringFilter>;
  heroHeight?: InputMaybe<StringFilter>;
  horizontalPosition?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  imageXCenter?: InputMaybe<IntegerFilter>;
  imageYCenter?: InputMaybe<IntegerFilter>;
  link?: InputMaybe<StringFilter>;
  linkText?: InputMaybe<StringFilter>;
  mobileAnalyticsPromoName?: InputMaybe<StringFilter>;
  mobileBackgroundImage?: InputMaybe<FileFilter>;
  mobileBackgroundImageClickLink?: InputMaybe<StringFilter>;
  mobileHeaderFontSize?: InputMaybe<StringFilter>;
  mobileHeroHeight?: InputMaybe<StringFilter>;
  mobileHorizontalPosition?: InputMaybe<StringFilter>;
  mobileImageXCenter?: InputMaybe<IntegerFilter>;
  mobileImageYCenter?: InputMaybe<IntegerFilter>;
  mobileVerticalPosition?: InputMaybe<StringFilter>;
  showOnDesktop?: InputMaybe<BooleanFilter>;
  showOnMobile?: InputMaybe<BooleanFilter>;
  textColor?: InputMaybe<ColorFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  verticalPosition?: InputMaybe<StringFilter>;
};

export enum HomepageHeroComponentModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  analyticsPromoName_ASC = 'analyticsPromoName_ASC',
  analyticsPromoName_DESC = 'analyticsPromoName_DESC',
  backgroundImageClickLink_ASC = 'backgroundImageClickLink_ASC',
  backgroundImageClickLink_DESC = 'backgroundImageClickLink_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  headerFontSize_ASC = 'headerFontSize_ASC',
  headerFontSize_DESC = 'headerFontSize_DESC',
  header_ASC = 'header_ASC',
  header_DESC = 'header_DESC',
  heroHeight_ASC = 'heroHeight_ASC',
  heroHeight_DESC = 'heroHeight_DESC',
  horizontalPosition_ASC = 'horizontalPosition_ASC',
  horizontalPosition_DESC = 'horizontalPosition_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  imageXCenter_ASC = 'imageXCenter_ASC',
  imageXCenter_DESC = 'imageXCenter_DESC',
  imageYCenter_ASC = 'imageYCenter_ASC',
  imageYCenter_DESC = 'imageYCenter_DESC',
  linkText_ASC = 'linkText_ASC',
  linkText_DESC = 'linkText_DESC',
  link_ASC = 'link_ASC',
  link_DESC = 'link_DESC',
  mobileAnalyticsPromoName_ASC = 'mobileAnalyticsPromoName_ASC',
  mobileAnalyticsPromoName_DESC = 'mobileAnalyticsPromoName_DESC',
  mobileBackgroundImageClickLink_ASC = 'mobileBackgroundImageClickLink_ASC',
  mobileBackgroundImageClickLink_DESC = 'mobileBackgroundImageClickLink_DESC',
  mobileHeaderFontSize_ASC = 'mobileHeaderFontSize_ASC',
  mobileHeaderFontSize_DESC = 'mobileHeaderFontSize_DESC',
  mobileHeroHeight_ASC = 'mobileHeroHeight_ASC',
  mobileHeroHeight_DESC = 'mobileHeroHeight_DESC',
  mobileHorizontalPosition_ASC = 'mobileHorizontalPosition_ASC',
  mobileHorizontalPosition_DESC = 'mobileHorizontalPosition_DESC',
  mobileImageXCenter_ASC = 'mobileImageXCenter_ASC',
  mobileImageXCenter_DESC = 'mobileImageXCenter_DESC',
  mobileImageYCenter_ASC = 'mobileImageYCenter_ASC',
  mobileImageYCenter_DESC = 'mobileImageYCenter_DESC',
  mobileVerticalPosition_ASC = 'mobileVerticalPosition_ASC',
  mobileVerticalPosition_DESC = 'mobileVerticalPosition_DESC',
  showOnDesktop_ASC = 'showOnDesktop_ASC',
  showOnDesktop_DESC = 'showOnDesktop_DESC',
  showOnMobile_ASC = 'showOnMobile_ASC',
  showOnMobile_DESC = 'showOnMobile_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  verticalPosition_ASC = 'verticalPosition_ASC',
  verticalPosition_DESC = 'verticalPosition_DESC'
}

/** Record of type Homepage Hero Component (homepage_hero_component) */
export type HomepageHeroComponentRecord = RecordInterface & {
  __typename?: 'HomepageHeroComponentRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  analyticsPromoName?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<FileField>;
  backgroundImageClickLink?: Maybe<Scalars['String']>;
  buttonBackgroundColor?: Maybe<ColorField>;
  buttonTextColor?: Maybe<ColorField>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  headerFontSize?: Maybe<Scalars['String']>;
  heroHeight?: Maybe<Scalars['String']>;
  horizontalPosition?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  imageXCenter?: Maybe<Scalars['IntType']>;
  imageYCenter?: Maybe<Scalars['IntType']>;
  link?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  mobileAnalyticsPromoName?: Maybe<Scalars['String']>;
  mobileBackgroundImage?: Maybe<FileField>;
  mobileBackgroundImageClickLink?: Maybe<Scalars['String']>;
  mobileHeaderFontSize?: Maybe<Scalars['String']>;
  mobileHeroHeight?: Maybe<Scalars['String']>;
  mobileHorizontalPosition?: Maybe<Scalars['String']>;
  mobileImageXCenter?: Maybe<Scalars['IntType']>;
  mobileImageYCenter?: Maybe<Scalars['IntType']>;
  mobileVerticalPosition?: Maybe<Scalars['String']>;
  showOnDesktop?: Maybe<Scalars['BooleanType']>;
  showOnMobile?: Maybe<Scalars['BooleanType']>;
  textColor?: Maybe<ColorField>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  verticalPosition?: Maybe<Scalars['String']>;
};


/** Record of type Homepage Hero Component (homepage_hero_component) */
export type HomepageHeroComponentRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Homepage Hero (homepage_hero) */
export type HomepageHeroRecord = RecordInterface & {
  __typename?: 'HomepageHeroRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _stage: RegularWorkflowWorkflowStage;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  homepageHero: Array<HeroRecord>;
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
};


/** Record of type Homepage Hero (homepage_hero) */
export type HomepageHeroRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Icon With Image (icon_with_image) */
export type IconWithImageRecord = RecordInterface & {
  __typename?: 'IconWithImageRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Icon With Image (icon_with_image) */
export type IconWithImageRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Image Link (image_link) */
export type ImageLinkRecord = RecordInterface & {
  __typename?: 'ImageLinkRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};


/** Block of type Image Link (image_link) */
export type ImageLinkRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Image Link With Text (image_link_with_text) */
export type ImageLinkWithTextRecord = RecordInterface & {
  __typename?: 'ImageLinkWithTextRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};


/** Block of type Image Link With Text (image_link_with_text) */
export type ImageLinkWithTextRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Image (image) */
export type ImageRecord = RecordInterface & {
  __typename?: 'ImageRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  link: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


/** Block of type Image (image) */
export type ImageRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ImgixParams = {
  /**
   * Aspect Ratio
   *
   * Specifies an aspect ratio to maintain when resizing and cropping the image
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/ar)
   */
  ar?: InputMaybe<Scalars['String']>;
  /**
   * Automatic
   *
   * Applies automatic enhancements to images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/auto)
   */
  auto?: InputMaybe<Array<ImgixParamsAuto>>;
  /**
   * Background Color
   *
   * Colors the background of padded and partially-transparent images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/bg)
   */
  bg?: InputMaybe<Scalars['String']>;
  /**
   * Background Removal
   *
   * Removes background from image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/bg-remove)
   */
  bgRemove?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Background Removal Fallback
   *
   * Overrides default fallback behavior for bg-remove failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/bg-remove)
   */
  bgRemoveFallback?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Background Replacement
   *
   * Replaces background from image using a string based prompt.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/bg-replace)
   */
  bgReplace?: InputMaybe<Scalars['String']>;
  /**
   * Background Removal Fallback
   *
   * Overrides default fallback behavior for bg-replace failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/bg-replace)
   */
  bgReplaceFallback?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Background Replacement Negative Prompt
   *
   * Provides a negative text suggestion for background replacement.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/bg-replace-neg-prompt)
   */
  bgReplaceNegPrompt?: InputMaybe<Scalars['String']>;
  /**
   * Blend
   *
   * Specifies the location of the blend image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend)
   */
  blend?: InputMaybe<Scalars['String']>;
  /**
   * Blend Align
   *
   * Changes the blend alignment relative to the parent image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-align)
   */
  blendAlign?: InputMaybe<Array<ImgixParamsBlendAlign>>;
  /**
   * Blend Alpha
   *
   * Changes the alpha of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-alpha)
   */
  blendAlpha?: InputMaybe<Scalars['IntType']>;
  /**
   * Blend Color
   *
   * Specifies a color to use when applying the blend.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-color)
   */
  blendColor?: InputMaybe<Scalars['String']>;
  /**
   * Blend Crop
   *
   * Specifies the type of crop for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-crop)
   */
  blendCrop?: InputMaybe<Array<ImgixParamsBlendCrop>>;
  /**
   * Blend Fit
   *
   * Specifies the fit mode for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-fit)
   */
  blendFit?: InputMaybe<ImgixParamsBlendFit>;
  /**
   * Blend Height
   *
   * Adjusts the height of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-h)
   */
  blendH?: InputMaybe<Scalars['FloatType']>;
  /**
   * Blend Mode
   *
   * Sets the blend mode for a blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-mode)
   */
  blendMode?: InputMaybe<ImgixParamsBlendMode>;
  /**
   * Blend Padding
   *
   * Applies padding to the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-pad)
   */
  blendPad?: InputMaybe<Scalars['IntType']>;
  /**
   * Blend Size
   *
   * Adjusts the size of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-size)
   */
  blendSize?: InputMaybe<ImgixParamsBlendSize>;
  /**
   * Blend Width
   *
   * Adjusts the width of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-w)
   */
  blendW?: InputMaybe<Scalars['FloatType']>;
  /**
   * Blend X Position
   *
   * Adjusts the x-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-x)
   */
  blendX?: InputMaybe<Scalars['IntType']>;
  /**
   * Blend Y Position
   *
   * Adjusts the y-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/blending/blend-y)
   */
  blendY?: InputMaybe<Scalars['IntType']>;
  /**
   * Gaussian Blur
   *
   * Applies a gaussian blur to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/stylize/blur)
   */
  blur?: InputMaybe<Scalars['IntType']>;
  /**
   * Border Size & Color
   *
   * Applies a border to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/border)
   */
  border?: InputMaybe<Scalars['String']>;
  /**
   * Border Bottom
   *
   * Sets bottom border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/border-bottom)
   */
  borderBottom?: InputMaybe<Scalars['IntType']>;
  /**
   * Border Left
   *
   * Sets left border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/border-left)
   */
  borderLeft?: InputMaybe<Scalars['IntType']>;
  /**
   * Outer Border Radius
   *
   * Sets the outer radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/border-radius)
   */
  borderRadius?: InputMaybe<Scalars['String']>;
  /**
   * Inner Border Radius
   *
   * Sets the inner radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/border-radius-inner)
   */
  borderRadiusInner?: InputMaybe<Scalars['String']>;
  /**
   * Border Right
   *
   * Sets right border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/border-right)
   */
  borderRight?: InputMaybe<Scalars['IntType']>;
  /**
   * Border Top
   *
   * Sets top border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/border-top)
   */
  borderTop?: InputMaybe<Scalars['IntType']>;
  /**
   * Brightness
   *
   * Adjusts the brightness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/bri)
   */
  bri?: InputMaybe<Scalars['IntType']>;
  /**
   * Client Hints
   *
   * Sets one or more Client-Hints headers
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/format/ch)
   */
  ch?: InputMaybe<Array<ImgixParamsCh>>;
  /**
   * Chroma Subsampling
   *
   * Specifies the output chroma subsampling rate.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/format/chromasub)
   */
  chromasub?: InputMaybe<Scalars['IntType']>;
  /**
   * Color Quantization
   *
   * Limits the number of unique colors in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/format/colorquant)
   */
  colorquant?: InputMaybe<Scalars['IntType']>;
  /**
   * Palette Color Count
   *
   * Specifies how many colors to include in a palette-extraction response.
   *
   * Depends on: `palette`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/color-palette/colors)
   */
  colors?: InputMaybe<Scalars['IntType']>;
  /**
   * Contrast
   *
   * Adjusts the contrast of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/con)
   */
  con?: InputMaybe<Scalars['IntType']>;
  /**
   * Mask Corner Radius
   *
   * Specifies the radius value for a rounded corner mask.
   *
   * Depends on: `mask=corners`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/mask/corner-radius)
   */
  cornerRadius?: InputMaybe<Scalars['String']>;
  /**
   * Crop Mode
   *
   * Specifies how to crop an image.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/crop)
   */
  crop?: InputMaybe<Array<ImgixParamsCrop>>;
  /**
   * Color Space
   *
   * Specifies the color space of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/format/cs)
   */
  cs?: InputMaybe<ImgixParamsCs>;
  /**
   * Download
   *
   * Forces a URL to use send-file in its response.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/format/dl)
   */
  dl?: InputMaybe<Scalars['String']>;
  /**
   * Dots Per Inch
   *
   * Sets the DPI value in the EXIF header.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/format/dpi)
   */
  dpi?: InputMaybe<Scalars['IntType']>;
  /**
   * Device Pixel Ratio
   *
   * Adjusts the device-pixel ratio of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/dpr)
   */
  dpr?: InputMaybe<Scalars['FloatType']>;
  /**
   * Duotone
   *
   * Applies a duotone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/stylize/duotone)
   */
  duotone?: InputMaybe<Scalars['String']>;
  /**
   * Duotone Alpha
   *
   * Changes the alpha of the duotone effect atop the source image.
   *
   * Depends on: `duotone`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/stylize/duotone-alpha)
   */
  duotoneAlpha?: InputMaybe<Scalars['IntType']>;
  /**
   * Exposure
   *
   * Adjusts the exposure of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/exp)
   */
  exp?: InputMaybe<Scalars['IntType']>;
  /**
   * Url Expiration Timestamp
   *
   * A Unix timestamp specifying a UTC time. Requests made to this URL after that time will output a 404 status code.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/expires)
   */
  expires?: InputMaybe<Scalars['IntType']>;
  /**
   * Face Index
   *
   * Selects a face to crop to.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/face-detection/faceindex)
   */
  faceindex?: InputMaybe<Scalars['IntType']>;
  /**
   * Face Padding
   *
   * Adjusts padding around a selected face.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/face-detection/facepad)
   */
  facepad?: InputMaybe<Scalars['FloatType']>;
  /**
   * Json Face Data
   *
   * Specifies that face data should be included in output when combined with `fm=json`.
   *
   * Depends on: `fm=json`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/face-detection/faces)
   */
  faces?: InputMaybe<Scalars['IntType']>;
  /**
   * Fill Mode
   *
   * Determines how to fill in additional space created by the fit setting
   *
   * Depends on: `fit`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill)
   */
  fill?: InputMaybe<ImgixParamsFill>;
  /**
   * Fill Color
   *
   * Sets the fill color for images with additional space created by the fit setting
   *
   * Depends on: `fill=solid`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-color)
   */
  fillColor?: InputMaybe<Scalars['String']>;
  /**
   * Fill Generative Fallback
   *
   * Sets the fallback behavior for generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gen-fallback)
   */
  fillGenFallback?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Fill Generative Negative Prompt
   *
   * Provides a negative text suggestion to the generative fill parameter. Used to reduce the probability of a subject, detail, or object appearing in generative output.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gen-neg-prompt)
   */
  fillGenNegPrompt?: InputMaybe<Scalars['String']>;
  /**
   * Fill Generative Position
   *
   * Sets the position of the Origin Image in relation to the generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gen-pos)
   */
  fillGenPos?: InputMaybe<Array<ImgixParamsFillGenPos>>;
  /**
   * Fill Generative Prompt
   *
   * Provides a text suggestion to the generative fill parameter.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gen-prompt)
   */
  fillGenPrompt?: InputMaybe<Scalars['String']>;
  /**
   * Fill Generative Seed
   *
   * Sets the generative seed value. Used to generate similar outputs from different prompts.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gen-seed)
   */
  fillGenSeed?: InputMaybe<Scalars['IntType']>;
  /**
   * Fill Gradient Color Space
   *
   * Defines the color space as linear, sRGB, Oklab, HSL, or LCH for gradient color interpolation
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gradient-cs)
   */
  fillGradientCs?: InputMaybe<ImgixParamsFillGradientCs>;
  /**
   * Fill Gradient Linear
   *
   * Blends a gradient between two colors, {color1} and {color2}, along a straight path
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gradient-linear)
   */
  fillGradientLinear?: InputMaybe<Scalars['String']>;
  /**
   * Fill Gradient Linear Direction
   *
   * The fill-gradient-linear-direction specifies the gradient's direction, flowing towards the bottom, top, right, or left
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gradient-linear-direction)
   */
  fillGradientLinearDirection?: InputMaybe<Array<ImgixParamsFillGradientLinearDirection>>;
  /**
   * Fill Gradient Radial
   *
   * The fill-gradient-radial parameter creates a circular gradient transitioning from a central color (Color1) to an outer color (Color2)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gradient-radial)
   */
  fillGradientRadial?: InputMaybe<Scalars['String']>;
  /**
   * Fill Gradient Radial Radius
   *
   * Parameter defines the radial gradient's radius as pixels or a percentage (0.0-1.0) of the image's smallest dimension
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gradient-radial-radius)
   */
  fillGradientRadialRadius?: InputMaybe<Scalars['String']>;
  /**
   * Fill Gradient Radial X
   *
   * Specifies the location of the radial gradient's center along the x-axis, using either a pixel value or a floating point percentage (ranging from 0.0 to 1.0) of the image's width
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gradient-radial-x)
   */
  fillGradientRadialX?: InputMaybe<Scalars['FloatType']>;
  /**
   * Fill Gradient Radial Y
   *
   * Parameter sets the radial gradient's center on the y-axis, using pixels or a 0.0 to 1.0 percentage of the image's height
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gradient-radial-y)
   */
  fillGradientRadialY?: InputMaybe<Scalars['FloatType']>;
  /**
   * Fill Gradient Type
   *
   * Specifies if a gradient is radial (circular) or linear (straight)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/fill-gradient-type)
   */
  fillGradientType?: InputMaybe<ImgixParamsFillGradientType>;
  /**
   * Resize Fit Mode
   *
   * Specifies how to map the source image to the output image dimensions.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/fit)
   */
  fit?: InputMaybe<ImgixParamsFit>;
  /**
   * Flip Axis
   *
   * Flips an image on a specified axis.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/rotation/flip)
   */
  flip?: InputMaybe<ImgixParamsFlip>;
  /**
   * Output Format
   *
   * Changes the format of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/format/fm)
   */
  fm?: InputMaybe<ImgixParamsFm>;
  /**
   * Focal Point Debug
   *
   * Displays crosshairs identifying the location of the set focal point
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/focalpoint-crop/fp-debug)
   */
  fpDebug?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Focal Point X Position
   *
   * Sets the relative horizontal value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/focalpoint-crop/fp-x)
   */
  fpX?: InputMaybe<Scalars['FloatType']>;
  /**
   * Focal Point Y Position
   *
   * Sets the relative vertical value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/focalpoint-crop/fp-y)
   */
  fpY?: InputMaybe<Scalars['FloatType']>;
  /**
   * Focal Point Zoom
   *
   * Sets the relative zoom value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/focalpoint-crop/fp-z)
   */
  fpZ?: InputMaybe<Scalars['FloatType']>;
  /**
   * Frames Per Second
   *
   * Specifies the framerate of the generated image.
   */
  fps?: InputMaybe<Scalars['IntType']>;
  /**
   * Frame Selection
   *
   * Specifies the frame of an animated image to use.
   */
  frame?: InputMaybe<Scalars['String']>;
  /**
   * Gamma
   *
   * Adjusts the gamma of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/gam)
   */
  gam?: InputMaybe<Scalars['IntType']>;
  /**
   * Animated Gif Quality
   *
   * Specifies the quality of the animated gif. The higher the value, the better more compression is applied.
   *
   * Depends on: `fm=gif`
   */
  gifQ?: InputMaybe<Scalars['IntType']>;
  /**
   * Grid Colors
   *
   * Sets grid colors for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   */
  gridColors?: InputMaybe<Scalars['String']>;
  /**
   * Grid Size
   *
   * Sets grid size for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   */
  gridSize?: InputMaybe<Scalars['IntType']>;
  /**
   * Image Height
   *
   * Adjusts the height of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/h)
   */
  h?: InputMaybe<Scalars['FloatType']>;
  /**
   * Highlight
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/high)
   */
  high?: InputMaybe<Scalars['IntType']>;
  /**
   * Halftone
   *
   * Applies a half-tone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/stylize/htn)
   */
  htn?: InputMaybe<Scalars['IntType']>;
  /**
   * Hue Shift
   *
   * Adjusts the hue of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/hue)
   */
  hue?: InputMaybe<Scalars['IntType']>;
  /**
   * Frame Interval
   *
   * Displays every Nth frame starting with the first frame.
   */
  interval?: InputMaybe<Scalars['IntType']>;
  /**
   * Invert
   *
   * Inverts the colors on the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/invert)
   */
  invert?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Iptc Passthrough
   *
   * Determine if IPTC data should be passed for JPEG images.
   */
  iptc?: InputMaybe<ImgixParamsIptc>;
  /**
   * Jpg Progressive
   *
   * Specifies whether or not a jpg/jpeg uses progressive (true) or baseline (false)
   */
  jpgProgressive?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Animation Loop Count
   *
   * Specifies the number of times an animated image should repeat. A value of 0 means infinite looping.
   */
  loop?: InputMaybe<Scalars['IntType']>;
  /**
   * Lossless Compression
   *
   * Specifies that the output image should be a lossless variant.
   *
   * Depends on: `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/format/lossless)
   */
  lossless?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Watermark Image Url
   *
   * Specifies the location of the watermark image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark)
   */
  mark?: InputMaybe<Scalars['String']>;
  /**
   * Watermark Alignment Mode
   *
   * Changes the watermark alignment relative to the parent image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-align)
   */
  markAlign?: InputMaybe<Array<ImgixParamsMarkAlign>>;
  /**
   * Watermark Alpha
   *
   * Changes the alpha of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-alpha)
   */
  markAlpha?: InputMaybe<Scalars['IntType']>;
  /**
   * Watermark Base Url
   *
   * Changes base URL of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-base)
   */
  markBase?: InputMaybe<Scalars['String']>;
  /**
   * Watermark Fit Mode
   *
   * Specifies the fit mode for watermark images.
   *
   * Depends on: `mark`, `markw`, `markh`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-fit)
   */
  markFit?: InputMaybe<ImgixParamsMarkFit>;
  /**
   * Watermark Height
   *
   * Adjusts the height of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-h)
   */
  markH?: InputMaybe<Scalars['FloatType']>;
  /**
   * Watermark Padding
   *
   * Applies padding to the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-pad)
   */
  markPad?: InputMaybe<Scalars['IntType']>;
  /**
   * Watermark Rotation
   *
   * Rotates a watermark or tiled watermarks by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-rot)
   */
  markRot?: InputMaybe<Scalars['FloatType']>;
  /**
   * Watermark Scale
   *
   * Adjusts the scale of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-scale)
   */
  markScale?: InputMaybe<Scalars['IntType']>;
  /**
   * Watermark Tile
   *
   * Adds tiled watermark.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-tile)
   */
  markTile?: InputMaybe<ImgixParamsMarkTile>;
  /**
   * Watermark Width
   *
   * Adjusts the width of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-w)
   */
  markW?: InputMaybe<Scalars['FloatType']>;
  /**
   * Watermark X Position
   *
   * Adjusts the x-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-x)
   */
  markX?: InputMaybe<Scalars['IntType']>;
  /**
   * Watermark Y Position
   *
   * Adjusts the y-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/watermark/mark-y)
   */
  markY?: InputMaybe<Scalars['IntType']>;
  /**
   * Mask Type
   *
   * Defines the type of mask and specifies the URL if that type is selected.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/mask)
   */
  mask?: InputMaybe<Scalars['String']>;
  /**
   * Mask Background Color
   *
   * Colors the background of the transparent mask area of images
   *
   * Depends on: `mask`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/mask/mask-bg)
   */
  maskBg?: InputMaybe<Scalars['String']>;
  /**
   * Maximum Height
   *
   * Specifies the maximum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/max-height)
   */
  maxH?: InputMaybe<Scalars['IntType']>;
  /**
   * Maximum Width
   *
   * Specifies the maximum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/max-width)
   */
  maxW?: InputMaybe<Scalars['IntType']>;
  /**
   * Minimum Height
   *
   * Specifies the minimum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/min-height)
   */
  minH?: InputMaybe<Scalars['IntType']>;
  /**
   * Minimum Width
   *
   * Specifies the minimum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/min-width)
   */
  minW?: InputMaybe<Scalars['IntType']>;
  /**
   * Monochrome
   *
   * Applies a monochrome effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/stylize/monochrome)
   */
  monochrome?: InputMaybe<Scalars['String']>;
  /**
   * Noise Reduction Bound
   *
   * Reduces the noise in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/noise-reduction/nr)
   */
  nr?: InputMaybe<Scalars['IntType']>;
  /**
   * Noise Reduction Sharpen
   *
   * Provides a threshold by which to sharpen an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/noise-reduction/nrs)
   */
  nrs?: InputMaybe<Scalars['IntType']>;
  /**
   * Orientation
   *
   * Changes the image orientation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/rotation/orient)
   */
  orient?: InputMaybe<Scalars['IntType']>;
  /**
   * Padding
   *
   * Pads an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/pad)
   */
  pad?: InputMaybe<Scalars['IntType']>;
  /**
   * Padding Bottom
   *
   * Sets bottom padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/pad-bottom)
   */
  padBottom?: InputMaybe<Scalars['IntType']>;
  /**
   * Padding Left
   *
   * Sets left padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/pad-left)
   */
  padLeft?: InputMaybe<Scalars['IntType']>;
  /**
   * Padding Right
   *
   * Sets right padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/pad-right)
   */
  padRight?: InputMaybe<Scalars['IntType']>;
  /**
   * Padding Top
   *
   * Sets top padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/border-and-padding/pad-top)
   */
  padTop?: InputMaybe<Scalars['IntType']>;
  /**
   * Pdf Page Number
   *
   * Selects a page from a PDF for display.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/pdf/page)
   */
  page?: InputMaybe<Scalars['IntType']>;
  /**
   * Color Palette Extraction
   *
   * Specifies an output format for palette-extraction.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/color-palette/palette)
   */
  palette?: InputMaybe<ImgixParamsPalette>;
  /**
   * Pdf Annotation
   *
   * Enables or disables PDF annotation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/pdf/pdf-annotation)
   */
  pdfAnnotation?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Css Prefix
   *
   * Specifies a CSS prefix for all classes in palette-extraction.
   *
   * Depends on: `palette=css`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/color-palette/prefix)
   */
  prefix?: InputMaybe<Scalars['String']>;
  /**
   * Pixellate
   *
   * Applies a pixelation effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/stylize/px)
   */
  px?: InputMaybe<Scalars['IntType']>;
  /**
   * Output Quality
   *
   * Adjusts the quality of an output image.
   *
   * Depends on: `fm=jpg`, `fm=pjpg`, `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/format/q)
   */
  q?: InputMaybe<Scalars['IntType']>;
  /**
   * Source Rectangle Region
   *
   * Crops an image to a specified rectangle.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/rect)
   */
  rect?: InputMaybe<Scalars['String']>;
  /**
   * Reverse
   *
   * Reverses the frame order on the source animation.
   */
  reverse?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Rotation
   *
   * Rotates an image by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/rotation/rot)
   */
  rot?: InputMaybe<Scalars['FloatType']>;
  /**
   * Saturation
   *
   * Adjusts the saturation of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/sat)
   */
  sat?: InputMaybe<Scalars['IntType']>;
  /**
   * Sepia Tone
   *
   * Applies a sepia effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/stylize/sepia)
   */
  sepia?: InputMaybe<Scalars['IntType']>;
  /**
   * Shadow
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/shad)
   */
  shad?: InputMaybe<Scalars['FloatType']>;
  /**
   * Sharpen
   *
   * Adjusts the sharpness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/sharp)
   */
  sharp?: InputMaybe<Scalars['FloatType']>;
  /**
   * Frame Skip
   *
   * Skips every Nth frame starting with the first frame.
   */
  skip?: InputMaybe<Scalars['IntType']>;
  /**
   * Bypasses any [DatoCMS Automatic Image Optimization](https://www.datocms.com/docs/cdn-settings/advanced-asset-settings) that might be set up for the project.
   *
   * Exercise caution when using this parameter, as it could significantly increase your bandwidth costs.
   */
  skipDefaultOptimizations?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Sanitize Svg
   *
   * Specifies whether to sanitize an SVG.
   */
  svgSanitize?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Transparency
   *
   * Adds checkerboard behind images which support transparency.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/fill/transparency)
   */
  transparency?: InputMaybe<ImgixParamsTransparency>;
  /**
   * Trim Image
   *
   * Trims the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/trim/trim)
   */
  trim?: InputMaybe<ImgixParamsTrim>;
  /**
   * Trim Color
   *
   * Specifies a trim color on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/trim/trim-color)
   */
  trimColor?: InputMaybe<Scalars['String']>;
  /**
   * Trim Mean Difference
   *
   * Specifies the mean difference on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/trim/trim-md)
   */
  trimMd?: InputMaybe<Scalars['FloatType']>;
  /**
   * Trim Padding
   *
   * Pads the area of the source image before trimming.
   *
   * Depends on: `trim`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/trim/trim-pad)
   */
  trimPad?: InputMaybe<Scalars['IntType']>;
  /**
   * Trim Standard Deviation
   *
   * Specifies the standard deviation on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/trim/trim-sd)
   */
  trimSd?: InputMaybe<Scalars['FloatType']>;
  /**
   * Trim Tolerance
   *
   * Specifies the tolerance on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/trim/trim-tol)
   */
  trimTol?: InputMaybe<Scalars['FloatType']>;
  /**
   * Text String
   *
   * Sets the text string to render.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt)
   */
  txt?: InputMaybe<Scalars['String']>;
  /**
   * Text Align
   *
   * Sets the vertical and horizontal alignment of rendered text relative to the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-align)
   */
  txtAlign?: InputMaybe<Array<ImgixParamsTxtAlign>>;
  /**
   * Text Clipping Mode
   *
   * Sets the clipping properties of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-clip)
   */
  txtClip?: InputMaybe<Array<ImgixParamsTxtClip>>;
  /**
   * Text Color
   *
   * Specifies the color of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-color)
   */
  txtColor?: InputMaybe<Scalars['String']>;
  /**
   * Text Fit Mode
   *
   * Specifies the fit approach for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-fit)
   */
  txtFit?: InputMaybe<ImgixParamsTxtFit>;
  /**
   * Text Font
   *
   * Selects a font for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-font)
   */
  txtFont?: InputMaybe<Scalars['String']>;
  /**
   * Text Leading
   *
   * Sets the leading (line spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/typesetting/txt-lead)
   */
  txtLead?: InputMaybe<Scalars['IntType']>;
  /**
   * Text Outline
   *
   * Outlines the rendered text with a specified color.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-line)
   */
  txtLine?: InputMaybe<Scalars['IntType']>;
  /**
   * Text Outline Color
   *
   * Specifies a text outline color.
   *
   * Depends on: `txt`, `txtline`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-line-color)
   */
  txtLineColor?: InputMaybe<Scalars['String']>;
  /**
   * Text Padding
   *
   * Specifies the padding (in device-independent pixels) between a textbox and the edges of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-pad)
   */
  txtPad?: InputMaybe<Scalars['IntType']>;
  /**
   * Text Shadow
   *
   * Applies a shadow to rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-shad)
   */
  txtShad?: InputMaybe<Scalars['FloatType']>;
  /**
   * Text Font Size
   *
   * Sets the font size of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-size)
   */
  txtSize?: InputMaybe<Scalars['IntType']>;
  /**
   * Text Tracking
   *
   * Sets the tracking (letter spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/typesetting/txt-track)
   */
  txtTrack?: InputMaybe<Scalars['IntType']>;
  /**
   * Text Width
   *
   * Sets the width of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-width)
   */
  txtWidth?: InputMaybe<Scalars['IntType']>;
  /**
   * Text X Position
   *
   * Sets the horizontal (x) position of the text in pixels relative to the left edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-x)
   */
  txtX?: InputMaybe<Scalars['IntType']>;
  /**
   * Text Y Position
   *
   * Sets the vertical (y) position of the text in pixels relative to the top edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/text/txt-y)
   */
  txtY?: InputMaybe<Scalars['IntType']>;
  /**
   * Super Resolution
   *
   * Uses generative AI fill to upscale low resolution images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution/upscale)
   */
  upscale?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Super Resolution Fallback
   *
   * Overrides default fallback behavior for super resolution failures
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution/upscale-fallback)
   */
  upscaleFallback?: InputMaybe<Scalars['BooleanType']>;
  /**
   * Unsharp Mask
   *
   * Sharpens the source image using an unsharp mask.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/usm)
   */
  usm?: InputMaybe<Scalars['IntType']>;
  /**
   * Unsharp Mask Radius
   *
   * Specifies the radius for an unsharp mask operation.
   *
   * Depends on: `usm`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/usmrad)
   */
  usmrad?: InputMaybe<Scalars['FloatType']>;
  /**
   * Vibrance
   *
   * Adjusts the vibrance of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/adjustment/vib)
   */
  vib?: InputMaybe<Scalars['IntType']>;
  /**
   * Image Width
   *
   * Adjusts the width of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/url/size/w)
   */
  w?: InputMaybe<Scalars['FloatType']>;
};

export enum ImgixParamsAuto {
  compress = 'compress',
  enhance = 'enhance',
  format = 'format',
  redeye = 'redeye'
}

export enum ImgixParamsBlendAlign {
  bottom = 'bottom',
  center = 'center',
  left = 'left',
  middle = 'middle',
  right = 'right',
  top = 'top'
}

export enum ImgixParamsBlendCrop {
  bottom = 'bottom',
  faces = 'faces',
  left = 'left',
  right = 'right',
  top = 'top'
}

export enum ImgixParamsBlendFit {
  clamp = 'clamp',
  clip = 'clip',
  crop = 'crop',
  max = 'max',
  scale = 'scale'
}

export enum ImgixParamsBlendMode {
  burn = 'burn',
  color = 'color',
  darken = 'darken',
  difference = 'difference',
  dodge = 'dodge',
  exclusion = 'exclusion',
  hardlight = 'hardlight',
  hue = 'hue',
  lighten = 'lighten',
  luminosity = 'luminosity',
  multiply = 'multiply',
  normal = 'normal',
  overlay = 'overlay',
  saturation = 'saturation',
  screen = 'screen',
  softlight = 'softlight'
}

export enum ImgixParamsBlendSize {
  inherit = 'inherit'
}

export enum ImgixParamsCh {
  dpr = 'dpr',
  saveData = 'saveData',
  width = 'width'
}

export enum ImgixParamsCrop {
  bottom = 'bottom',
  edges = 'edges',
  entropy = 'entropy',
  faces = 'faces',
  focalpoint = 'focalpoint',
  left = 'left',
  right = 'right',
  top = 'top'
}

export enum ImgixParamsCs {
  adobergb1998 = 'adobergb1998',
  srgb = 'srgb',
  strip = 'strip',
  tinysrgb = 'tinysrgb'
}

export enum ImgixParamsFill {
  blur = 'blur',
  gen = 'gen',
  generative = 'generative',
  gradient = 'gradient',
  solid = 'solid'
}

export enum ImgixParamsFillGenPos {
  bottom = 'bottom',
  center = 'center',
  left = 'left',
  middle = 'middle',
  right = 'right',
  top = 'top'
}

export enum ImgixParamsFillGradientCs {
  hsl = 'hsl',
  lch = 'lch',
  linear = 'linear',
  oklab = 'oklab',
  srgb = 'srgb'
}

export enum ImgixParamsFillGradientLinearDirection {
  bottom = 'bottom',
  left = 'left',
  right = 'right',
  top = 'top'
}

export enum ImgixParamsFillGradientType {
  linear = 'linear',
  radial = 'radial'
}

export enum ImgixParamsFit {
  clamp = 'clamp',
  clip = 'clip',
  crop = 'crop',
  facearea = 'facearea',
  fill = 'fill',
  fillmax = 'fillmax',
  max = 'max',
  min = 'min',
  scale = 'scale'
}

export enum ImgixParamsFlip {
  h = 'h',
  hv = 'hv',
  v = 'v'
}

export enum ImgixParamsFm {
  avif = 'avif',
  blurhash = 'blurhash',
  gif = 'gif',
  jp2 = 'jp2',
  jpg = 'jpg',
  json = 'json',
  jxr = 'jxr',
  mp4 = 'mp4',
  pjpg = 'pjpg',
  png = 'png',
  png8 = 'png8',
  png32 = 'png32',
  webm = 'webm',
  webp = 'webp'
}

export enum ImgixParamsIptc {
  allow = 'allow',
  block = 'block'
}

export enum ImgixParamsMarkAlign {
  bottom = 'bottom',
  center = 'center',
  left = 'left',
  middle = 'middle',
  right = 'right',
  top = 'top'
}

export enum ImgixParamsMarkFit {
  clip = 'clip',
  crop = 'crop',
  fill = 'fill',
  max = 'max',
  scale = 'scale'
}

export enum ImgixParamsMarkTile {
  grid = 'grid'
}

export enum ImgixParamsPalette {
  css = 'css',
  json = 'json'
}

export enum ImgixParamsTransparency {
  grid = 'grid'
}

export enum ImgixParamsTrim {
  auto = 'auto',
  color = 'color'
}

export enum ImgixParamsTxtAlign {
  bottom = 'bottom',
  center = 'center',
  left = 'left',
  middle = 'middle',
  right = 'right',
  top = 'top'
}

export enum ImgixParamsTxtClip {
  ellipsis = 'ellipsis',
  end = 'end',
  middle = 'middle',
  start = 'start'
}

export enum ImgixParamsTxtFit {
  max = 'max'
}

/** Specifies how to filter by usage */
export type InUseFilter = {
  /** Search uploads that are currently used by some record or not */
  eq?: InputMaybe<Scalars['BooleanType']>;
};

/** Specifies how to filter Integer fields */
export type IntegerFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['IntType']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['IntType']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['IntType']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['IntType']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['IntType']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['IntType']>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenArticleAndBlogSection = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<ArticleModelFieldsReferencingBlogSectionModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<ArticleModelFieldsReferencingBlogSectionModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenBlogSectionAndArticle = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<BlogSectionModelFieldsReferencingArticleModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<BlogSectionModelFieldsReferencingArticleModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenFeaturedBlogPostComponentAndArticle = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<FeaturedBlogPostComponentModelFieldsReferencingArticleModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<FeaturedBlogPostComponentModelFieldsReferencingArticleModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenProductAndProductCategory = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<ProductModelFieldsReferencingProductCategoryModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<ProductModelFieldsReferencingProductCategoryModel>>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenArticleAndBlogSection = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenArticleAndBlogSection>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenBlogSectionAndArticle = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenBlogSectionAndArticle>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenFeaturedBlogPostComponentAndArticle = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenFeaturedBlogPostComponentAndArticle>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenProductAndProductCategory = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenProductAndProductCategory>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter by ID */
export type ItemIdFilter = {
  /** Search the record with the specified ID */
  eq?: InputMaybe<Scalars['ItemId']>;
  /** Search records with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['ItemId']>>>;
  /** Exclude the record with the specified ID */
  neq?: InputMaybe<Scalars['ItemId']>;
  /** Search records that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']>>>;
};

export enum ItemStatus {
  draft = 'draft',
  published = 'published',
  updated = 'updated'
}

/** Specifies how to filter JSON fields */
export type JsonFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
};

/** Block of type Key with Value (key_with_value) */
export type KeyWithValueRecord = RecordInterface & {
  __typename?: 'KeyWithValueRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  key?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  value?: Maybe<Scalars['String']>;
};


/** Block of type Key with Value (key_with_value) */
export type KeyWithValueRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type LandingPageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<LandingPageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LandingPageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  content?: InputMaybe<TextFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum LandingPageModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Landing Page (landing_page) */
export type LandingPageRecord = RecordInterface & {
  __typename?: 'LandingPageRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  components?: Maybe<ComponentsWrapperRecord>;
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  seo?: Maybe<SeoRecord>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Landing Page (landing_page) */
export type LandingPageRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Landing Page (landing_page) */
export type LandingPageRecordcontentArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};

export type LegalModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<LegalModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LegalModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum LegalModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Legal (legal) */
export type LegalRecord = RecordInterface & {
  __typename?: 'LegalRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  legalSection: Array<LegalSectionRecord>;
  seo?: Maybe<SeoRecord>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Legal (legal) */
export type LegalRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type LegalSectionModelContentField = {
  __typename?: 'LegalSectionModelContentField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Legal Section (legal_section) */
export type LegalSectionRecord = RecordInterface & {
  __typename?: 'LegalSectionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  content?: Maybe<LegalSectionModelContentField>;
  createdAt: Scalars['DateTime'];
  heading?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
};


/** Block of type Legal Section (legal_section) */
export type LegalSectionRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Single-link fields */
export type LinkFilter = {
  /** Search for records with an exact match. The specified value must be a Record ID */
  eq?: InputMaybe<Scalars['ItemId']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records linked to one of the specified records */
  in?: InputMaybe<Array<InputMaybe<Scalars['ItemId']>>>;
  /** Exclude records with an exact match. The specified value must be a Record ID */
  neq?: InputMaybe<Scalars['ItemId']>;
  /** Filter records not linked to one of the specified records */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']>>>;
};

/** Block of type Link (link) */
export type LinkRecord = RecordInterface & {
  __typename?: 'LinkRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};


/** Block of type Link (link) */
export type LinkRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Link With Color (link_with_color) */
export type LinkWithColorRecord = RecordInterface & {
  __typename?: 'LinkWithColorRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  color?: Maybe<ColorField>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};


/** Block of type Link With Color (link_with_color) */
export type LinkWithColorRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Linking locales */
export enum LinkingLocale {
  _nonLocalized = '_nonLocalized',
  en = 'en'
}

/** Specifies how to filter by linking locales */
export type LinkingLocalesFilter = {
  /** Filter linking records that link to current record in at least one of the specified locales */
  anyIn?: InputMaybe<Array<LinkingLocale>>;
  /** Filter linking records that do not link to current record in any of the specified locales */
  notIn?: InputMaybe<Array<LinkingLocale>>;
};

export type LinksAsCardsComponentModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<LinksAsCardsComponentModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LinksAsCardsComponentModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum LinksAsCardsComponentModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Links as Cards Component (links_as_cards_component) */
export type LinksAsCardsComponentRecord = RecordInterface & {
  __typename?: 'LinksAsCardsComponentRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  links: Array<ImageLinkWithTextRecord>;
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Links as Cards Component (links_as_cards_component) */
export type LinksAsCardsComponentRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Multiple-links fields */
export type LinksFilter = {
  /** Filter records linked to all of the specified records. The specified values must be Record IDs */
  allIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']>>>;
  /** Filter records linked to at least one of the specified records. The specified values must be Record IDs */
  anyIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']>>>;
  /** Search for records with an exact match. The specified values must be Record IDs */
  eq?: InputMaybe<Array<InputMaybe<Scalars['ItemId']>>>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records not linked to any of the specified records. The specified values must be Record IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']>>>;
};

/** Record of type Login Page (login_page) */
export type LoginPageRecord = RecordInterface & {
  __typename?: 'LoginPageRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  seo?: Maybe<SeoRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Login Page (login_page) */
export type LoginPageRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type MachineComparisonPageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<MachineComparisonPageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MachineComparisonPageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  productsToCompare?: InputMaybe<LinksFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum MachineComparisonPageModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Machine Comparison Page (machine_comparison_page) */
export type MachineComparisonPageRecord = RecordInterface & {
  __typename?: 'MachineComparisonPageRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  productsToCompare: Array<ProductRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Machine Comparison Page (machine_comparison_page) */
export type MachineComparisonPageRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Machine Comparison Data (machine_comparison) */
export type MachineComparisonRecord = RecordInterface & {
  __typename?: 'MachineComparisonRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  bottleMaterial?: Maybe<Scalars['String']>;
  compatibleBottles?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  cylinderInsertion?: Maybe<Scalars['String']>;
  dimensions?: Maybe<Scalars['String']>;
  dishwasherSafeBottles?: Maybe<Scalars['String']>;
  howItWorks?: Maybe<Scalars['String']>;
  howToFizz?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
};


/** Block of type Machine Comparison Data (machine_comparison) */
export type MachineComparisonRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type MachineModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<MachineModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MachineModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  gtin?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  name?: InputMaybe<StringFilter>;
  slug?: InputMaybe<SlugFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum MachineModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  gtin_ASC = 'gtin_ASC',
  gtin_DESC = 'gtin_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Machine (machine) */
export type MachineRecord = RecordInterface & {
  __typename?: 'MachineRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  components?: Maybe<ComponentsWrapperRecord>;
  createdAt: Scalars['DateTime'];
  gtin?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  name?: Maybe<Scalars['String']>;
  seo?: Maybe<SeoRecord>;
  slug?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Machine (machine) */
export type MachineRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Machine Registration Page (machine_registration_page) */
export type MachineRegistrationPageRecord = RecordInterface & {
  __typename?: 'MachineRegistrationPageRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  benefitsOfAccount?: Maybe<SliderWithImageAndStructuredTextRecord>;
  createdAt: Scalars['DateTime'];
  customData: Array<KeyWithValueRecord>;
  emailSubscriptionText?: Maybe<RichTextBlockRecord>;
  header?: Maybe<RichTextBlockRecord>;
  headerText?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  machineBannerBackground?: Maybe<FileField>;
  machineDetailsHeader?: Maybe<Scalars['String']>;
  machines: Array<MachineRecord>;
  machinesHeader?: Maybe<Scalars['String']>;
  purchaseLocation: Array<OptionRecord>;
  seo?: Maybe<SeoRecord>;
  subHeaderText?: Maybe<Scalars['String']>;
  termsOfServiceText?: Maybe<RichTextBlockRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Machine Registration Page (machine_registration_page) */
export type MachineRegistrationPageRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Media with Structured Text (media_with_structured_text) */
export type MediaWithStructuredTextRecord = RecordInterface & {
  __typename?: 'MediaWithStructuredTextRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  text?: Maybe<RichTextBlockRecord>;
  updatedAt: Scalars['DateTime'];
  video?: Maybe<FileField>;
};


/** Block of type Media with Structured Text (media_with_structured_text) */
export type MediaWithStructuredTextRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Media with text (media_with_text) */
export type MediaWithTextRecord = RecordInterface & {
  __typename?: 'MediaWithTextRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  header?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  media?: Maybe<FileField>;
  text?: Maybe<RichTextBlockRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Media with text (media_with_text) */
export type MediaWithTextRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Mobile Header Menu Item (mobile_header_menu_item) */
export type MobileHeaderMenuItemRecord = RecordInterface & {
  __typename?: 'MobileHeaderMenuItemRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  content: Array<HeaderImageLinkWithColorRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Mobile Header Menu Item (mobile_header_menu_item) */
export type MobileHeaderMenuItemRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type MobileHeaderModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<MobileHeaderModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MobileHeaderModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  promotionalBar?: InputMaybe<StringFilter>;
  promotionalBarBackgroundColor?: InputMaybe<ColorFilter>;
  promotionalBarLink?: InputMaybe<StringFilter>;
  promotionalBarTextColor?: InputMaybe<ColorFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum MobileHeaderModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  promotionalBarLink_ASC = 'promotionalBarLink_ASC',
  promotionalBarLink_DESC = 'promotionalBarLink_DESC',
  promotionalBar_ASC = 'promotionalBar_ASC',
  promotionalBar_DESC = 'promotionalBar_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Mobile Header (mobile_header) */
export type MobileHeaderRecord = RecordInterface & {
  __typename?: 'MobileHeaderRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  bottomMenuColoredLink: Array<LinkWithColorRecord>;
  bottomMenuLinks: Array<LinkWithColorRecord>;
  createdAt: Scalars['DateTime'];
  customHeaderLinks: Array<CustomMobileHeaderLinkRecord>;
  id: Scalars['ItemId'];
  mobileMenuCategories: Array<MobileHeaderMenuItemRecord>;
  promotionalBar?: Maybe<Scalars['String']>;
  promotionalBarBackgroundColor?: Maybe<ColorField>;
  promotionalBarLink?: Maybe<Scalars['String']>;
  promotionalBarTextColor?: Maybe<ColorField>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Mobile Header (mobile_header) */
export type MobileHeaderRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export enum MuxThumbnailFormatType {
  gif = 'gif',
  jpg = 'jpg',
  png = 'png'
}

export type NewsletterModelCompletedTextField = {
  __typename?: 'NewsletterModelCompletedTextField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type NewsletterModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<NewsletterModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NewsletterModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  analyticsElementId?: InputMaybe<StringFilter>;
  backgroundColor?: InputMaybe<ColorFilter>;
  backgroundImage?: InputMaybe<FileFilter>;
  completedText?: InputMaybe<StructuredTextFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  emailPlaceholder?: InputMaybe<StringFilter>;
  firstTerms?: InputMaybe<StructuredTextFilter>;
  header?: InputMaybe<StructuredTextFilter>;
  headerText?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  otherTerms?: InputMaybe<StructuredTextFilter>;
  secondTerms?: InputMaybe<StructuredTextFilter>;
  showFirstTermsAbove?: InputMaybe<BooleanFilter>;
  showFirstTermsCheckbox?: InputMaybe<BooleanFilter>;
  showSecondTermsAbove?: InputMaybe<BooleanFilter>;
  showSecondTermsCheckbox?: InputMaybe<BooleanFilter>;
  subscribeButtonText?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type NewsletterModelFirstTermsField = {
  __typename?: 'NewsletterModelFirstTermsField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type NewsletterModelHeaderField = {
  __typename?: 'NewsletterModelHeaderField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export enum NewsletterModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  analyticsElementId_ASC = 'analyticsElementId_ASC',
  analyticsElementId_DESC = 'analyticsElementId_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  emailPlaceholder_ASC = 'emailPlaceholder_ASC',
  emailPlaceholder_DESC = 'emailPlaceholder_DESC',
  headerText_ASC = 'headerText_ASC',
  headerText_DESC = 'headerText_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  showFirstTermsAbove_ASC = 'showFirstTermsAbove_ASC',
  showFirstTermsAbove_DESC = 'showFirstTermsAbove_DESC',
  showFirstTermsCheckbox_ASC = 'showFirstTermsCheckbox_ASC',
  showFirstTermsCheckbox_DESC = 'showFirstTermsCheckbox_DESC',
  showSecondTermsAbove_ASC = 'showSecondTermsAbove_ASC',
  showSecondTermsAbove_DESC = 'showSecondTermsAbove_DESC',
  showSecondTermsCheckbox_ASC = 'showSecondTermsCheckbox_ASC',
  showSecondTermsCheckbox_DESC = 'showSecondTermsCheckbox_DESC',
  subscribeButtonText_ASC = 'subscribeButtonText_ASC',
  subscribeButtonText_DESC = 'subscribeButtonText_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type NewsletterModelOtherTermsField = {
  __typename?: 'NewsletterModelOtherTermsField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type NewsletterModelSecondTermsField = {
  __typename?: 'NewsletterModelSecondTermsField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Record of type Newsletter (newsletter) */
export type NewsletterRecord = RecordInterface & {
  __typename?: 'NewsletterRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  analyticsElementId?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<ColorField>;
  backgroundImage?: Maybe<FileField>;
  completedText?: Maybe<NewsletterModelCompletedTextField>;
  createdAt: Scalars['DateTime'];
  customData: Array<KeyWithValueRecord>;
  emailPlaceholder?: Maybe<Scalars['String']>;
  firstTerms?: Maybe<NewsletterModelFirstTermsField>;
  header?: Maybe<NewsletterModelHeaderField>;
  headerText?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  otherTerms?: Maybe<NewsletterModelOtherTermsField>;
  secondTerms?: Maybe<NewsletterModelSecondTermsField>;
  showFirstTermsAbove?: Maybe<Scalars['BooleanType']>;
  showFirstTermsCheckbox?: Maybe<Scalars['BooleanType']>;
  showSecondTermsAbove?: Maybe<Scalars['BooleanType']>;
  showSecondTermsCheckbox?: Maybe<Scalars['BooleanType']>;
  subscribeButtonText?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Newsletter (newsletter) */
export type NewsletterRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Numeric Option (numeric_option) */
export type NumericOptionRecord = RecordInterface & {
  __typename?: 'NumericOptionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  label?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  value?: Maybe<Scalars['IntType']>;
};


/** Block of type Numeric Option (numeric_option) */
export type NumericOptionRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Numeric Select (numeric_select) */
export type NumericSelectRecord = RecordInterface & {
  __typename?: 'NumericSelectRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  options: Array<NumericOptionRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Numeric Select (numeric_select) */
export type NumericSelectRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Option (option) */
export type OptionRecord = RecordInterface & {
  __typename?: 'OptionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  label?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  value?: Maybe<Scalars['String']>;
};


/** Block of type Option (option) */
export type OptionRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by image orientation */
export type OrientationFilter = {
  /** Search uploads with the specified orientation */
  eq?: InputMaybe<UploadOrientation>;
  /** Exclude uploads with the specified orientation */
  neq?: InputMaybe<UploadOrientation>;
};

/** Record of type Page 404 (page404) */
export type Page404Record = RecordInterface & {
  __typename?: 'Page404Record';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  components?: Maybe<ComponentsWrapperRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
};


/** Record of type Page 404 (page404) */
export type Page404Record_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Page Title (page_title) */
export type PageTitleRecord = RecordInterface & {
  __typename?: 'PageTitleRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Page Title (page_title) */
export type PageTitleRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Popup Input Field (popup_input_field) */
export type PopupInputFieldRecord = RecordInterface & {
  __typename?: 'PopupInputFieldRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  inputFieldPlaceholder?: Maybe<Scalars['String']>;
  inputType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Popup Input Field (popup_input_field) */
export type PopupInputFieldRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type PopupLegalTextModelLegalTextField = {
  __typename?: 'PopupLegalTextModelLegalTextField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Popup Legal Text (popup_legal_text) */
export type PopupLegalTextRecord = RecordInterface & {
  __typename?: 'PopupLegalTextRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  legalText?: Maybe<PopupLegalTextModelLegalTextField>;
  showCheckbox?: Maybe<Scalars['BooleanType']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Popup Legal Text (popup_legal_text) */
export type PopupLegalTextRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type PopupModelDisclaimerTextField = {
  __typename?: 'PopupModelDisclaimerTextField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type PopupModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<PopupModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PopupModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  buttonText?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  disclaimerText?: InputMaybe<StructuredTextFilter>;
  heroImage?: InputMaybe<FileFilter>;
  id?: InputMaybe<ItemIdFilter>;
  imageOnLeftSide?: InputMaybe<BooleanFilter>;
  mainText?: InputMaybe<StructuredTextFilter>;
  showPopupAfter?: InputMaybe<IntegerFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  welcomeText?: InputMaybe<StructuredTextFilter>;
};

export type PopupModelMainTextField = {
  __typename?: 'PopupModelMainTextField';
  blocks: Array<PopupLegalTextRecord>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export enum PopupModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  buttonText_ASC = 'buttonText_ASC',
  buttonText_DESC = 'buttonText_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  imageOnLeftSide_ASC = 'imageOnLeftSide_ASC',
  imageOnLeftSide_DESC = 'imageOnLeftSide_DESC',
  showPopupAfter_ASC = 'showPopupAfter_ASC',
  showPopupAfter_DESC = 'showPopupAfter_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type PopupModelWelcomeTextField = {
  __typename?: 'PopupModelWelcomeTextField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Record of type Popup (popup) */
export type PopupRecord = RecordInterface & {
  __typename?: 'PopupRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  buttonText?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  disclaimerText?: Maybe<PopupModelDisclaimerTextField>;
  heroImage?: Maybe<FileField>;
  id: Scalars['ItemId'];
  imageOnLeftSide?: Maybe<Scalars['BooleanType']>;
  inputFields: Array<PopupInputFieldRecord>;
  mainText?: Maybe<PopupModelMainTextField>;
  showPopupAfter?: Maybe<Scalars['IntType']>;
  updatedAt: Scalars['DateTime'];
  welcomeText?: Maybe<PopupModelWelcomeTextField>;
};


/** Record of type Popup (popup) */
export type PopupRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by position (sorted and tree-like collections) */
export type PositionFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['IntType']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['IntType']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['IntType']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['IntType']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['IntType']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['IntType']>;
};

export type ProductBundleModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductBundleModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductBundleModelFilter>>>;
  bundleId?: InputMaybe<StringFilter>;
  bundleImage?: InputMaybe<FileFilter>;
  id?: InputMaybe<ItemIdFilter>;
  lowestPriceText?: InputMaybe<StringFilter>;
  price?: InputMaybe<FloatFilter>;
  title?: InputMaybe<StringFilter>;
};

/** Block of type Product Bundle (product_bundle) */
export type ProductBundleRecord = RecordInterface & {
  __typename?: 'ProductBundleRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  bundleId?: Maybe<Scalars['String']>;
  bundleImage?: Maybe<FileField>;
  bundleItems: Array<BundleItemRecord>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<TextDescriptionRecord>;
  id: Scalars['ItemId'];
  lowestPriceText?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['FloatType']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Product Bundle (product_bundle) */
export type ProductBundleRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ProductCartPromoModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductCartPromoModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductCartPromoModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  text?: InputMaybe<StringFilter>;
  textColor?: InputMaybe<ColorFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ProductCartPromoModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  text_ASC = 'text_ASC',
  text_DESC = 'text_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Product Cart Promo (product_cart_promo) */
export type ProductCartPromoRecord = RecordInterface & {
  __typename?: 'ProductCartPromoRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  text?: Maybe<Scalars['String']>;
  textColor?: Maybe<ColorField>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Product Cart Promo (product_cart_promo) */
export type ProductCartPromoRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ProductCategoryModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductCategoryModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductCategoryModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _stage?: InputMaybe<RegularWorkflowWorkflowStageFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  analyticsCategoryName?: InputMaybe<StringFilter>;
  analyticsName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  hero?: InputMaybe<LinkFilter>;
  heroImage?: InputMaybe<FileFilter>;
  heroImageMobile?: InputMaybe<FileFilter>;
  heroText?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  plpItemBackgroundColor?: InputMaybe<ColorFilter>;
  showCompatibleMachinesFilter?: InputMaybe<BooleanFilter>;
  slug?: InputMaybe<SlugFilter>;
  style?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ProductCategoryModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  analyticsCategoryName_ASC = 'analyticsCategoryName_ASC',
  analyticsCategoryName_DESC = 'analyticsCategoryName_DESC',
  analyticsName_ASC = 'analyticsName_ASC',
  analyticsName_DESC = 'analyticsName_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  heroText_ASC = 'heroText_ASC',
  heroText_DESC = 'heroText_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  showCompatibleMachinesFilter_ASC = 'showCompatibleMachinesFilter_ASC',
  showCompatibleMachinesFilter_DESC = 'showCompatibleMachinesFilter_DESC',
  style_ASC = 'style_ASC',
  style_DESC = 'style_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Product Category (product_category) */
export type ProductCategoryRecord = RecordInterface & {
  __typename?: 'ProductCategoryRecord';
  _allReferencingProducts: Array<ProductRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingProductsMeta: CollectionMetadata;
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _stage: RegularWorkflowWorkflowStage;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  analyticsCategoryName?: Maybe<Scalars['String']>;
  analyticsName?: Maybe<Scalars['String']>;
  components?: Maybe<ComponentsWrapperRecord>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  hero?: Maybe<HomepageHeroComponentRecord>;
  heroImage?: Maybe<FileField>;
  heroImageMobile?: Maybe<FileField>;
  heroText?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  itemButton?: Maybe<BottonLinkWithColorRecord>;
  plpItemBackgroundColor?: Maybe<ColorField>;
  promotionalCard?: Maybe<PromotionalCardRecord>;
  seo?: Maybe<SeoRecord>;
  showCompatibleMachinesFilter?: Maybe<Scalars['BooleanType']>;
  slug?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Product Category (product_category) */
export type ProductCategoryRecord_allReferencingProductsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ProductModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenProductAndProductCategory>;
};


/** Record of type Product Category (product_category) */
export type ProductCategoryRecord_allReferencingProductsMetaArgs = {
  filter?: InputMaybe<ProductModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenProductAndProductCategory>;
};


/** Record of type Product Category (product_category) */
export type ProductCategoryRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Product Feed (product_feed) */
export type ProductFeedRecord = RecordInterface & {
  __typename?: 'ProductFeedRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  gtin?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  lifestyleImage?: Maybe<FileField>;
  productType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Product Feed (product_feed) */
export type ProductFeedRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ProductLabelModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductLabelModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductLabelModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  label?: InputMaybe<StringFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ProductLabelModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Product Label (product_label) */
export type ProductLabelRecord = RecordInterface & {
  __typename?: 'ProductLabelRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  label?: Maybe<Scalars['String']>;
  seo?: Maybe<SeoField>;
  slug?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Product Label (product_label) */
export type ProductLabelRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ProductListComponentModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductListComponentModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductListComponentModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  products?: InputMaybe<LinksFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ProductListComponentModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Product List Component (product_list_component) */
export type ProductListComponentRecord = RecordInterface & {
  __typename?: 'ProductListComponentRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  products: Array<ProductRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Product List Component (product_list_component) */
export type ProductListComponentRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specify nested blocks fields conditions */
export type ProductModelCylinderTypesFieldBlocksConditions = {
  cylinderType?: InputMaybe<CylinderTypeModelFilter>;
};

/** Specify nested blocks types presence */
export type ProductModelCylinderTypesFieldBlocksPresence = {
  cylinderType?: InputMaybe<Scalars['BooleanType']>;
};

/** Specify how to filter this specific Modular Content field instance */
export type ProductModelCylinderTypesFieldFilter = {
  /** Filter records containing at least one block matching the specified conditions */
  any?: InputMaybe<ProductModelCylinderTypesFieldBlocksConditions>;
  /** Filter records containing at least one block of specified type or not */
  containsAny?: InputMaybe<ProductModelCylinderTypesFieldBlocksPresence>;
  /** Filter records containing at least one block of any kind or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
};

/** Linking fields */
export enum ProductModelFieldsReferencingProductCategoryModel {
  product_category = 'product_category'
}

export type ProductModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _stage?: InputMaybe<RegularWorkflowWorkflowStageFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  aboveTitlePromo?: InputMaybe<LinkFilter>;
  analyticsColorName?: InputMaybe<StringFilter>;
  belowTitlePromo?: InputMaybe<LinkFilter>;
  bundleTag?: InputMaybe<StringFilter>;
  category?: InputMaybe<LinkFilter>;
  color?: InputMaybe<ColorFilter>;
  colorVariants?: InputMaybe<LinksFilter>;
  compatibleMachines?: InputMaybe<LinksFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  cylinderMinFreeShippingQuantity?: InputMaybe<IntegerFilter>;
  cylinderSelectionInfo?: InputMaybe<StringFilter>;
  cylinderTypes?: InputMaybe<ProductModelCylinderTypesFieldFilter>;
  groupTitle?: InputMaybe<StringFilter>;
  gtin?: InputMaybe<StringFilter>;
  heroDescription?: InputMaybe<TextFilter>;
  heroImage?: InputMaybe<FileFilter>;
  heroTitle?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  labels?: InputMaybe<LinksFilter>;
  lowestPriceText?: InputMaybe<StringFilter>;
  plpThumbnail?: InputMaybe<FileFilter>;
  position?: InputMaybe<PositionFilter>;
  product3dModel?: InputMaybe<FileFilter>;
  product3dPoster?: InputMaybe<FileFilter>;
  productBundles?: InputMaybe<ProductModelProductBundlesFieldFilter>;
  productContent?: InputMaybe<StructuredTextFilter>;
  productImages?: InputMaybe<GalleryFilter>;
  returnPolicy?: InputMaybe<LinkFilter>;
  shortDescription?: InputMaybe<StringFilter>;
  slug?: InputMaybe<SlugFilter>;
  tags?: InputMaybe<LinksFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ProductModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  analyticsColorName_ASC = 'analyticsColorName_ASC',
  analyticsColorName_DESC = 'analyticsColorName_DESC',
  bundleTag_ASC = 'bundleTag_ASC',
  bundleTag_DESC = 'bundleTag_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  cylinderMinFreeShippingQuantity_ASC = 'cylinderMinFreeShippingQuantity_ASC',
  cylinderMinFreeShippingQuantity_DESC = 'cylinderMinFreeShippingQuantity_DESC',
  cylinderSelectionInfo_ASC = 'cylinderSelectionInfo_ASC',
  cylinderSelectionInfo_DESC = 'cylinderSelectionInfo_DESC',
  groupTitle_ASC = 'groupTitle_ASC',
  groupTitle_DESC = 'groupTitle_DESC',
  gtin_ASC = 'gtin_ASC',
  gtin_DESC = 'gtin_DESC',
  heroTitle_ASC = 'heroTitle_ASC',
  heroTitle_DESC = 'heroTitle_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  lowestPriceText_ASC = 'lowestPriceText_ASC',
  lowestPriceText_DESC = 'lowestPriceText_DESC',
  position_ASC = 'position_ASC',
  position_DESC = 'position_DESC',
  shortDescription_ASC = 'shortDescription_ASC',
  shortDescription_DESC = 'shortDescription_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Specify nested blocks fields conditions */
export type ProductModelProductBundlesFieldBlocksConditions = {
  productBundle?: InputMaybe<ProductBundleModelFilter>;
};

/** Specify nested blocks types presence */
export type ProductModelProductBundlesFieldBlocksPresence = {
  productBundle?: InputMaybe<Scalars['BooleanType']>;
};

/** Specify how to filter this specific Modular Content field instance */
export type ProductModelProductBundlesFieldFilter = {
  /** Filter records containing at least one block matching the specified conditions */
  any?: InputMaybe<ProductModelProductBundlesFieldBlocksConditions>;
  /** Filter records containing at least one block of specified type or not */
  containsAny?: InputMaybe<ProductModelProductBundlesFieldBlocksPresence>;
  /** Filter records containing at least one block of any kind or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
};

export type ProductModelProductContentField = {
  __typename?: 'ProductModelProductContentField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type ProductNutritionModelIngredientsField = {
  __typename?: 'ProductNutritionModelIngredientsField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Product Nutrition (product_nutrition) */
export type ProductNutritionRecord = RecordInterface & {
  __typename?: 'ProductNutritionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  ingredients?: Maybe<ProductNutritionModelIngredientsField>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Product Nutrition (product_nutrition) */
export type ProductNutritionRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Product (product) */
export type ProductRecord = RecordInterface & {
  __typename?: 'ProductRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _stage: RegularWorkflowWorkflowStage;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  aboveTitlePromo?: Maybe<ProductCartPromoRecord>;
  analyticsColorName?: Maybe<Scalars['String']>;
  belowTitlePromo?: Maybe<ProductCartPromoRecord>;
  bundleTag?: Maybe<Scalars['String']>;
  category?: Maybe<ProductCategoryRecord>;
  color?: Maybe<ColorField>;
  colorVariants: Array<ProductRecord>;
  comparisonData?: Maybe<MachineComparisonRecord>;
  compatibleMachines: Array<ProductRecord>;
  components?: Maybe<ComponentsWrapperRecord>;
  createdAt: Scalars['DateTime'];
  cylinderFrequencyOptions: Array<CylinderFrequencyOptionRecord>;
  cylinderMinFreeShippingQuantity?: Maybe<Scalars['IntType']>;
  cylinderQuantityOptions: Array<CylinderQuantityOptionRecord>;
  cylinderSelectionInfo?: Maybe<Scalars['String']>;
  cylinderTypes: Array<CylinderTypeRecord>;
  extraCylinderInfo?: Maybe<ExtraCylinderRecord>;
  faq?: Maybe<FaqRecord>;
  groupTitle?: Maybe<Scalars['String']>;
  gtin?: Maybe<Scalars['String']>;
  heroDescription?: Maybe<Scalars['String']>;
  heroImage?: Maybe<FileField>;
  heroTitle?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  labels: Array<ProductLabelRecord>;
  lowestPriceText?: Maybe<Scalars['String']>;
  nutrition?: Maybe<ProductNutritionRecord>;
  plpThumbnail?: Maybe<FileField>;
  position?: Maybe<Scalars['IntType']>;
  product3dModel?: Maybe<FileField>;
  product3dPoster?: Maybe<FileField>;
  productBenefits: Array<IconWithImageRecord>;
  productBundles: Array<ProductBundleRecord>;
  productContent?: Maybe<ProductModelProductContentField>;
  productFeed?: Maybe<ProductFeedRecord>;
  productImages: Array<FileField>;
  returnPolicy?: Maybe<ReturnPolicyRecord>;
  seo?: Maybe<SeoRecord>;
  shortDescription?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  tags: Array<ProductTagRecord>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Product (product) */
export type ProductRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Product (product) */
export type ProductRecordheroDescriptionArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};

export type ProductTagModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductTagModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTagModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  backgroundColor?: InputMaybe<ColorFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  tag?: InputMaybe<StringFilter>;
  textColor?: InputMaybe<ColorFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ProductTagModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  tag_ASC = 'tag_ASC',
  tag_DESC = 'tag_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Product Tag (product_tag) */
export type ProductTagRecord = RecordInterface & {
  __typename?: 'ProductTagRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundColor?: Maybe<ColorField>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  tag?: Maybe<Scalars['String']>;
  textColor?: Maybe<ColorField>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Product Tag (product_tag) */
export type ProductTagRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ProductsSliderComponentModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductsSliderComponentModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductsSliderComponentModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  backgroundColor?: InputMaybe<ColorFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  header?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  products?: InputMaybe<LinksFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ProductsSliderComponentModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  header_ASC = 'header_ASC',
  header_DESC = 'header_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Products Slider Component (products_slider_component) */
export type ProductsSliderComponentRecord = RecordInterface & {
  __typename?: 'ProductsSliderComponentRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundColor?: Maybe<ColorField>;
  createdAt: Scalars['DateTime'];
  header?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  products: Array<ProductRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Products Slider Component (products_slider_component) */
export type ProductsSliderComponentRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Promotional Card (promotional_card) */
export type PromotionalCardRecord = RecordInterface & {
  __typename?: 'PromotionalCardRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  button?: Maybe<ButtonWithPositionRecord>;
  cardPosition?: Maybe<Scalars['IntType']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  text?: Maybe<StructuredTextWithPositionRecord>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};


/** Block of type Promotional Card (promotional_card) */
export type PromotionalCardRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by publication datetime */
export type PublishedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']>;
};

/** Block of type Purchase Locations (purchases_location) */
export type PurchasesLocationRecord = RecordInterface & {
  __typename?: 'PurchasesLocationRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  purchaseLocation?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Purchase Locations (purchases_location) */
export type PurchasesLocationRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** The query root for this schema */
export type Query = {
  __typename?: 'Query';
  /** Returns meta information regarding a record collection */
  _allArticlesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allBigTilesComponentsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allBlogSectionsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allCollectionPagesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allColumnContentComponentsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allExternalVideosMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allFaqComponentsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allFeaturedBlogPostComponentsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allHeroImageComponentsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allHomepageHeroComponentsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allLandingPagesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allLegalsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allLinksAsCardsComponentsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allMachineComparisonPagesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allMachinesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allMobileHeadersMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allNewslettersMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allPopupsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allProductCartPromosMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allProductCategoriesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allProductLabelsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allProductListComponentsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allProductTagsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allProductsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allProductsSliderComponentsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allReturnPoliciesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allRichTextComponentsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allSmallTilesComponentsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allSplitContentComponentsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allSplitHeroComponentsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allTabsComponentsMeta: CollectionMetadata;
  /** Returns meta information regarding an assets collection */
  _allUploadsMeta: CollectionMetadata;
  /** Returns the single instance record */
  _site: Site;
  /** Returns a collection of records */
  allArticles: Array<ArticleRecord>;
  /** Returns a collection of records */
  allBigTilesComponents: Array<BigTilesComponentRecord>;
  /** Returns a collection of records */
  allBlogSections: Array<BlogSectionRecord>;
  /** Returns a collection of records */
  allCollectionPages: Array<CollectionPageRecord>;
  /** Returns a collection of records */
  allColumnContentComponents: Array<ColumnContentComponentRecord>;
  /** Returns a collection of records */
  allExternalVideos: Array<ExternalVideoRecord>;
  /** Returns a collection of records */
  allFaqComponents: Array<FaqComponentRecord>;
  /** Returns a collection of records */
  allFeaturedBlogPostComponents: Array<FeaturedBlogPostComponentRecord>;
  /** Returns a collection of records */
  allHeroImageComponents: Array<HeroImageComponentRecord>;
  /** Returns a collection of records */
  allHomepageHeroComponents: Array<HomepageHeroComponentRecord>;
  /** Returns a collection of records */
  allLandingPages: Array<LandingPageRecord>;
  /** Returns a collection of records */
  allLegals: Array<LegalRecord>;
  /** Returns a collection of records */
  allLinksAsCardsComponents: Array<LinksAsCardsComponentRecord>;
  /** Returns a collection of records */
  allMachineComparisonPages: Array<MachineComparisonPageRecord>;
  /** Returns a collection of records */
  allMachines: Array<MachineRecord>;
  /** Returns a collection of records */
  allMobileHeaders: Array<MobileHeaderRecord>;
  /** Returns a collection of records */
  allNewsletters: Array<NewsletterRecord>;
  /** Returns a collection of records */
  allPopups: Array<PopupRecord>;
  /** Returns a collection of records */
  allProductCartPromos: Array<ProductCartPromoRecord>;
  /** Returns a collection of records */
  allProductCategories: Array<ProductCategoryRecord>;
  /** Returns a collection of records */
  allProductLabels: Array<ProductLabelRecord>;
  /** Returns a collection of records */
  allProductListComponents: Array<ProductListComponentRecord>;
  /** Returns a collection of records */
  allProductTags: Array<ProductTagRecord>;
  /** Returns a collection of records */
  allProducts: Array<ProductRecord>;
  /** Returns a collection of records */
  allProductsSliderComponents: Array<ProductsSliderComponentRecord>;
  /** Returns a collection of records */
  allReturnPolicies: Array<ReturnPolicyRecord>;
  /** Returns a collection of records */
  allRichTextComponents: Array<RichTextComponentRecord>;
  /** Returns a collection of records */
  allSmallTilesComponents: Array<SmallTilesComponentRecord>;
  /** Returns a collection of records */
  allSplitContentComponents: Array<SplitContentComponentRecord>;
  /** Returns a collection of records */
  allSplitHeroComponents: Array<SplitHeroComponentRecord>;
  /** Returns a collection of records */
  allTabsComponents: Array<TabsComponentRecord>;
  /** Returns a collection of assets */
  allUploads: Array<FileField>;
  /** Returns a specific record */
  article?: Maybe<ArticleRecord>;
  /** Returns a specific record */
  bigTilesComponent?: Maybe<BigTilesComponentRecord>;
  /** Returns the single instance record */
  blogPage?: Maybe<BlogPageRecord>;
  /** Returns a specific record */
  blogSection?: Maybe<BlogSectionRecord>;
  /** Returns the single instance record */
  cartPage?: Maybe<CartPageRecord>;
  /** Returns a specific record */
  collectionPage?: Maybe<CollectionPageRecord>;
  /** Returns a specific record */
  columnContentComponent?: Maybe<ColumnContentComponentRecord>;
  /** Returns the single instance record */
  desktopHeader?: Maybe<DesktopHeaderRecord>;
  /** Returns a specific record */
  externalVideo?: Maybe<ExternalVideoRecord>;
  /** Returns a specific record */
  faqComponent?: Maybe<FaqComponentRecord>;
  /** Returns a specific record */
  featuredBlogPostComponent?: Maybe<FeaturedBlogPostComponentRecord>;
  /** Returns the single instance record */
  footer?: Maybe<FooterRecord>;
  /** Returns the single instance record */
  gasExchangePage?: Maybe<GasExchangePageRecord>;
  /** Returns a specific record */
  heroImageComponent?: Maybe<HeroImageComponentRecord>;
  /** Returns the single instance record */
  homePage?: Maybe<HomePageRecord>;
  /** Returns the single instance record */
  homepageHero?: Maybe<HomepageHeroRecord>;
  /** Returns a specific record */
  homepageHeroComponent?: Maybe<HomepageHeroComponentRecord>;
  /** Returns a specific record */
  landingPage?: Maybe<LandingPageRecord>;
  /** Returns a specific record */
  legal?: Maybe<LegalRecord>;
  /** Returns a specific record */
  linksAsCardsComponent?: Maybe<LinksAsCardsComponentRecord>;
  /** Returns the single instance record */
  loginPage?: Maybe<LoginPageRecord>;
  /** Returns a specific record */
  machine?: Maybe<MachineRecord>;
  /** Returns a specific record */
  machineComparisonPage?: Maybe<MachineComparisonPageRecord>;
  /** Returns the single instance record */
  machineRegistrationPage?: Maybe<MachineRegistrationPageRecord>;
  /** Returns a specific record */
  mobileHeader?: Maybe<MobileHeaderRecord>;
  /** Returns a specific record */
  newsletter?: Maybe<NewsletterRecord>;
  /** Returns the single instance record */
  page404?: Maybe<Page404Record>;
  /** Returns a specific record */
  popup?: Maybe<PopupRecord>;
  /** Returns a specific record */
  product?: Maybe<ProductRecord>;
  /** Returns a specific record */
  productCartPromo?: Maybe<ProductCartPromoRecord>;
  /** Returns a specific record */
  productCategory?: Maybe<ProductCategoryRecord>;
  /** Returns a specific record */
  productLabel?: Maybe<ProductLabelRecord>;
  /** Returns a specific record */
  productListComponent?: Maybe<ProductListComponentRecord>;
  /** Returns a specific record */
  productTag?: Maybe<ProductTagRecord>;
  /** Returns a specific record */
  productsSliderComponent?: Maybe<ProductsSliderComponentRecord>;
  /** Returns the single instance record */
  registerPage?: Maybe<RegisterPageRecord>;
  /** Returns a specific record */
  returnPolicy?: Maybe<ReturnPolicyRecord>;
  /** Returns a specific record */
  richTextComponent?: Maybe<RichTextComponentRecord>;
  /** Returns a specific record */
  smallTilesComponent?: Maybe<SmallTilesComponentRecord>;
  /** Returns the single instance record */
  socialShareConfiguration?: Maybe<SocialShareConfigurationRecord>;
  /** Returns a specific record */
  splitContentComponent?: Maybe<SplitContentComponentRecord>;
  /** Returns a specific record */
  splitHeroComponent?: Maybe<SplitHeroComponentRecord>;
  /** Returns a specific record */
  tabsComponent?: Maybe<TabsComponentRecord>;
  /** Returns the single instance record */
  translation?: Maybe<TranslationRecord>;
  /** Returns a specific asset */
  upload?: Maybe<FileField>;
};


/** The query root for this schema */
export type Query_allArticlesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ArticleModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allBigTilesComponentsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BigTilesComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allBlogSectionsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BlogSectionModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allCollectionPagesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CollectionPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allColumnContentComponentsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ColumnContentComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allExternalVideosMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ExternalVideoModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allFaqComponentsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FaqComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allFeaturedBlogPostComponentsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FeaturedBlogPostComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allHeroImageComponentsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<HeroImageComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allHomepageHeroComponentsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<HomepageHeroComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allLandingPagesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<LandingPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allLegalsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<LegalModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allLinksAsCardsComponentsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<LinksAsCardsComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allMachineComparisonPagesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<MachineComparisonPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allMachinesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<MachineModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allMobileHeadersMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<MobileHeaderModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allNewslettersMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<NewsletterModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allPopupsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PopupModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allProductCartPromosMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductCartPromoModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allProductCategoriesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductCategoryModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allProductLabelsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductLabelModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allProductListComponentsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductListComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allProductTagsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductTagModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allProductsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allProductsSliderComponentsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductsSliderComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allReturnPoliciesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ReturnPolicyModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allRichTextComponentsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<RichTextComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allSmallTilesComponentsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SmallTilesComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allSplitContentComponentsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SplitContentComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allSplitHeroComponentsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SplitHeroComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allTabsComponentsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<TabsComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_allUploadsMetaArgs = {
  filter?: InputMaybe<UploadFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_siteArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryallArticlesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ArticleModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ArticleModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallBigTilesComponentsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BigTilesComponentModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BigTilesComponentModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallBlogSectionsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BlogSectionModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BlogSectionModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallCollectionPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CollectionPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CollectionPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallColumnContentComponentsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ColumnContentComponentModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ColumnContentComponentModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallExternalVideosArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ExternalVideoModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ExternalVideoModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallFaqComponentsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FaqComponentModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FaqComponentModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallFeaturedBlogPostComponentsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FeaturedBlogPostComponentModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FeaturedBlogPostComponentModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallHeroImageComponentsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<HeroImageComponentModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<HeroImageComponentModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallHomepageHeroComponentsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<HomepageHeroComponentModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<HomepageHeroComponentModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallLandingPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<LandingPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<LandingPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallLegalsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<LegalModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<LegalModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallLinksAsCardsComponentsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<LinksAsCardsComponentModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<LinksAsCardsComponentModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallMachineComparisonPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<MachineComparisonPageModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<MachineComparisonPageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallMachinesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<MachineModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<MachineModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallMobileHeadersArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<MobileHeaderModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<MobileHeaderModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallNewslettersArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<NewsletterModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<NewsletterModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallPopupsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PopupModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PopupModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallProductCartPromosArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductCartPromoModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ProductCartPromoModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallProductCategoriesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductCategoryModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ProductCategoryModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallProductLabelsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductLabelModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ProductLabelModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallProductListComponentsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductListComponentModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ProductListComponentModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallProductTagsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductTagModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ProductTagModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallProductsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ProductModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallProductsSliderComponentsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductsSliderComponentModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ProductsSliderComponentModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallReturnPoliciesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ReturnPolicyModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ReturnPolicyModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallRichTextComponentsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<RichTextComponentModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<RichTextComponentModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallSmallTilesComponentsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SmallTilesComponentModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SmallTilesComponentModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallSplitContentComponentsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SplitContentComponentModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SplitContentComponentModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallSplitHeroComponentsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SplitHeroComponentModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SplitHeroComponentModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallTabsComponentsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<TabsComponentModelFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<TabsComponentModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryallUploadsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<UploadFilter>;
  first?: InputMaybe<Scalars['IntType']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<UploadOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']>;
};


/** The query root for this schema */
export type QueryarticleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ArticleModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ArticleModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerybigTilesComponentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BigTilesComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BigTilesComponentModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryblogPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryblogSectionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BlogSectionModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BlogSectionModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerycartPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QuerycollectionPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CollectionPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CollectionPageModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerycolumnContentComponentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ColumnContentComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ColumnContentComponentModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerydesktopHeaderArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryexternalVideoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ExternalVideoModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ExternalVideoModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryfaqComponentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FaqComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FaqComponentModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryfeaturedBlogPostComponentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FeaturedBlogPostComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FeaturedBlogPostComponentModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryfooterArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QuerygasExchangePageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryheroImageComponentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<HeroImageComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<HeroImageComponentModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryhomePageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryhomepageHeroArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryhomepageHeroComponentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<HomepageHeroComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<HomepageHeroComponentModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerylandingPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<LandingPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<LandingPageModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerylegalArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<LegalModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<LegalModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerylinksAsCardsComponentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<LinksAsCardsComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<LinksAsCardsComponentModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryloginPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QuerymachineArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<MachineModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<MachineModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerymachineComparisonPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<MachineComparisonPageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<MachineComparisonPageModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerymachineRegistrationPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QuerymobileHeaderArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<MobileHeaderModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<MobileHeaderModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerynewsletterArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<NewsletterModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<NewsletterModelOrderBy>>>;
};


/** The query root for this schema */
export type Querypage404Args = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QuerypopupArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PopupModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PopupModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryproductArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ProductModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryproductCartPromoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductCartPromoModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ProductCartPromoModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryproductCategoryArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductCategoryModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ProductCategoryModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryproductLabelArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductLabelModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ProductLabelModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryproductListComponentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductListComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ProductListComponentModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryproductTagArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductTagModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ProductTagModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryproductsSliderComponentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ProductsSliderComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ProductsSliderComponentModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryregisterPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryreturnPolicyArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ReturnPolicyModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ReturnPolicyModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryrichTextComponentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<RichTextComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<RichTextComponentModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerysmallTilesComponentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SmallTilesComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SmallTilesComponentModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerysocialShareConfigurationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QuerysplitContentComponentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SplitContentComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SplitContentComponentModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerysplitHeroComponentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SplitHeroComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SplitHeroComponentModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerytabsComponentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<TabsComponentModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<TabsComponentModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerytranslationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryuploadArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<UploadFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<UploadOrderBy>>>;
};

/** Block of type Quick Links Block (quick_links_block) */
export type QuickLinksBlockRecord = RecordInterface & {
  __typename?: 'QuickLinksBlockRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  links: Array<ImageLinkWithTextRecord>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Quick Links Block (quick_links_block) */
export type QuickLinksBlockRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type RecordInterface = {
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
};


export type RecordInterface_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Register Page (register_page) */
export type RegisterPageRecord = RecordInterface & {
  __typename?: 'RegisterPageRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  seo?: Maybe<SeoRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Register Page (register_page) */
export type RegisterPageRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export enum RegularWorkflowWorkflowStage {
  workInProgress = 'workInProgress'
}

/** Specifies how to filter by stage */
export type RegularWorkflowWorkflowStageFilter = {
  /** Search the record with the specified stage */
  eq?: InputMaybe<RegularWorkflowWorkflowStage>;
  /** Search records with the specified stagees */
  in?: InputMaybe<Array<RegularWorkflowWorkflowStage>>;
  /** Exclude the record with the specified stage */
  neq?: InputMaybe<RegularWorkflowWorkflowStage>;
  /** Search records without the specified stagees */
  notIn?: InputMaybe<Array<RegularWorkflowWorkflowStage>>;
};

/** Specifies how to filter by upload type */
export type ResolutionFilter = {
  /** Search uploads with the specified resolution */
  eq?: InputMaybe<ResolutionType>;
  /** Search uploads with the specified resolutions */
  in?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
  /** Exclude uploads with the specified resolution */
  neq?: InputMaybe<ResolutionType>;
  /** Search uploads without the specified resolutions */
  notIn?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
};

export enum ResolutionType {
  icon = 'icon',
  large = 'large',
  medium = 'medium',
  small = 'small'
}

export type ResponsiveImage = {
  __typename?: 'ResponsiveImage';
  alt?: Maybe<Scalars['String']>;
  aspectRatio: Scalars['FloatType'];
  base64?: Maybe<Scalars['String']>;
  bgColor?: Maybe<Scalars['String']>;
  height: Scalars['IntType'];
  sizes: Scalars['String'];
  src: Scalars['String'];
  srcSet: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  webpSrcSet: Scalars['String'];
  width: Scalars['IntType'];
};

export type ReturnPolicyModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ReturnPolicyModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ReturnPolicyModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  policy?: InputMaybe<StructuredTextFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ReturnPolicyModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ReturnPolicyModelPolicyField = {
  __typename?: 'ReturnPolicyModelPolicyField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Record of type Return Policy (return_policy) */
export type ReturnPolicyRecord = RecordInterface & {
  __typename?: 'ReturnPolicyRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  policy?: Maybe<ReturnPolicyModelPolicyField>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Return Policy (return_policy) */
export type ReturnPolicyRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type RichTextBlockModelTextContentField = {
  __typename?: 'RichTextBlockModelTextContentField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Rich Text Block (rich_text_block) */
export type RichTextBlockRecord = RecordInterface & {
  __typename?: 'RichTextBlockRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundColor?: Maybe<ColorField>;
  createdAt: Scalars['DateTime'];
  headingTextSize?: Maybe<Scalars['IntType']>;
  id: Scalars['ItemId'];
  textColor?: Maybe<ColorField>;
  textContent?: Maybe<RichTextBlockModelTextContentField>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Rich Text Block (rich_text_block) */
export type RichTextBlockRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type RichTextComponentModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<RichTextComponentModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<RichTextComponentModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  backgroundColor?: InputMaybe<ColorFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  headingTextSize?: InputMaybe<IntegerFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  textColor?: InputMaybe<ColorFilter>;
  textContent?: InputMaybe<StructuredTextFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum RichTextComponentModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  headingTextSize_ASC = 'headingTextSize_ASC',
  headingTextSize_DESC = 'headingTextSize_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type RichTextComponentModelTextContentField = {
  __typename?: 'RichTextComponentModelTextContentField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Record of type Rich Text Component (rich_text_component) */
export type RichTextComponentRecord = RecordInterface & {
  __typename?: 'RichTextComponentRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundColor?: Maybe<ColorField>;
  createdAt: Scalars['DateTime'];
  headingTextSize?: Maybe<Scalars['IntType']>;
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  textColor?: Maybe<ColorField>;
  textContent?: Maybe<RichTextComponentModelTextContentField>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Rich Text Component (rich_text_component) */
export type RichTextComponentRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type SeoField = {
  __typename?: 'SeoField';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<FileField>;
  noIndex?: Maybe<Scalars['BooleanType']>;
  title?: Maybe<Scalars['String']>;
  twitterCard?: Maybe<Scalars['String']>;
};

/** Specifies how to filter SEO meta tags fields */
export type SeoFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
};

/** Block of type Seo Generator (seo_generator) */
export type SeoGeneratorRecord = RecordInterface & {
  __typename?: 'SeoGeneratorRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  mainSeoFields?: Maybe<SeoField>;
  robots?: Maybe<Scalars['JsonField']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Seo Generator (seo_generator) */
export type SeoGeneratorRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type SEO (seo) */
export type SeoRecord = RecordInterface & {
  __typename?: 'SeoRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  seo?: Maybe<SeoField>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type SEO (seo) */
export type SeoRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type Site = {
  __typename?: 'Site';
  favicon?: Maybe<FileField>;
  faviconMetaTags: Array<Tag>;
  globalSeo?: Maybe<GlobalSeoField>;
  locales: Array<SiteLocale>;
  noIndex?: Maybe<Scalars['BooleanType']>;
};


export type SitefaviconMetaTagsArgs = {
  variants?: InputMaybe<Array<InputMaybe<FaviconType>>>;
};


export type SiteglobalSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export enum SiteLocale {
  en = 'en'
}

/** Block of type Slider with Image and Strucured Text (slider_with_image_and_structured_text) */
export type SliderWithImageAndStructuredTextRecord = RecordInterface & {
  __typename?: 'SliderWithImageAndStructuredTextRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  header?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  slides: Array<MediaWithStructuredTextRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Slider with Image and Strucured Text (slider_with_image_and_structured_text) */
export type SliderWithImageAndStructuredTextRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Slug fields */
export type SlugFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']>;
  /** Filter records that have one of the specified slugs */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']>;
  /** Filter records that do have one of the specified slugs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Block of type Small Tile (small_tile) */
export type SmallTileRecord = RecordInterface & {
  __typename?: 'SmallTileRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  analyticsType?: Maybe<Scalars['String']>;
  bodyText?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  header?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  linkText?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Small Tile (small_tile) */
export type SmallTileRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Block of type Small Tile (small_tile) */
export type SmallTileRecordbodyTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};

/** Block of type Small Tile Section (small_tile_section) */
export type SmallTileSectionRecord = RecordInterface & {
  __typename?: 'SmallTileSectionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  smallTiles: Array<SmallTileRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Small Tile Section (small_tile_section) */
export type SmallTileSectionRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type SmallTilesComponentModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<SmallTilesComponentModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SmallTilesComponentModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  backgroundColor?: InputMaybe<ColorFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum SmallTilesComponentModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Small Tiles Component (small_tiles_component) */
export type SmallTilesComponentRecord = RecordInterface & {
  __typename?: 'SmallTilesComponentRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundColor?: Maybe<ColorField>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  smallTiles: Array<SmallTileRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Small Tiles Component (small_tiles_component) */
export type SmallTilesComponentRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Social Share Configuration (social_share_configuration) */
export type SocialShareConfigurationRecord = RecordInterface & {
  __typename?: 'SocialShareConfigurationRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _stage: RegularWorkflowWorkflowStage;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  facebookShare?: Maybe<Scalars['BooleanType']>;
  id: Scalars['ItemId'];
  linkedinShare?: Maybe<Scalars['BooleanType']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Social Share Configuration (social_share_configuration) */
export type SocialShareConfigurationRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type SplitContentBlockModelContentField = SplitContentImageRecord | SplitContentTextRecord;

/** Block of type Split Content Block (split_content_block) */
export type SplitContentBlockRecord = RecordInterface & {
  __typename?: 'SplitContentBlockRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundColor?: Maybe<ColorField>;
  content: Array<SplitContentBlockModelContentField>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
};


/** Block of type Split Content Block (split_content_block) */
export type SplitContentBlockRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type SplitContentComponentModelContentField = SplitContentImageRecord | SplitContentTextRecord;

export type SplitContentComponentModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<SplitContentComponentModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SplitContentComponentModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  backgroundColor?: InputMaybe<ColorFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  showSecondBlockFirstOnMobile?: InputMaybe<BooleanFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum SplitContentComponentModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  showSecondBlockFirstOnMobile_ASC = 'showSecondBlockFirstOnMobile_ASC',
  showSecondBlockFirstOnMobile_DESC = 'showSecondBlockFirstOnMobile_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Split Content Component (split_content_component) */
export type SplitContentComponentRecord = RecordInterface & {
  __typename?: 'SplitContentComponentRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundColor?: Maybe<ColorField>;
  content: Array<SplitContentComponentModelContentField>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  showSecondBlockFirstOnMobile?: Maybe<Scalars['BooleanType']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Split Content Component (split_content_component) */
export type SplitContentComponentRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Split Content Image (split_content_image) */
export type SplitContentImageRecord = RecordInterface & {
  __typename?: 'SplitContentImageRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  button?: Maybe<ButtonWithPositionRecord>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Split Content Image (split_content_image) */
export type SplitContentImageRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Split Content Text (split_content_text) */
export type SplitContentTextRecord = RecordInterface & {
  __typename?: 'SplitContentTextRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  button?: Maybe<ButtonWithPositionRecord>;
  buttonBeforeText?: Maybe<Scalars['BooleanType']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  textContent?: Maybe<RichTextBlockRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Split Content Text (split_content_text) */
export type SplitContentTextRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type SplitHeroComponentModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<SplitHeroComponentModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SplitHeroComponentModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  backgroundColor?: InputMaybe<ColorFilter>;
  bodyText?: InputMaybe<TextFilter>;
  bodyTextColor?: InputMaybe<ColorFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  header?: InputMaybe<StringFilter>;
  headerColor?: InputMaybe<ColorFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  name?: InputMaybe<StringFilter>;
  options?: InputMaybe<JsonFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum SplitHeroComponentModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  header_ASC = 'header_ASC',
  header_DESC = 'header_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Split Hero Component (split_hero_component) */
export type SplitHeroComponentRecord = RecordInterface & {
  __typename?: 'SplitHeroComponentRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  backgroundColor?: Maybe<ColorField>;
  bodyText?: Maybe<Scalars['String']>;
  bodyTextColor?: Maybe<ColorField>;
  createdAt: Scalars['DateTime'];
  header?: Maybe<Scalars['String']>;
  headerColor?: Maybe<ColorField>;
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['JsonField']>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Split Hero Component (split_hero_component) */
export type SplitHeroComponentRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Split Hero Component (split_hero_component) */
export type SplitHeroComponentRecordbodyTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};

/** Block of type Split Hero (split_hero) */
export type SplitHeroRecord = RecordInterface & {
  __typename?: 'SplitHeroRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  bodyText?: Maybe<Scalars['String']>;
  bodyTextColor?: Maybe<ColorField>;
  createdAt: Scalars['DateTime'];
  header?: Maybe<Scalars['String']>;
  headerColor?: Maybe<ColorField>;
  id: Scalars['ItemId'];
  image?: Maybe<FileField>;
  options?: Maybe<Scalars['JsonField']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Split Hero (split_hero) */
export type SplitHeroRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Block of type Split Hero (split_hero) */
export type SplitHeroRecordbodyTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};

/** Specifies how to filter by status */
export type StatusFilter = {
  /** Search the record with the specified status */
  eq?: InputMaybe<ItemStatus>;
  /** Search records with the specified statuses */
  in?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
  /** Exclude the record with the specified status */
  neq?: InputMaybe<ItemStatus>;
  /** Search records without the specified statuses */
  notIn?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
};

/** Specifies how to filter Single-line string fields */
export type StringFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']>;
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records that equal one of the specified values */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter records with the specified field set as blank (null or empty string) */
  isBlank?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']>;
  /** Filter records that do not equal one of the specified values */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type StringMatchesFilter = {
  caseSensitive?: InputMaybe<Scalars['BooleanType']>;
  pattern: Scalars['String'];
  regexp?: InputMaybe<Scalars['BooleanType']>;
};

/** Specifies how to filter Structured Text fields values */
export type StructuredTextFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with the specified field set as blank (null or single empty paragraph) */
  isBlank?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type StructuredTextWithPositionModelTextField = {
  __typename?: 'StructuredTextWithPositionModelTextField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Block of type Structured Text With Position (structured_text_with_position) */
export type StructuredTextWithPositionRecord = RecordInterface & {
  __typename?: 'StructuredTextWithPositionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  color?: Maybe<ColorField>;
  createdAt: Scalars['DateTime'];
  horizontalPosition?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  text?: Maybe<StructuredTextWithPositionModelTextField>;
  updatedAt: Scalars['DateTime'];
  verticalPosition?: Maybe<Scalars['String']>;
};


/** Block of type Structured Text With Position (structured_text_with_position) */
export type StructuredTextWithPositionRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type TabItemModelTabComponentsField = BigTilesComponentRecord | ColumnContentComponentRecord | ExternalVideoRecord | FaqComponentRecord | FeaturedBlogPostComponentRecord | HeroImageComponentRecord | HomepageHeroComponentRecord | LinksAsCardsComponentRecord | ProductsSliderComponentRecord | RichTextComponentRecord | SmallTilesComponentRecord | SplitContentComponentRecord | SplitHeroComponentRecord;

/** Block of type Tab Item (tab_item) */
export type TabItemRecord = RecordInterface & {
  __typename?: 'TabItemRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  tabComponents?: Maybe<TabItemModelTabComponentsField>;
  tabTitle?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Tab Item (tab_item) */
export type TabItemRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type TabsComponentModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<TabsComponentModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TabsComponentModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum TabsComponentModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Tabs Component (tabs_component) */
export type TabsComponentRecord = RecordInterface & {
  __typename?: 'TabsComponentRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  name?: Maybe<Scalars['String']>;
  tabs: Array<TabItemRecord>;
  updatedAt: Scalars['DateTime'];
};


/** Record of type Tabs Component (tabs_component) */
export type TabsComponentRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type Tag = {
  __typename?: 'Tag';
  attributes?: Maybe<Scalars['MetaTagAttributes']>;
  content?: Maybe<Scalars['String']>;
  tag: Scalars['String'];
};

/** Block of type Text Description (text_description) */
export type TextDescriptionRecord = RecordInterface & {
  __typename?: 'TextDescriptionRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  header?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/** Block of type Text Description (text_description) */
export type TextDescriptionRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter text fields */
export type TextFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with the specified field set as blank (null or empty string) */
  isBlank?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type TranslationModelMachineComparisonTitleField = {
  __typename?: 'TranslationModelMachineComparisonTitleField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type TranslationModelUseAtLeast1SpecialCharacterField = {
  __typename?: 'TranslationModelUseAtLeast1SpecialCharacterField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type TranslationModelUseAtLeast1UppercaseAnd1LowercaseLetterField = {
  __typename?: 'TranslationModelUseAtLeast1UppercaseAnd1LowercaseLetterField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type TranslationModelUseAtLeast2NumbersField = {
  __typename?: 'TranslationModelUseAtLeast2NumbersField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

export type TranslationModelUseAtLeast8CharactersField = {
  __typename?: 'TranslationModelUseAtLeast8CharactersField';
  blocks: Array<Scalars['String']>;
  links: Array<Scalars['String']>;
  value: Scalars['JsonField'];
};

/** Record of type Translation (translation) */
export type TranslationRecord = RecordInterface & {
  __typename?: 'TranslationRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  addAnExtraCylinder?: Maybe<Scalars['String']>;
  addAnExtraCylinderToMyOrderFor?: Maybe<Scalars['String']>;
  addToCart?: Maybe<Scalars['String']>;
  addToCartFor?: Maybe<Scalars['String']>;
  added?: Maybe<Scalars['String']>;
  ageDisclaimerSubtext?: Maybe<Scalars['String']>;
  all?: Maybe<Scalars['String']>;
  amountUntilFreeShipping?: Maybe<Scalars['String']>;
  blog?: Maybe<Scalars['String']>;
  bottleCompatibleWithTheFollowing?: Maybe<Scalars['String']>;
  bottleMaterialText?: Maybe<Scalars['String']>;
  calculatedAtCheckout?: Maybe<Scalars['String']>;
  cartDiscountWarning?: Maybe<Scalars['String']>;
  cartEmpty?: Maybe<Scalars['String']>;
  checkout?: Maybe<Scalars['String']>;
  checkoutWith?: Maybe<Scalars['String']>;
  chooseYourPack?: Maybe<Scalars['String']>;
  co2TermsText?: Maybe<Scalars['String']>;
  colors?: Maybe<Scalars['String']>;
  comingSoon?: Maybe<Scalars['String']>;
  compareTo?: Maybe<Scalars['String']>;
  compatibleBottlesText?: Maybe<Scalars['String']>;
  compatibleMachinesFilterContainerHeading?: Maybe<Scalars['String']>;
  compatibleMachinesFilterEmptyFilterText?: Maybe<Scalars['String']>;
  compatibleMachinesFilterFilledFilterText?: Maybe<Scalars['String']>;
  compatibleMachinesFilterMainHeading?: Maybe<Scalars['String']>;
  compatibleWithAllAlternativeBrandSparklingWaterMakers?: Maybe<Scalars['String']>;
  completeYourRegistration?: Maybe<Scalars['String']>;
  continue?: Maybe<Scalars['String']>;
  createAPassword?: Maybe<Scalars['String']>;
  createPasswordPlaceholder?: Maybe<Scalars['String']>;
  createYourAccount?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  cylinder?: Maybe<Scalars['String']>;
  cylinderAddXItemsMoreForFreeShipping?: Maybe<Scalars['String']>;
  cylinderCompatibleWithTheFollowing?: Maybe<Scalars['String']>;
  cylinderFreeShippingUnlocked?: Maybe<Scalars['String']>;
  cylinderInsertionText?: Maybe<Scalars['String']>;
  cylinders?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  dateOfPurchase?: Maybe<Scalars['String']>;
  delivery?: Maybe<Scalars['String']>;
  dimensionsText?: Maybe<Scalars['String']>;
  dishwasherSafeBottlesText?: Maybe<Scalars['String']>;
  doesBottleFitMachine?: Maybe<Scalars['String']>;
  each?: Maybe<Scalars['String']>;
  edit?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  emailAddressPlaceholder?: Maybe<Scalars['String']>;
  emailIsRequired?: Maybe<Scalars['String']>;
  exchangeYourCylindersText?: Maybe<Scalars['String']>;
  filterBy?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  firstNameIsRequired?: Maybe<Scalars['String']>;
  firstNamePlaceholder?: Maybe<Scalars['String']>;
  for?: Maybe<Scalars['String']>;
  free?: Maybe<Scalars['String']>;
  freeShipping?: Maybe<Scalars['String']>;
  gotIt?: Maybe<Scalars['String']>;
  grandTotal?: Maybe<Scalars['String']>;
  homepage?: Maybe<Scalars['String']>;
  homepagePopup?: Maybe<Scalars['String']>;
  howItWorksText?: Maybe<Scalars['String']>;
  howManyDoYouNeed?: Maybe<Scalars['String']>;
  howToFizzText?: Maybe<Scalars['String']>;
  iAlreadyHaveAnAccount?: Maybe<Scalars['String']>;
  id: Scalars['ItemId'];
  ingredients?: Maybe<Scalars['String']>;
  invalidEmail?: Maybe<Scalars['String']>;
  invalidPassword?: Maybe<Scalars['String']>;
  invalidPurchaseDate?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lastNameIsRequired?: Maybe<Scalars['String']>;
  lastNamePlaceholder?: Maybe<Scalars['String']>;
  linkConfirmationSubtext?: Maybe<Scalars['String']>;
  machineComparisonTitle?: Maybe<TranslationModelMachineComparisonTitleField>;
  machineIsRequired?: Maybe<Scalars['String']>;
  month?: Maybe<Scalars['String']>;
  months?: Maybe<Scalars['String']>;
  nutritionInformation?: Maybe<Scalars['String']>;
  orderQuantity?: Maybe<Scalars['String']>;
  orderSummary?: Maybe<Scalars['String']>;
  ordering?: Maybe<Scalars['String']>;
  outOfStockError?: Maybe<Scalars['String']>;
  pack?: Maybe<Scalars['String']>;
  page404?: Maybe<ErrorPageRecord>;
  page500?: Maybe<ErrorPageRecord>;
  passwordIsRequired?: Maybe<Scalars['String']>;
  placeOfPurchase?: Maybe<Scalars['String']>;
  pleaseSelectACylinder?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  purchaseDate2Years?: Maybe<Scalars['String']>;
  purchaseDateIsRequired?: Maybe<Scalars['String']>;
  purchasePlaceIsRequired?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['String']>;
  quantityUpdatedWarning?: Maybe<Scalars['String']>;
  quickLinks?: Maybe<Scalars['String']>;
  quickconnectFeatureText?: Maybe<Scalars['String']>;
  remove?: Maybe<Scalars['String']>;
  removed?: Maybe<Scalars['String']>;
  returnEmptyCylinder?: Maybe<Scalars['String']>;
  review?: Maybe<Scalars['String']>;
  selectCylinderType?: Maybe<Scalars['String']>;
  selectLocationPlaceholder?: Maybe<Scalars['String']>;
  selectOrderQuantity?: Maybe<Scalars['String']>;
  selectYourColor?: Maybe<Scalars['String']>;
  shareThisArticle?: Maybe<Scalars['String']>;
  shipping?: Maybe<Scalars['String']>;
  shopNow?: Maybe<Scalars['String']>;
  showLess?: Maybe<Scalars['String']>;
  showMore?: Maybe<Scalars['String']>;
  sparklingWaterMaker?: Maybe<Scalars['String']>;
  startShopping?: Maybe<Scalars['String']>;
  startingAt?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['String']>;
  taxes?: Maybe<Scalars['String']>;
  termsAreRequired?: Maybe<Scalars['String']>;
  thankYouNewsletter?: Maybe<Scalars['String']>;
  thanksForRegisteringMachine?: Maybe<Scalars['String']>;
  unknownError?: Maybe<Scalars['String']>;
  unknownRegistrationError?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  useAtLeast1SpecialCharacter?: Maybe<TranslationModelUseAtLeast1SpecialCharacterField>;
  useAtLeast1UppercaseAnd1LowercaseLetter?: Maybe<TranslationModelUseAtLeast1UppercaseAnd1LowercaseLetterField>;
  useAtLeast2Numbers?: Maybe<TranslationModelUseAtLeast2NumbersField>;
  useAtLeast8Characters?: Maybe<TranslationModelUseAtLeast8CharactersField>;
  validDateRequired?: Maybe<Scalars['String']>;
  viewArticle?: Maybe<Scalars['String']>;
  viewCompatibility?: Maybe<Scalars['String']>;
  weSuggestEveryCustomerHaveAtLeast?: Maybe<Scalars['String']>;
  whichCylinderDoINeed?: Maybe<Scalars['String']>;
  youAreRegisteringYour?: Maybe<Scalars['String']>;
  youSelected?: Maybe<Scalars['String']>;
  yourCart?: Maybe<Scalars['String']>;
};


/** Record of type Translation (translation) */
export type TranslationRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Translation (translation) */
export type TranslationRecordco2TermsTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};


/** Record of type Translation (translation) */
export type TranslationRecordquickconnectFeatureTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']>;
};

/** Specifies how to filter by upload type */
export type TypeFilter = {
  /** Search uploads with the specified type */
  eq?: InputMaybe<UploadType>;
  /** Search uploads with the specified types */
  in?: InputMaybe<Array<InputMaybe<UploadType>>>;
  /** Exclude uploads with the specified type */
  neq?: InputMaybe<UploadType>;
  /** Search uploads without the specified types */
  notIn?: InputMaybe<Array<InputMaybe<UploadType>>>;
};

/** Specifies how to filter by update datetime */
export type UpdatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']>;
};

/** Specifies how to filter by default alt */
export type UploadAltFilter = {
  /** Search the uploads with the specified alt */
  eq?: InputMaybe<Scalars['String']>;
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Search uploads with the specified values as default alt */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the uploads with the specified alt */
  neq?: InputMaybe<Scalars['String']>;
  /** Search uploads that do not have the specified values as default alt */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by auhtor */
export type UploadAuthorFilter = {
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by basename */
export type UploadBasenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by colors */
export type UploadColorsFilter = {
  /** Filter uploads that have all of the specified colors */
  allIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have at least one of the specified colors */
  anyIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have the specified colors */
  contains?: InputMaybe<ColorBucketType>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that do not have any of the specified colors */
  notIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
};

/** Specifies how to filter by copyright */
export type UploadCopyrightFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by creation datetime */
export type UploadCreatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']>;
};

/** Specifies how to filter by filename */
export type UploadFilenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type UploadFilter = {
  AND?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  _createdAt?: InputMaybe<UploadCreatedAtFilter>;
  _updatedAt?: InputMaybe<UploadUpdatedAtFilter>;
  alt?: InputMaybe<UploadAltFilter>;
  author?: InputMaybe<UploadAuthorFilter>;
  basename?: InputMaybe<UploadBasenameFilter>;
  colors?: InputMaybe<UploadColorsFilter>;
  copyright?: InputMaybe<UploadCopyrightFilter>;
  filename?: InputMaybe<UploadFilenameFilter>;
  format?: InputMaybe<UploadFormatFilter>;
  height?: InputMaybe<UploadHeightFilter>;
  id?: InputMaybe<UploadIdFilter>;
  inUse?: InputMaybe<InUseFilter>;
  md5?: InputMaybe<UploadMd5Filter>;
  mimeType?: InputMaybe<UploadMimeTypeFilter>;
  notes?: InputMaybe<UploadNotesFilter>;
  orientation?: InputMaybe<OrientationFilter>;
  resolution?: InputMaybe<ResolutionFilter>;
  size?: InputMaybe<UploadSizeFilter>;
  smartTags?: InputMaybe<UploadTagsFilter>;
  tags?: InputMaybe<UploadTagsFilter>;
  title?: InputMaybe<UploadTitleFilter>;
  type?: InputMaybe<TypeFilter>;
  width?: InputMaybe<UploadWidthFilter>;
};

/** Specifies how to filter by format */
export type UploadFormatFilter = {
  /** Search the asset with the specified format */
  eq?: InputMaybe<Scalars['String']>;
  /** Search assets with the specified formats */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude the asset with the specified format */
  neq?: InputMaybe<Scalars['String']>;
  /** Search assets that do not have the specified formats */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Specifies how to filter by height */
export type UploadHeightFilter = {
  /** Search assets with the specified height */
  eq?: InputMaybe<Scalars['IntType']>;
  /** Search all assets larger than the specified height */
  gt?: InputMaybe<Scalars['IntType']>;
  /** Search all assets larger or equal to the specified height */
  gte?: InputMaybe<Scalars['IntType']>;
  /** Search all assets smaller than the specified height */
  lt?: InputMaybe<Scalars['IntType']>;
  /** Search all assets larger or equal to the specified height */
  lte?: InputMaybe<Scalars['IntType']>;
  /** Search assets that do not have the specified height */
  neq?: InputMaybe<Scalars['IntType']>;
};

/** Specifies how to filter by ID */
export type UploadIdFilter = {
  /** Search the asset with the specified ID */
  eq?: InputMaybe<Scalars['UploadId']>;
  /** Search assets with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['UploadId']>>>;
  /** Exclude the asset with the specified ID */
  neq?: InputMaybe<Scalars['UploadId']>;
  /** Search assets that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']>>>;
};

/** Specifies how to filter by MD5 */
export type UploadMd5Filter = {
  /** Search the asset with the specified MD5 */
  eq?: InputMaybe<Scalars['String']>;
  /** Search assets with the specified MD5s */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude the asset with the specified MD5 */
  neq?: InputMaybe<Scalars['String']>;
  /** Search assets that do not have the specified MD5s */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Specifies how to filter by mime type */
export type UploadMimeTypeFilter = {
  /** Search the asset with the specified mime type */
  eq?: InputMaybe<Scalars['String']>;
  /** Search assets with the specified mime types */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified mime type */
  neq?: InputMaybe<Scalars['String']>;
  /** Search assets that do not have the specified mime types */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by notes */
export type UploadNotesFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export enum UploadOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  basename_ASC = 'basename_ASC',
  basename_DESC = 'basename_DESC',
  filename_ASC = 'filename_ASC',
  filename_DESC = 'filename_DESC',
  format_ASC = 'format_ASC',
  format_DESC = 'format_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  mimeType_ASC = 'mimeType_ASC',
  mimeType_DESC = 'mimeType_DESC',
  resolution_ASC = 'resolution_ASC',
  resolution_DESC = 'resolution_DESC',
  size_ASC = 'size_ASC',
  size_DESC = 'size_DESC'
}

export enum UploadOrientation {
  landscape = 'landscape',
  portrait = 'portrait',
  square = 'square'
}

/** Specifies how to filter by size */
export type UploadSizeFilter = {
  /** Search assets with the specified size (in bytes) */
  eq?: InputMaybe<Scalars['IntType']>;
  /** Search all assets larger than the specified size (in bytes) */
  gt?: InputMaybe<Scalars['IntType']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  gte?: InputMaybe<Scalars['IntType']>;
  /** Search all assets smaller than the specified size (in bytes) */
  lt?: InputMaybe<Scalars['IntType']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  lte?: InputMaybe<Scalars['IntType']>;
  /** Search assets that do not have the specified size (in bytes) */
  neq?: InputMaybe<Scalars['IntType']>;
};

/** Specifies how to filter by tags */
export type UploadTagsFilter = {
  /** Filter uploads linked to all of the specified tags */
  allIn?: InputMaybe<Array<Scalars['String']>>;
  /** Filter uploads linked to at least one of the specified tags */
  anyIn?: InputMaybe<Array<Scalars['String']>>;
  /** Filter uploads linked to the specified tag */
  contains?: InputMaybe<Scalars['String']>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<Scalars['String']>>;
  /** Filter uploads not linked to any of the specified tags */
  notIn?: InputMaybe<Array<Scalars['String']>>;
};

/** Specifies how to filter by default title */
export type UploadTitleFilter = {
  /** Search the asset with the specified title */
  eq?: InputMaybe<Scalars['String']>;
  /** Filter assets with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
  /** Search assets with the specified as default title */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified title */
  neq?: InputMaybe<Scalars['String']>;
  /** Search assets that do not have the specified as default title */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export enum UploadType {
  archive = 'archive',
  audio = 'audio',
  image = 'image',
  pdfdocument = 'pdfdocument',
  presentation = 'presentation',
  richtext = 'richtext',
  spreadsheet = 'spreadsheet',
  video = 'video'
}

/** Specifies how to filter by update datetime */
export type UploadUpdatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']>;
};

export type UploadVideoField = {
  __typename?: 'UploadVideoField';
  alt?: Maybe<Scalars['String']>;
  blurUpThumb?: Maybe<Scalars['String']>;
  blurhash?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  framerate?: Maybe<Scalars['Int']>;
  height: Scalars['IntType'];
  mp4Url?: Maybe<Scalars['String']>;
  muxAssetId: Scalars['String'];
  muxPlaybackId: Scalars['String'];
  streamingUrl: Scalars['String'];
  thumbhash?: Maybe<Scalars['String']>;
  thumbnailUrl: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  width: Scalars['IntType'];
};


export type UploadVideoFieldaltArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type UploadVideoFieldblurUpThumbArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
  punch?: Scalars['Float'];
  quality?: Scalars['Int'];
  size?: Scalars['Int'];
};


export type UploadVideoFieldmp4UrlArgs = {
  exactRes?: InputMaybe<VideoMp4Res>;
  res?: InputMaybe<VideoMp4Res>;
};


export type UploadVideoFieldthumbnailUrlArgs = {
  format?: InputMaybe<MuxThumbnailFormatType>;
};


export type UploadVideoFieldtitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by width */
export type UploadWidthFilter = {
  /** Search assets with the specified width */
  eq?: InputMaybe<Scalars['IntType']>;
  /** Search all assets larger than the specified width */
  gt?: InputMaybe<Scalars['IntType']>;
  /** Search all assets larger or equal to the specified width */
  gte?: InputMaybe<Scalars['IntType']>;
  /** Search all assets smaller than the specified width */
  lt?: InputMaybe<Scalars['IntType']>;
  /** Search all assets larger or equal to the specified width */
  lte?: InputMaybe<Scalars['IntType']>;
  /** Search assets that do not have the specified width */
  neq?: InputMaybe<Scalars['IntType']>;
};

export type VideoField = {
  __typename?: 'VideoField';
  height: Scalars['IntType'];
  provider: Scalars['String'];
  providerUid: Scalars['String'];
  thumbnailUrl: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
  width: Scalars['IntType'];
};

/** Specifies how to filter Video fields */
export type VideoFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']>;
};

export enum VideoMp4Res {
  high = 'high',
  low = 'low',
  medium = 'medium'
}

/** Block of type Video (video) */
export type VideoRecord = RecordInterface & {
  __typename?: 'VideoRecord';
  _createdAt: Scalars['DateTime'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']>;
  _firstPublishedAt?: Maybe<Scalars['DateTime']>;
  _isValid: Scalars['BooleanType'];
  _modelApiKey: Scalars['String'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']>;
  _publishedAt?: Maybe<Scalars['DateTime']>;
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']>;
  _updatedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ItemId'];
  updatedAt: Scalars['DateTime'];
  video?: Maybe<FileField>;
};


/** Block of type Video (video) */
export type VideoRecord_seoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type focalPoint = {
  __typename?: 'focalPoint';
  x: Scalars['FloatType'];
  y: Scalars['FloatType'];
};

export type ArticlesBySectionQueryVariables = Exact<{
  sectionId?: InputMaybe<Scalars['ItemId']>;
  skip?: InputMaybe<Scalars['IntType']>;
  first?: InputMaybe<Scalars['IntType']>;
}>;


export type ArticlesBySectionQuery = { __typename?: 'Query', allArticles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, _allArticlesMeta: { __typename?: 'CollectionMetadata', count: any } };

export type BigTilesComponentFragment = { __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined };

export type BlogPageQueryVariables = Exact<{ [key: string]: never; }>;


export type BlogPageQuery = { __typename?: 'Query', blogPage?: { __typename?: 'BlogPageRecord', pageTitle?: string | null | undefined, topNewsletter?: { __typename: 'NewsletterRecord', id: any, emailPlaceholder?: string | null | undefined, showFirstTermsCheckbox?: any | null | undefined, showSecondTermsCheckbox?: any | null | undefined, subscribeButtonText?: string | null | undefined, showFirstTermsAbove?: any | null | undefined, showSecondTermsAbove?: any | null | undefined, headerText?: string | null | undefined, analyticsElementId?: string | null | undefined, newsletterHeader?: { __typename?: 'NewsletterModelHeaderField', value: any } | null | undefined, firstTerms?: { __typename?: 'NewsletterModelFirstTermsField', value: any } | null | undefined, secondTerms?: { __typename?: 'NewsletterModelSecondTermsField', value: any } | null | undefined, otherTerms?: { __typename?: 'NewsletterModelOtherTermsField', value: any } | null | undefined, completedText?: { __typename?: 'NewsletterModelCompletedTextField', value: any } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }>, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, bodyNewsletter?: { __typename: 'NewsletterRecord', id: any, emailPlaceholder?: string | null | undefined, showFirstTermsCheckbox?: any | null | undefined, showSecondTermsCheckbox?: any | null | undefined, subscribeButtonText?: string | null | undefined, showFirstTermsAbove?: any | null | undefined, showSecondTermsAbove?: any | null | undefined, headerText?: string | null | undefined, analyticsElementId?: string | null | undefined, newsletterHeader?: { __typename?: 'NewsletterModelHeaderField', value: any } | null | undefined, firstTerms?: { __typename?: 'NewsletterModelFirstTermsField', value: any } | null | undefined, secondTerms?: { __typename?: 'NewsletterModelSecondTermsField', value: any } | null | undefined, otherTerms?: { __typename?: 'NewsletterModelOtherTermsField', value: any } | null | undefined, completedText?: { __typename?: 'NewsletterModelCompletedTextField', value: any } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }>, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, components?: { __typename?: 'ComponentsWrapperRecord', components: Array<{ __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'NewsletterRecord', id: any, emailPlaceholder?: string | null | undefined, showFirstTermsCheckbox?: any | null | undefined, showSecondTermsCheckbox?: any | null | undefined, subscribeButtonText?: string | null | undefined, showFirstTermsAbove?: any | null | undefined, showSecondTermsAbove?: any | null | undefined, headerText?: string | null | undefined, analyticsElementId?: string | null | undefined, newsletterHeader?: { __typename?: 'NewsletterModelHeaderField', value: any } | null | undefined, firstTerms?: { __typename?: 'NewsletterModelFirstTermsField', value: any } | null | undefined, secondTerms?: { __typename?: 'NewsletterModelSecondTermsField', value: any } | null | undefined, otherTerms?: { __typename?: 'NewsletterModelOtherTermsField', value: any } | null | undefined, completedText?: { __typename?: 'NewsletterModelCompletedTextField', value: any } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }>, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ProductListComponentRecord', id: any, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, groupTitle?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', slug?: string | null | undefined, analyticsColorName?: string | null | undefined, title?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'ProductTagRecord', id: any, tag?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined }>, labels: Array<{ __typename?: 'ProductLabelRecord', label?: string | null | undefined, slug?: string | null | undefined, id: any }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, analyticsCategoryName?: string | null | undefined, analyticsName?: string | null | undefined } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'TabsComponentRecord', id: any, tabs: Array<{ __typename?: 'TabItemRecord', id: any, tabTitle?: string | null | undefined, tabComponents?: { __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> }> } | null | undefined, seo?: { __typename?: 'SeoRecord', seoMeta: Array<{ __typename?: 'Tag', attributes?: any | null | undefined, content?: string | null | undefined, tag: string }> } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined } | null | undefined };

export type CategoryComponentsBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type CategoryComponentsBySlugQuery = { __typename?: 'Query', productCategory?: { __typename?: 'ProductCategoryRecord', id: any, components?: { __typename?: 'ComponentsWrapperRecord', components: Array<{ __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'NewsletterRecord', id: any, emailPlaceholder?: string | null | undefined, showFirstTermsCheckbox?: any | null | undefined, showSecondTermsCheckbox?: any | null | undefined, subscribeButtonText?: string | null | undefined, showFirstTermsAbove?: any | null | undefined, showSecondTermsAbove?: any | null | undefined, headerText?: string | null | undefined, analyticsElementId?: string | null | undefined, newsletterHeader?: { __typename?: 'NewsletterModelHeaderField', value: any } | null | undefined, firstTerms?: { __typename?: 'NewsletterModelFirstTermsField', value: any } | null | undefined, secondTerms?: { __typename?: 'NewsletterModelSecondTermsField', value: any } | null | undefined, otherTerms?: { __typename?: 'NewsletterModelOtherTermsField', value: any } | null | undefined, completedText?: { __typename?: 'NewsletterModelCompletedTextField', value: any } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }>, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ProductListComponentRecord', id: any, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, groupTitle?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', slug?: string | null | undefined, analyticsColorName?: string | null | undefined, title?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'ProductTagRecord', id: any, tag?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined }>, labels: Array<{ __typename?: 'ProductLabelRecord', label?: string | null | undefined, slug?: string | null | undefined, id: any }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, analyticsCategoryName?: string | null | undefined, analyticsName?: string | null | undefined } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'TabsComponentRecord', id: any, tabs: Array<{ __typename?: 'TabItemRecord', id: any, tabTitle?: string | null | undefined, tabComponents?: { __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> }> } | null | undefined } | null | undefined };

export type CollectionPageBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type CollectionPageBySlugQuery = { __typename?: 'Query', collectionPage?: { __typename?: 'CollectionPageRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, components?: { __typename?: 'ComponentsWrapperRecord', components: Array<{ __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'NewsletterRecord', id: any, emailPlaceholder?: string | null | undefined, showFirstTermsCheckbox?: any | null | undefined, showSecondTermsCheckbox?: any | null | undefined, subscribeButtonText?: string | null | undefined, showFirstTermsAbove?: any | null | undefined, showSecondTermsAbove?: any | null | undefined, headerText?: string | null | undefined, analyticsElementId?: string | null | undefined, newsletterHeader?: { __typename?: 'NewsletterModelHeaderField', value: any } | null | undefined, firstTerms?: { __typename?: 'NewsletterModelFirstTermsField', value: any } | null | undefined, secondTerms?: { __typename?: 'NewsletterModelSecondTermsField', value: any } | null | undefined, otherTerms?: { __typename?: 'NewsletterModelOtherTermsField', value: any } | null | undefined, completedText?: { __typename?: 'NewsletterModelCompletedTextField', value: any } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }>, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ProductListComponentRecord', id: any, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, groupTitle?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', slug?: string | null | undefined, analyticsColorName?: string | null | undefined, title?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'ProductTagRecord', id: any, tag?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined }>, labels: Array<{ __typename?: 'ProductLabelRecord', label?: string | null | undefined, slug?: string | null | undefined, id: any }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, analyticsCategoryName?: string | null | undefined, analyticsName?: string | null | undefined } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'TabsComponentRecord', id: any, tabs: Array<{ __typename?: 'TabItemRecord', id: any, tabTitle?: string | null | undefined, tabComponents?: { __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> }> } | null | undefined, seo?: { __typename?: 'SeoRecord', seoMeta: Array<{ __typename?: 'Tag', attributes?: any | null | undefined, content?: string | null | undefined, tag: string }> } | null | undefined } | null | undefined };

export type ColumnContentComponentFragment = { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> };

export type CompatibleMachineFragment = { __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined };

export type ComponentsWrapperFragment = { __typename?: 'ComponentsWrapperRecord', components: Array<{ __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'NewsletterRecord', id: any, emailPlaceholder?: string | null | undefined, showFirstTermsCheckbox?: any | null | undefined, showSecondTermsCheckbox?: any | null | undefined, subscribeButtonText?: string | null | undefined, showFirstTermsAbove?: any | null | undefined, showSecondTermsAbove?: any | null | undefined, headerText?: string | null | undefined, analyticsElementId?: string | null | undefined, newsletterHeader?: { __typename?: 'NewsletterModelHeaderField', value: any } | null | undefined, firstTerms?: { __typename?: 'NewsletterModelFirstTermsField', value: any } | null | undefined, secondTerms?: { __typename?: 'NewsletterModelSecondTermsField', value: any } | null | undefined, otherTerms?: { __typename?: 'NewsletterModelOtherTermsField', value: any } | null | undefined, completedText?: { __typename?: 'NewsletterModelCompletedTextField', value: any } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }>, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ProductListComponentRecord', id: any, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, groupTitle?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', slug?: string | null | undefined, analyticsColorName?: string | null | undefined, title?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'ProductTagRecord', id: any, tag?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined }>, labels: Array<{ __typename?: 'ProductLabelRecord', label?: string | null | undefined, slug?: string | null | undefined, id: any }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, analyticsCategoryName?: string | null | undefined, analyticsName?: string | null | undefined } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'TabsComponentRecord', id: any, tabs: Array<{ __typename?: 'TabItemRecord', id: any, tabTitle?: string | null | undefined, tabComponents?: { __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> }> };

export type CartPageQueryVariables = Exact<{ [key: string]: never; }>;


export type CartPageQuery = { __typename?: 'Query', cartPage?: { __typename?: 'CartPageRecord', components?: { __typename?: 'ComponentsWrapperRecord', components: Array<{ __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'NewsletterRecord', id: any, emailPlaceholder?: string | null | undefined, showFirstTermsCheckbox?: any | null | undefined, showSecondTermsCheckbox?: any | null | undefined, subscribeButtonText?: string | null | undefined, showFirstTermsAbove?: any | null | undefined, showSecondTermsAbove?: any | null | undefined, headerText?: string | null | undefined, analyticsElementId?: string | null | undefined, newsletterHeader?: { __typename?: 'NewsletterModelHeaderField', value: any } | null | undefined, firstTerms?: { __typename?: 'NewsletterModelFirstTermsField', value: any } | null | undefined, secondTerms?: { __typename?: 'NewsletterModelSecondTermsField', value: any } | null | undefined, otherTerms?: { __typename?: 'NewsletterModelOtherTermsField', value: any } | null | undefined, completedText?: { __typename?: 'NewsletterModelCompletedTextField', value: any } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }>, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ProductListComponentRecord', id: any, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, groupTitle?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', slug?: string | null | undefined, analyticsColorName?: string | null | undefined, title?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'ProductTagRecord', id: any, tag?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined }>, labels: Array<{ __typename?: 'ProductLabelRecord', label?: string | null | undefined, slug?: string | null | undefined, id: any }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, analyticsCategoryName?: string | null | undefined, analyticsName?: string | null | undefined } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'TabsComponentRecord', id: any, tabs: Array<{ __typename?: 'TabItemRecord', id: any, tabTitle?: string | null | undefined, tabComponents?: { __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> }> } | null | undefined, checkoutPaymentImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, seo?: { __typename?: 'SeoRecord', seoMeta: Array<{ __typename?: 'Tag', attributes?: any | null | undefined, content?: string | null | undefined, tag: string }> } | null | undefined } | null | undefined };

export type ExternalVideoComponentFragment = { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined };

export type FaqComponentFragment = { __typename?: 'FaqRecord', title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> };

export type TabFaqComponentFragment = { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> };

export type FeaturedBlogPostComponentFragment = { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined };

export type GasExchangePageQueryVariables = Exact<{ [key: string]: never; }>;


export type GasExchangePageQuery = { __typename?: 'Query', gasExchangePage?: { __typename?: 'GasExchangePageRecord', gasSelectorText?: string | null | undefined, recommendedCylindersText?: string | null | undefined, lowestPriceText?: string | null | undefined, pageBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, title?: { __typename?: 'PageTitleRecord', title?: string | null | undefined, description?: string | null | undefined } | null | undefined, peopleSelect?: { __typename?: 'NumericSelectRecord', options: Array<{ __typename?: 'NumericOptionRecord', id: any, label?: string | null | undefined, value?: any | null | undefined }> } | null | undefined, bottlesSelect?: { __typename?: 'NumericSelectRecord', options: Array<{ __typename?: 'NumericOptionRecord', id: any, label?: string | null | undefined, value?: any | null | undefined }> } | null | undefined, customCylinders: Array<{ __typename?: 'CustomCylinderRecord', id: any, title?: string | null | undefined, description?: string | null | undefined, price?: any | null | undefined, buttonText?: string | null | undefined, buttonUrl?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> }>, components?: { __typename?: 'ComponentsWrapperRecord', components: Array<{ __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'NewsletterRecord', id: any, emailPlaceholder?: string | null | undefined, showFirstTermsCheckbox?: any | null | undefined, showSecondTermsCheckbox?: any | null | undefined, subscribeButtonText?: string | null | undefined, showFirstTermsAbove?: any | null | undefined, showSecondTermsAbove?: any | null | undefined, headerText?: string | null | undefined, analyticsElementId?: string | null | undefined, newsletterHeader?: { __typename?: 'NewsletterModelHeaderField', value: any } | null | undefined, firstTerms?: { __typename?: 'NewsletterModelFirstTermsField', value: any } | null | undefined, secondTerms?: { __typename?: 'NewsletterModelSecondTermsField', value: any } | null | undefined, otherTerms?: { __typename?: 'NewsletterModelOtherTermsField', value: any } | null | undefined, completedText?: { __typename?: 'NewsletterModelCompletedTextField', value: any } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }>, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ProductListComponentRecord', id: any, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, groupTitle?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', slug?: string | null | undefined, analyticsColorName?: string | null | undefined, title?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'ProductTagRecord', id: any, tag?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined }>, labels: Array<{ __typename?: 'ProductLabelRecord', label?: string | null | undefined, slug?: string | null | undefined, id: any }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, analyticsCategoryName?: string | null | undefined, analyticsName?: string | null | undefined } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'TabsComponentRecord', id: any, tabs: Array<{ __typename?: 'TabItemRecord', id: any, tabTitle?: string | null | undefined, tabComponents?: { __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> }> } | null | undefined, seo?: { __typename?: 'SeoRecord', seoMeta: Array<{ __typename?: 'Tag', attributes?: any | null | undefined, content?: string | null | undefined, tag: string }> } | null | undefined } | null | undefined };

export type HomepageHeroComponentFragment = { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined };

export type HeroImageComponentFragment = { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined };

export type LabelBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type LabelBySlugQuery = { __typename?: 'Query', productLabel?: { __typename?: 'ProductLabelRecord', id: any, label?: string | null | undefined, slug?: string | null | undefined } | null | undefined };

export type LegalBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type LegalBySlugQuery = { __typename?: 'Query', legal?: { __typename?: 'LegalRecord', slug?: string | null | undefined, legalSection: Array<{ __typename?: 'LegalSectionRecord', heading?: string | null | undefined, content?: { __typename?: 'LegalSectionModelContentField', value: any } | null | undefined }>, seo?: { __typename?: 'SeoRecord', seoMeta: Array<{ __typename?: 'Tag', attributes?: any | null | undefined, content?: string | null | undefined, tag: string }> } | null | undefined } | null | undefined };

export type LinksAsCardsComponentFragment = { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> };

export type LoginPageQueryVariables = Exact<{ [key: string]: never; }>;


export type LoginPageQuery = { __typename?: 'Query', loginPage?: { __typename?: 'LoginPageRecord', seo?: { __typename?: 'SeoRecord', seoMeta: Array<{ __typename?: 'Tag', attributes?: any | null | undefined, content?: string | null | undefined, tag: string }> } | null | undefined } | null | undefined };

export type MediaWithStructuredTextFragment = { __typename?: 'MediaWithStructuredTextRecord', id: any, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, video?: { __typename?: 'FileField', video?: { __typename?: 'UploadVideoField', thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined };

export type NewsletterFragment = { __typename: 'NewsletterRecord', id: any, emailPlaceholder?: string | null | undefined, showFirstTermsCheckbox?: any | null | undefined, showSecondTermsCheckbox?: any | null | undefined, subscribeButtonText?: string | null | undefined, showFirstTermsAbove?: any | null | undefined, showSecondTermsAbove?: any | null | undefined, headerText?: string | null | undefined, analyticsElementId?: string | null | undefined, newsletterHeader?: { __typename?: 'NewsletterModelHeaderField', value: any } | null | undefined, firstTerms?: { __typename?: 'NewsletterModelFirstTermsField', value: any } | null | undefined, secondTerms?: { __typename?: 'NewsletterModelSecondTermsField', value: any } | null | undefined, otherTerms?: { __typename?: 'NewsletterModelOtherTermsField', value: any } | null | undefined, completedText?: { __typename?: 'NewsletterModelCompletedTextField', value: any } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }>, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined };

export type Page404QueryVariables = Exact<{ [key: string]: never; }>;


export type Page404Query = { __typename?: 'Query', page404?: { __typename?: 'Page404Record', components?: { __typename?: 'ComponentsWrapperRecord', components: Array<{ __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'NewsletterRecord', id: any, emailPlaceholder?: string | null | undefined, showFirstTermsCheckbox?: any | null | undefined, showSecondTermsCheckbox?: any | null | undefined, subscribeButtonText?: string | null | undefined, showFirstTermsAbove?: any | null | undefined, showSecondTermsAbove?: any | null | undefined, headerText?: string | null | undefined, analyticsElementId?: string | null | undefined, newsletterHeader?: { __typename?: 'NewsletterModelHeaderField', value: any } | null | undefined, firstTerms?: { __typename?: 'NewsletterModelFirstTermsField', value: any } | null | undefined, secondTerms?: { __typename?: 'NewsletterModelSecondTermsField', value: any } | null | undefined, otherTerms?: { __typename?: 'NewsletterModelOtherTermsField', value: any } | null | undefined, completedText?: { __typename?: 'NewsletterModelCompletedTextField', value: any } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }>, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ProductListComponentRecord', id: any, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, groupTitle?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', slug?: string | null | undefined, analyticsColorName?: string | null | undefined, title?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'ProductTagRecord', id: any, tag?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined }>, labels: Array<{ __typename?: 'ProductLabelRecord', label?: string | null | undefined, slug?: string | null | undefined, id: any }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, analyticsCategoryName?: string | null | undefined, analyticsName?: string | null | undefined } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'TabsComponentRecord', id: any, tabs: Array<{ __typename?: 'TabItemRecord', id: any, tabTitle?: string | null | undefined, tabComponents?: { __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> }> } | null | undefined } | null | undefined };

export type CollectionProductListComponentFragment = { __typename: 'ProductListComponentRecord', id: any, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, groupTitle?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', slug?: string | null | undefined, analyticsColorName?: string | null | undefined, title?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'ProductTagRecord', id: any, tag?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined }>, labels: Array<{ __typename?: 'ProductLabelRecord', label?: string | null | undefined, slug?: string | null | undefined, id: any }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, analyticsCategoryName?: string | null | undefined, analyticsName?: string | null | undefined } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined }> };

export type ProductPageContentBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type ProductPageContentBySlugQuery = { __typename?: 'Query', product?: { __typename?: 'ProductRecord', components?: { __typename?: 'ComponentsWrapperRecord', components: Array<{ __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'NewsletterRecord', id: any, emailPlaceholder?: string | null | undefined, showFirstTermsCheckbox?: any | null | undefined, showSecondTermsCheckbox?: any | null | undefined, subscribeButtonText?: string | null | undefined, showFirstTermsAbove?: any | null | undefined, showSecondTermsAbove?: any | null | undefined, headerText?: string | null | undefined, analyticsElementId?: string | null | undefined, newsletterHeader?: { __typename?: 'NewsletterModelHeaderField', value: any } | null | undefined, firstTerms?: { __typename?: 'NewsletterModelFirstTermsField', value: any } | null | undefined, secondTerms?: { __typename?: 'NewsletterModelSecondTermsField', value: any } | null | undefined, otherTerms?: { __typename?: 'NewsletterModelOtherTermsField', value: any } | null | undefined, completedText?: { __typename?: 'NewsletterModelCompletedTextField', value: any } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }>, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ProductListComponentRecord', id: any, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, groupTitle?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', slug?: string | null | undefined, analyticsColorName?: string | null | undefined, title?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'ProductTagRecord', id: any, tag?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined }>, labels: Array<{ __typename?: 'ProductLabelRecord', label?: string | null | undefined, slug?: string | null | undefined, id: any }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, analyticsCategoryName?: string | null | undefined, analyticsName?: string | null | undefined } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'TabsComponentRecord', id: any, tabs: Array<{ __typename?: 'TabItemRecord', id: any, tabTitle?: string | null | undefined, tabComponents?: { __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> }> } | null | undefined, faq?: { __typename?: 'FaqRecord', title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | null | undefined, seo?: { __typename?: 'SeoRecord', seoMeta: Array<{ __typename?: 'Tag', attributes?: any | null | undefined, content?: string | null | undefined, tag: string }> } | null | undefined } | null | undefined };

export type ProductsByGtinQueryVariables = Exact<{
  gtin?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type ProductsByGtinQuery = { __typename?: 'Query', allProducts: Array<{ __typename?: 'ProductRecord', gtin?: string | null | undefined, slug?: string | null | undefined, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined, cylinderTypes: Array<{ __typename?: 'CylinderTypeRecord', gtin?: string | null | undefined, spareCylinder?: { __typename?: 'ExtraCylinderRecord', gtin?: string | null | undefined } | null | undefined }> }> };

export type ProductsByGtinAndBundleTagQueryVariables = Exact<{
  gtins?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  bundleTags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type ProductsByGtinAndBundleTagQuery = { __typename?: 'Query', allProducts: Array<{ __typename?: 'ProductRecord', bundleTag?: string | null | undefined, gtin?: string | null | undefined, slug?: string | null | undefined, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined, cylinderTypes: Array<{ __typename?: 'CylinderTypeRecord', gtin?: string | null | undefined, spareCylinder?: { __typename?: 'ExtraCylinderRecord', gtin?: string | null | undefined } | null | undefined }>, aboveTitlePromo?: { __typename?: 'ProductCartPromoRecord', text?: string | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, belowTitlePromo?: { __typename?: 'ProductCartPromoRecord', text?: string | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> };

export type ProductsSliderComponentFragment = { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> };

export type PromotionalCardFragment = { __typename: 'PromotionalCardRecord', url?: string | null | undefined, cardPosition?: any | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, text?: { __typename?: 'StructuredTextWithPositionRecord', horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, text?: { __typename?: 'StructuredTextWithPositionModelTextField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, buttonText?: string | null | undefined, url?: string | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined };

export type RegisterPageQueryVariables = Exact<{ [key: string]: never; }>;


export type RegisterPageQuery = { __typename?: 'Query', registerPage?: { __typename?: 'RegisterPageRecord', seo?: { __typename?: 'SeoRecord', seoMeta: Array<{ __typename?: 'Tag', attributes?: any | null | undefined, content?: string | null | undefined, tag: string }> } | null | undefined } | null | undefined };

export type RichTextBlockFragment = { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined };

export type RichTextComponentFragment = { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined };

export type SeoFragment = { __typename?: 'SeoRecord', seoMeta: Array<{ __typename?: 'Tag', attributes?: any | null | undefined, content?: string | null | undefined, tag: string }> };

export type SliderWithImageAndStructuredTextFragment = { __typename?: 'SliderWithImageAndStructuredTextRecord', header?: string | null | undefined, slides: Array<{ __typename?: 'MediaWithStructuredTextRecord', id: any, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, video?: { __typename?: 'FileField', video?: { __typename?: 'UploadVideoField', thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined }> };

export type SmallTilesComponentFragment = { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined };

export type SplitContentComponentFragment = { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> };

export type SplitContentImageFragment = { __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined };

export type SplitContentTextFragment = { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined };

export type SplitHeroComponentFragment = { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined };

export type TabsComponentFragment = { __typename: 'TabsComponentRecord', id: any, tabs: Array<{ __typename?: 'TabItemRecord', id: any, tabTitle?: string | null | undefined, tabComponents?: { __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> };

export type TranslationQueryVariables = Exact<{ [key: string]: never; }>;


export type TranslationQuery = { __typename?: 'Query', translation?: { __typename?: 'TranslationRecord', added?: string | null | undefined, removed?: string | null | undefined, addToCart?: string | null | undefined, nutritionInformation?: string | null | undefined, ingredients?: string | null | undefined, howManyDoYouNeed?: string | null | undefined, cartDiscountWarning?: string | null | undefined, cartEmpty?: string | null | undefined, startShopping?: string | null | undefined, yourCart?: string | null | undefined, freeShipping?: string | null | undefined, amountUntilFreeShipping?: string | null | undefined, checkout?: string | null | undefined, outOfStockError?: string | null | undefined, quantityUpdatedWarning?: string | null | undefined, remove?: string | null | undefined, subtotal?: string | null | undefined, shipping?: string | null | undefined, free?: string | null | undefined, taxes?: string | null | undefined, calculatedAtCheckout?: string | null | undefined, grandTotal?: string | null | undefined, checkoutWith?: string | null | undefined, filterBy?: string | null | undefined, comingSoon?: string | null | undefined, thanksForRegisteringMachine?: string | null | undefined, month?: string | null | undefined, months?: string | null | undefined, cylinder?: string | null | undefined, cylinders?: string | null | undefined, shopNow?: string | null | undefined, for?: string | null | undefined, viewCompatibility?: string | null | undefined, cylinderCompatibleWithTheFollowing?: string | null | undefined, bottleCompatibleWithTheFollowing?: string | null | undefined, compatibleWithAllAlternativeBrandSparklingWaterMakers?: string | null | undefined, gotIt?: string | null | undefined, doesBottleFitMachine?: string | null | undefined, compareTo?: string | null | undefined, startingAt?: string | null | undefined, unknownError?: string | null | undefined, thankYouNewsletter?: string | null | undefined, quickconnectFeatureText?: string | null | undefined, ordering?: string | null | undefined, edit?: string | null | undefined, delivery?: string | null | undefined, quantity?: string | null | undefined, review?: string | null | undefined, selectCylinderType?: string | null | undefined, orderSummary?: string | null | undefined, each?: string | null | undefined, orderQuantity?: string | null | undefined, addAnExtraCylinder?: string | null | undefined, weSuggestEveryCustomerHaveAtLeast?: string | null | undefined, addAnExtraCylinderToMyOrderFor?: string | null | undefined, co2TermsText?: string | null | undefined, pleaseSelectACylinder?: string | null | undefined, whichCylinderDoINeed?: string | null | undefined, continue?: string | null | undefined, addToCartFor?: string | null | undefined, iAlreadyHaveAnAccount?: string | null | undefined, chooseYourPack?: string | null | undefined, selectYourColor?: string | null | undefined, youSelected?: string | null | undefined, showMore?: string | null | undefined, showLess?: string | null | undefined, youAreRegisteringYour?: string | null | undefined, sparklingWaterMaker?: string | null | undefined, placeOfPurchase?: string | null | undefined, selectLocationPlaceholder?: string | null | undefined, dateOfPurchase?: string | null | undefined, createYourAccount?: string | null | undefined, firstName?: string | null | undefined, firstNamePlaceholder?: string | null | undefined, firstNameIsRequired?: string | null | undefined, lastName?: string | null | undefined, lastNamePlaceholder?: string | null | undefined, lastNameIsRequired?: string | null | undefined, emailAddress?: string | null | undefined, emailAddressPlaceholder?: string | null | undefined, emailIsRequired?: string | null | undefined, invalidEmail?: string | null | undefined, createAPassword?: string | null | undefined, createPasswordPlaceholder?: string | null | undefined, invalidPassword?: string | null | undefined, passwordIsRequired?: string | null | undefined, dateOfBirth?: string | null | undefined, linkConfirmationSubtext?: string | null | undefined, ageDisclaimerSubtext?: string | null | undefined, completeYourRegistration?: string | null | undefined, compatibleMachinesFilterMainHeading?: string | null | undefined, compatibleMachinesFilterEmptyFilterText?: string | null | undefined, compatibleMachinesFilterFilledFilterText?: string | null | undefined, compatibleMachinesFilterContainerHeading?: string | null | undefined, unknownRegistrationError?: string | null | undefined, termsAreRequired?: string | null | undefined, machineIsRequired?: string | null | undefined, purchasePlaceIsRequired?: string | null | undefined, purchaseDateIsRequired?: string | null | undefined, purchaseDate2Years?: string | null | undefined, invalidPurchaseDate?: string | null | undefined, howItWorksText?: string | null | undefined, howToFizzText?: string | null | undefined, cylinderInsertionText?: string | null | undefined, bottleMaterialText?: string | null | undefined, dishwasherSafeBottlesText?: string | null | undefined, compatibleBottlesText?: string | null | undefined, dimensionsText?: string | null | undefined, viewArticle?: string | null | undefined, quickLinks?: string | null | undefined, all?: string | null | undefined, colors?: string | null | undefined, price?: string | null | undefined, returnEmptyCylinder?: string | null | undefined, homepagePopup?: string | null | undefined, shareThisArticle?: string | null | undefined, selectOrderQuantity?: string | null | undefined, homepage?: string | null | undefined, blog?: string | null | undefined, pack?: string | null | undefined, page404?: { __typename?: 'ErrorPageRecord', header?: string | null | undefined, description?: string | null | undefined, linkText?: string | null | undefined } | null | undefined, page500?: { __typename?: 'ErrorPageRecord', header?: string | null | undefined, description?: string | null | undefined, linkText?: string | null | undefined } | null | undefined, useAtLeast8Characters?: { __typename?: 'TranslationModelUseAtLeast8CharactersField', value: any } | null | undefined, useAtLeast1UppercaseAnd1LowercaseLetter?: { __typename?: 'TranslationModelUseAtLeast1UppercaseAnd1LowercaseLetterField', value: any } | null | undefined, useAtLeast2Numbers?: { __typename?: 'TranslationModelUseAtLeast2NumbersField', value: any } | null | undefined, useAtLeast1SpecialCharacter?: { __typename?: 'TranslationModelUseAtLeast1SpecialCharacterField', value: any } | null | undefined, machineComparisonTitle?: { __typename?: 'TranslationModelMachineComparisonTitleField', value: any } | null | undefined } | null | undefined };

export type allArticlesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['IntType']>;
  first?: InputMaybe<Scalars['IntType']>;
}>;


export type allArticlesQuery = { __typename?: 'Query', allArticles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, _updatedAt: any, section?: { __typename?: 'BlogSectionRecord', slug?: string | null | undefined } | null | undefined, seo?: { __typename?: 'SeoRecord', seo?: { __typename?: 'SeoField', noIndex?: any | null | undefined } | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', url: string } | null | undefined }> };

export type AllBlogSectionsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['IntType']>;
  first?: InputMaybe<Scalars['IntType']>;
}>;


export type AllBlogSectionsQuery = { __typename?: 'Query', allBlogSections: Array<{ __typename?: 'BlogSectionRecord', id: any, title?: string | null | undefined, filterText?: string | null | undefined, shouldAppearAsCategoryFilter?: any | null | undefined, _updatedAt: any, mainArticleTitleText?: string | null | undefined, slug?: string | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, mainArticleTitle?: { __typename?: 'BlogSectionModelMainArticleTitleField', value: any } | null | undefined, mainArticleSummary?: { __typename?: 'BlogSectionModelMainArticleSummaryField', value: any } | null | undefined, seo?: { __typename?: 'SeoRecord', seoMeta: Array<{ __typename?: 'Tag', attributes?: any | null | undefined, content?: string | null | undefined, tag: string }> } | null | undefined, mainArticle?: { __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined } | null | undefined, secondaryArticles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> }>, _allBlogSectionsMeta: { __typename?: 'CollectionMetadata', count: any } };

export type AllProdctLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllProdctLabelsQuery = { __typename?: 'Query', allProductLabels: Array<{ __typename?: 'ProductLabelRecord', id: any, label?: string | null | undefined, slug?: string | null | undefined }> };

export type AllPopupsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPopupsQuery = { __typename?: 'Query', allPopups: Array<{ __typename?: 'PopupRecord', buttonText?: string | null | undefined, imageOnLeftSide?: any | null | undefined, showPopupAfter?: any | null | undefined, disclaimerText?: { __typename?: 'PopupModelDisclaimerTextField', value: any } | null | undefined, heroImage?: { __typename?: 'FileField', url: string } | null | undefined, mainText?: { __typename?: 'PopupModelMainTextField', value: any, blocks: Array<{ __typename?: 'PopupLegalTextRecord', showCheckbox?: any | null | undefined, id: any, legalText?: { __typename?: 'PopupLegalTextModelLegalTextField', value: any } | null | undefined }> } | null | undefined, inputFields: Array<{ __typename?: 'PopupInputFieldRecord', inputFieldPlaceholder?: string | null | undefined, inputType?: string | null | undefined }>, welcomeText?: { __typename?: 'PopupModelWelcomeTextField', value: any } | null | undefined }> };

export type AllProductsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['IntType']>;
  first?: InputMaybe<Scalars['IntType']>;
}>;


export type AllProductsQuery = { __typename?: 'Query', allProducts: Array<{ __typename?: 'ProductRecord', _updatedAt: any, gtin?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined, cylinderTypes: Array<{ __typename?: 'CylinderTypeRecord', gtin?: string | null | undefined, spareCylinder?: { __typename?: 'ExtraCylinderRecord', gtin?: string | null | undefined } | null | undefined }>, seo?: { __typename?: 'SeoRecord', seo?: { __typename?: 'SeoField', noIndex?: any | null | undefined } | null | undefined } | null | undefined }>, _allProductsMeta: { __typename?: 'CollectionMetadata', count: any } };

export type allCollectionPagesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['IntType']>;
  first?: InputMaybe<Scalars['IntType']>;
}>;


export type allCollectionPagesQuery = { __typename?: 'Query', allCollectionPages: Array<{ __typename?: 'CollectionPageRecord', slug?: string | null | undefined, title?: string | null | undefined, _updatedAt: any, seo?: { __typename?: 'SeoRecord', seo?: { __typename?: 'SeoField', noIndex?: any | null | undefined } | null | undefined } | null | undefined }>, _allCollectionPagesMeta: { __typename?: 'CollectionMetadata', count: any } };

export type allLandingPagesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['IntType']>;
  first?: InputMaybe<Scalars['IntType']>;
}>;


export type allLandingPagesQuery = { __typename?: 'Query', allLandingPages: Array<{ __typename?: 'LandingPageRecord', title?: string | null | undefined, slug?: string | null | undefined, _updatedAt: any, _seoMetaTags: Array<{ __typename?: 'Tag', tag: string, content?: string | null | undefined, attributes?: any | null | undefined }>, seo?: { __typename?: 'SeoRecord', seo?: { __typename?: 'SeoField', noIndex?: any | null | undefined } | null | undefined } | null | undefined }>, _allLandingPagesMeta: { __typename?: 'CollectionMetadata', count: any } };

export type allProductCategoriesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['IntType']>;
  first?: InputMaybe<Scalars['IntType']>;
}>;


export type allProductCategoriesQuery = { __typename?: 'Query', allProductCategories: Array<{ __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, title?: string | null | undefined, _updatedAt: any, seo?: { __typename?: 'SeoRecord', seo?: { __typename?: 'SeoField', noIndex?: any | null | undefined } | null | undefined } | null | undefined }>, _allProductCategoriesMeta: { __typename?: 'CollectionMetadata', count: any } };

export type ArticleBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type ArticleBySlugQuery = { __typename?: 'Query', article?: { __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, featuredProductDirection?: string | null | undefined, content?: { __typename?: 'ArticleModelContentField', value: any, blocks: Array<{ __typename: 'ImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined } | { __typename: 'VideoRecord', id: any, video?: { __typename?: 'FileField', video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined }>, links: Array<{ __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined }> } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, featuredProducts: Array<{ __typename?: 'ProductRecord', shortDescription?: string | null | undefined, slug?: string | null | undefined, title?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, width?: any | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined } | null | undefined }>, seo?: { __typename?: 'SeoRecord', seoMeta: Array<{ __typename?: 'Tag', attributes?: any | null | undefined, content?: string | null | undefined, tag: string }> } | null | undefined, section?: { __typename?: 'BlogSectionRecord', slug?: string | null | undefined } | null | undefined } | null | undefined };

export type ArticleComponentsBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type ArticleComponentsBySlugQuery = { __typename?: 'Query', article?: { __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, components?: { __typename?: 'ComponentsWrapperRecord', components: Array<{ __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'NewsletterRecord', id: any, emailPlaceholder?: string | null | undefined, showFirstTermsCheckbox?: any | null | undefined, showSecondTermsCheckbox?: any | null | undefined, subscribeButtonText?: string | null | undefined, showFirstTermsAbove?: any | null | undefined, showSecondTermsAbove?: any | null | undefined, headerText?: string | null | undefined, analyticsElementId?: string | null | undefined, newsletterHeader?: { __typename?: 'NewsletterModelHeaderField', value: any } | null | undefined, firstTerms?: { __typename?: 'NewsletterModelFirstTermsField', value: any } | null | undefined, secondTerms?: { __typename?: 'NewsletterModelSecondTermsField', value: any } | null | undefined, otherTerms?: { __typename?: 'NewsletterModelOtherTermsField', value: any } | null | undefined, completedText?: { __typename?: 'NewsletterModelCompletedTextField', value: any } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }>, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ProductListComponentRecord', id: any, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, groupTitle?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', slug?: string | null | undefined, analyticsColorName?: string | null | undefined, title?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'ProductTagRecord', id: any, tag?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined }>, labels: Array<{ __typename?: 'ProductLabelRecord', label?: string | null | undefined, slug?: string | null | undefined, id: any }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, analyticsCategoryName?: string | null | undefined, analyticsName?: string | null | undefined } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'TabsComponentRecord', id: any, tabs: Array<{ __typename?: 'TabItemRecord', id: any, tabTitle?: string | null | undefined, tabComponents?: { __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> }> } | null | undefined } | null | undefined };

export type ProductCategoryFragment = { __typename?: 'ProductCategoryRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, style?: string | null | undefined, heroText?: string | null | undefined, description?: string | null | undefined, showCompatibleMachinesFilter?: any | null | undefined, analyticsName?: string | null | undefined, analyticsCategoryName?: string | null | undefined, heroImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, heroImageMobile?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, promotionalCard?: { __typename: 'PromotionalCardRecord', url?: string | null | undefined, cardPosition?: any | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, text?: { __typename?: 'StructuredTextWithPositionRecord', horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, text?: { __typename?: 'StructuredTextWithPositionModelTextField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, buttonText?: string | null | undefined, url?: string | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined } | null | undefined, plpItemBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, itemButton?: { __typename?: 'BottonLinkWithColorRecord', color?: { __typename?: 'ColorField', hex: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, seo?: { __typename?: 'SeoRecord', seoMeta: Array<{ __typename?: 'Tag', attributes?: any | null | undefined, content?: string | null | undefined, tag: string }> } | null | undefined };

export type CollectionPageFragment = { __typename?: 'CollectionPageRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, components?: { __typename?: 'ComponentsWrapperRecord', components: Array<{ __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'NewsletterRecord', id: any, emailPlaceholder?: string | null | undefined, showFirstTermsCheckbox?: any | null | undefined, showSecondTermsCheckbox?: any | null | undefined, subscribeButtonText?: string | null | undefined, showFirstTermsAbove?: any | null | undefined, showSecondTermsAbove?: any | null | undefined, headerText?: string | null | undefined, analyticsElementId?: string | null | undefined, newsletterHeader?: { __typename?: 'NewsletterModelHeaderField', value: any } | null | undefined, firstTerms?: { __typename?: 'NewsletterModelFirstTermsField', value: any } | null | undefined, secondTerms?: { __typename?: 'NewsletterModelSecondTermsField', value: any } | null | undefined, otherTerms?: { __typename?: 'NewsletterModelOtherTermsField', value: any } | null | undefined, completedText?: { __typename?: 'NewsletterModelCompletedTextField', value: any } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }>, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ProductListComponentRecord', id: any, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, groupTitle?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', slug?: string | null | undefined, analyticsColorName?: string | null | undefined, title?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'ProductTagRecord', id: any, tag?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined }>, labels: Array<{ __typename?: 'ProductLabelRecord', label?: string | null | undefined, slug?: string | null | undefined, id: any }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, analyticsCategoryName?: string | null | undefined, analyticsName?: string | null | undefined } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'TabsComponentRecord', id: any, tabs: Array<{ __typename?: 'TabItemRecord', id: any, tabTitle?: string | null | undefined, tabComponents?: { __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> }> } | null | undefined, seo?: { __typename?: 'SeoRecord', seoMeta: Array<{ __typename?: 'Tag', attributes?: any | null | undefined, content?: string | null | undefined, tag: string }> } | null | undefined };

export type DatoImageFragment = { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string };

export type DesktopHeaderQueryVariables = Exact<{ [key: string]: never; }>;


export type DesktopHeaderQuery = { __typename?: 'Query', desktopHeader?: { __typename?: 'DesktopHeaderRecord', promotionalBar?: string | null | undefined, promotionalBarLink?: string | null | undefined, leftDropdownItems: Array<{ __typename?: 'HeaderLeftDropdownItemRecord', id: any, title?: string | null | undefined, headerLeftSingleDropdown: Array<{ __typename?: 'HeaderImageLinkWithColorRecord', id: any, customTextColor?: string | null | undefined, url?: string | null | undefined, linkText?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string, alt?: string | null | undefined } | null | undefined }> }>, middleLinks: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, rightLinks: Array<{ __typename?: 'LinkRecord', id: any, url?: string | null | undefined, title?: string | null | undefined }>, promotionalBarTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, promotionalBarBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined };

export type FooterQueryVariables = Exact<{ [key: string]: never; }>;


export type FooterQuery = { __typename?: 'Query', footer?: { __typename?: 'FooterRecord', id: any, firstColumnHeading?: string | null | undefined, secondColumnHeading?: string | null | undefined, thirdColumnHeading?: string | null | undefined, firstColumnLinks: Array<{ __typename?: 'LinkRecord', url?: string | null | undefined, title?: string | null | undefined }>, secondColumnLinks: Array<{ __typename?: 'LinkRecord', url?: string | null | undefined, title?: string | null | undefined }>, thirdColumnLinks: Array<{ __typename?: 'LinkRecord', url?: string | null | undefined, title?: string | null | undefined }>, newsletter?: { __typename: 'NewsletterRecord', id: any, emailPlaceholder?: string | null | undefined, showFirstTermsCheckbox?: any | null | undefined, showSecondTermsCheckbox?: any | null | undefined, subscribeButtonText?: string | null | undefined, showFirstTermsAbove?: any | null | undefined, showSecondTermsAbove?: any | null | undefined, headerText?: string | null | undefined, analyticsElementId?: string | null | undefined, newsletterHeader?: { __typename?: 'NewsletterModelHeaderField', value: any } | null | undefined, firstTerms?: { __typename?: 'NewsletterModelFirstTermsField', value: any } | null | undefined, secondTerms?: { __typename?: 'NewsletterModelSecondTermsField', value: any } | null | undefined, otherTerms?: { __typename?: 'NewsletterModelOtherTermsField', value: any } | null | undefined, completedText?: { __typename?: 'NewsletterModelCompletedTextField', value: any } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }>, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, copyrightInfo?: { __typename?: 'FooterModelCopyrightInfoField', value: any } | null | undefined, socialMediaLinks: Array<{ __typename?: 'ImageLinkRecord', id: any, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | null | undefined };

export type HomePageQueryVariables = Exact<{ [key: string]: never; }>;


export type HomePageQuery = { __typename?: 'Query', homePage?: { __typename?: 'HomePageRecord', components?: { __typename?: 'ComponentsWrapperRecord', components: Array<{ __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'NewsletterRecord', id: any, emailPlaceholder?: string | null | undefined, showFirstTermsCheckbox?: any | null | undefined, showSecondTermsCheckbox?: any | null | undefined, subscribeButtonText?: string | null | undefined, showFirstTermsAbove?: any | null | undefined, showSecondTermsAbove?: any | null | undefined, headerText?: string | null | undefined, analyticsElementId?: string | null | undefined, newsletterHeader?: { __typename?: 'NewsletterModelHeaderField', value: any } | null | undefined, firstTerms?: { __typename?: 'NewsletterModelFirstTermsField', value: any } | null | undefined, secondTerms?: { __typename?: 'NewsletterModelSecondTermsField', value: any } | null | undefined, otherTerms?: { __typename?: 'NewsletterModelOtherTermsField', value: any } | null | undefined, completedText?: { __typename?: 'NewsletterModelCompletedTextField', value: any } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }>, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ProductListComponentRecord', id: any, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, groupTitle?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', slug?: string | null | undefined, analyticsColorName?: string | null | undefined, title?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'ProductTagRecord', id: any, tag?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined }>, labels: Array<{ __typename?: 'ProductLabelRecord', label?: string | null | undefined, slug?: string | null | undefined, id: any }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, analyticsCategoryName?: string | null | undefined, analyticsName?: string | null | undefined } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'TabsComponentRecord', id: any, tabs: Array<{ __typename?: 'TabItemRecord', id: any, tabTitle?: string | null | undefined, tabComponents?: { __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> }> } | null | undefined, seo?: { __typename?: 'SeoRecord', seoMeta: Array<{ __typename?: 'Tag', attributes?: any | null | undefined, content?: string | null | undefined, tag: string }> } | null | undefined } | null | undefined };

export type LandingPageBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type LandingPageBySlugQuery = { __typename?: 'Query', landingPage?: { __typename?: 'LandingPageRecord', title?: string | null | undefined, slug?: string | null | undefined, content?: string | null | undefined, components?: { __typename?: 'ComponentsWrapperRecord', components: Array<{ __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'NewsletterRecord', id: any, emailPlaceholder?: string | null | undefined, showFirstTermsCheckbox?: any | null | undefined, showSecondTermsCheckbox?: any | null | undefined, subscribeButtonText?: string | null | undefined, showFirstTermsAbove?: any | null | undefined, showSecondTermsAbove?: any | null | undefined, headerText?: string | null | undefined, analyticsElementId?: string | null | undefined, newsletterHeader?: { __typename?: 'NewsletterModelHeaderField', value: any } | null | undefined, firstTerms?: { __typename?: 'NewsletterModelFirstTermsField', value: any } | null | undefined, secondTerms?: { __typename?: 'NewsletterModelSecondTermsField', value: any } | null | undefined, otherTerms?: { __typename?: 'NewsletterModelOtherTermsField', value: any } | null | undefined, completedText?: { __typename?: 'NewsletterModelCompletedTextField', value: any } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }>, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ProductListComponentRecord', id: any, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, groupTitle?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', slug?: string | null | undefined, analyticsColorName?: string | null | undefined, title?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'ProductTagRecord', id: any, tag?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined }>, labels: Array<{ __typename?: 'ProductLabelRecord', label?: string | null | undefined, slug?: string | null | undefined, id: any }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, analyticsCategoryName?: string | null | undefined, analyticsName?: string | null | undefined } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'TabsComponentRecord', id: any, tabs: Array<{ __typename?: 'TabItemRecord', id: any, tabTitle?: string | null | undefined, tabComponents?: { __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> }> } | null | undefined, seo?: { __typename?: 'SeoRecord', seoMeta: Array<{ __typename?: 'Tag', attributes?: any | null | undefined, content?: string | null | undefined, tag: string }> } | null | undefined } | null | undefined };

export type MachineBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type MachineBySlugQuery = { __typename?: 'Query', machine?: { __typename?: 'MachineRecord', id: any, slug?: string | null | undefined, name?: string | null | undefined, components?: { __typename?: 'ComponentsWrapperRecord', components: Array<{ __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'NewsletterRecord', id: any, emailPlaceholder?: string | null | undefined, showFirstTermsCheckbox?: any | null | undefined, showSecondTermsCheckbox?: any | null | undefined, subscribeButtonText?: string | null | undefined, showFirstTermsAbove?: any | null | undefined, showSecondTermsAbove?: any | null | undefined, headerText?: string | null | undefined, analyticsElementId?: string | null | undefined, newsletterHeader?: { __typename?: 'NewsletterModelHeaderField', value: any } | null | undefined, firstTerms?: { __typename?: 'NewsletterModelFirstTermsField', value: any } | null | undefined, secondTerms?: { __typename?: 'NewsletterModelSecondTermsField', value: any } | null | undefined, otherTerms?: { __typename?: 'NewsletterModelOtherTermsField', value: any } | null | undefined, completedText?: { __typename?: 'NewsletterModelCompletedTextField', value: any } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }>, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ProductListComponentRecord', id: any, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, groupTitle?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', slug?: string | null | undefined, analyticsColorName?: string | null | undefined, title?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'ProductTagRecord', id: any, tag?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined }>, labels: Array<{ __typename?: 'ProductLabelRecord', label?: string | null | undefined, slug?: string | null | undefined, id: any }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, analyticsCategoryName?: string | null | undefined, analyticsName?: string | null | undefined } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'TabsComponentRecord', id: any, tabs: Array<{ __typename?: 'TabItemRecord', id: any, tabTitle?: string | null | undefined, tabComponents?: { __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> }> } | null | undefined, seo?: { __typename?: 'SeoRecord', seoMeta: Array<{ __typename?: 'Tag', attributes?: any | null | undefined, content?: string | null | undefined, tag: string }> } | null | undefined } | null | undefined };

export type MachineRegistrationQueryVariables = Exact<{ [key: string]: never; }>;


export type MachineRegistrationQuery = { __typename?: 'Query', machineRegistrationPage?: { __typename?: 'MachineRegistrationPageRecord', headerText?: string | null | undefined, subHeaderText?: string | null | undefined, machinesHeader?: string | null | undefined, machineDetailsHeader?: string | null | undefined, header?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, machineBannerBackground?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, machines: Array<{ __typename?: 'MachineRecord', id: any, name?: string | null | undefined, slug?: string | null | undefined, gtin?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, purchaseLocation: Array<{ __typename?: 'OptionRecord', id: any, value?: string | null | undefined, label?: string | null | undefined }>, emailSubscriptionText?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, termsOfServiceText?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, benefitsOfAccount?: { __typename?: 'SliderWithImageAndStructuredTextRecord', header?: string | null | undefined, slides: Array<{ __typename?: 'MediaWithStructuredTextRecord', id: any, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, video?: { __typename?: 'FileField', video?: { __typename?: 'UploadVideoField', thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined }> } | null | undefined, seo?: { __typename?: 'SeoRecord', seoMeta: Array<{ __typename?: 'Tag', attributes?: any | null | undefined, content?: string | null | undefined, tag: string }> } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }> } | null | undefined };

export type MobileHeaderQueryVariables = Exact<{ [key: string]: never; }>;


export type MobileHeaderQuery = { __typename?: 'Query', mobileHeader?: { __typename?: 'MobileHeaderRecord', promotionalBar?: string | null | undefined, promotionalBarLink?: string | null | undefined, customHeaderLinks: Array<{ __typename?: 'CustomMobileHeaderLinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined, openMenu?: any | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, mobileMenuCategories: Array<{ __typename?: 'MobileHeaderMenuItemRecord', id: any, title?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, content: Array<{ __typename?: 'HeaderImageLinkWithColorRecord', id: any, linkText?: string | null | undefined, textColor?: string | null | undefined, url?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> }>, bottomMenuLinks: Array<{ __typename?: 'LinkWithColorRecord', id: any, title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, bottomMenuColoredLink: Array<{ __typename?: 'LinkWithColorRecord', id: any, title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, promotionalBarTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, promotionalBarBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined };

export type DatoProductForCategoryPageFragment = { __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, groupTitle?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', slug?: string | null | undefined, analyticsColorName?: string | null | undefined, title?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'ProductTagRecord', id: any, tag?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined }>, labels: Array<{ __typename?: 'ProductLabelRecord', label?: string | null | undefined, slug?: string | null | undefined, id: any }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, analyticsCategoryName?: string | null | undefined, analyticsName?: string | null | undefined } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined };

export type ProductBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type ProductBySlugQuery = { __typename?: 'Query', product?: { __typename?: 'ProductRecord', gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, heroTitle?: string | null | undefined, heroDescription?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, cylinderSelectionInfo?: string | null | undefined, lowestPriceText?: string | null | undefined, components?: { __typename?: 'ComponentsWrapperRecord', components: Array<{ __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'NewsletterRecord', id: any, emailPlaceholder?: string | null | undefined, showFirstTermsCheckbox?: any | null | undefined, showSecondTermsCheckbox?: any | null | undefined, subscribeButtonText?: string | null | undefined, showFirstTermsAbove?: any | null | undefined, showSecondTermsAbove?: any | null | undefined, headerText?: string | null | undefined, analyticsElementId?: string | null | undefined, newsletterHeader?: { __typename?: 'NewsletterModelHeaderField', value: any } | null | undefined, firstTerms?: { __typename?: 'NewsletterModelFirstTermsField', value: any } | null | undefined, secondTerms?: { __typename?: 'NewsletterModelSecondTermsField', value: any } | null | undefined, otherTerms?: { __typename?: 'NewsletterModelOtherTermsField', value: any } | null | undefined, completedText?: { __typename?: 'NewsletterModelCompletedTextField', value: any } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }>, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ProductListComponentRecord', id: any, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, groupTitle?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', slug?: string | null | undefined, analyticsColorName?: string | null | undefined, title?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'ProductTagRecord', id: any, tag?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined }>, labels: Array<{ __typename?: 'ProductLabelRecord', label?: string | null | undefined, slug?: string | null | undefined, id: any }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, analyticsCategoryName?: string | null | undefined, analyticsName?: string | null | undefined } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'TabsComponentRecord', id: any, tabs: Array<{ __typename?: 'TabItemRecord', id: any, tabTitle?: string | null | undefined, tabComponents?: { __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> }> } | null | undefined, faq?: { __typename?: 'FaqRecord', title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | null | undefined, seo?: { __typename?: 'SeoRecord', seoMeta: Array<{ __typename?: 'Tag', attributes?: any | null | undefined, content?: string | null | undefined, tag: string }> } | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, heroImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, category?: { __typename?: 'ProductCategoryRecord', style?: string | null | undefined, analyticsName?: string | null | undefined, analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', title?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, nutrition?: { __typename?: 'ProductNutritionRecord', image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, ingredients?: { __typename?: 'ProductNutritionModelIngredientsField', value: any } | null | undefined } | null | undefined, productBundles: Array<{ __typename?: 'ProductBundleRecord', title?: string | null | undefined, bundleId?: string | null | undefined, lowestPriceText?: string | null | undefined, bundleImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, bundleItems: Array<{ __typename?: 'BundleItemRecord', amount?: any | null | undefined, title?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, description?: { __typename?: 'TextDescriptionRecord', header?: string | null | undefined, text?: string | null | undefined } | null | undefined }>, productBenefits: Array<{ __typename?: 'IconWithImageRecord', text?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, cylinderTypes: Array<{ __typename?: 'CylinderTypeRecord', gtin?: string | null | undefined, title?: string | null | undefined, description?: string | null | undefined, blueBoxText?: string | null | undefined, lowestPriceText?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, cylinderTextDescription: Array<{ __typename?: 'TextDescriptionRecord', header?: string | null | undefined, text?: string | null | undefined }>, spareCylinder?: { __typename?: 'ExtraCylinderRecord', title?: string | null | undefined, gtin?: string | null | undefined, lowestPriceText?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> }>, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, cylinderQuantityOptions: Array<{ __typename?: 'CylinderQuantityOptionRecord', amount?: any | null | undefined, extraText?: string | null | undefined, promotionalText?: string | null | undefined }>, cylinderFrequencyOptions: Array<{ __typename?: 'CylinderFrequencyOptionRecord', periodLengthNumber?: any | null | undefined, periodLengthText?: string | null | undefined }>, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined, product3dModel?: { __typename?: 'FileField', url: string } | null | undefined, product3dPoster?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, returnPolicy?: { __typename?: 'ReturnPolicyRecord', policy?: { __typename?: 'ReturnPolicyModelPolicyField', value: any } | null | undefined } | null | undefined } | null | undefined };

export type ProductCategoryBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type ProductCategoryBySlugQuery = { __typename?: 'Query', productCategory?: { __typename?: 'ProductCategoryRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, style?: string | null | undefined, heroText?: string | null | undefined, description?: string | null | undefined, showCompatibleMachinesFilter?: any | null | undefined, analyticsName?: string | null | undefined, analyticsCategoryName?: string | null | undefined, _allReferencingProducts: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, groupTitle?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', slug?: string | null | undefined, analyticsColorName?: string | null | undefined, title?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'ProductTagRecord', id: any, tag?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined }>, labels: Array<{ __typename?: 'ProductLabelRecord', label?: string | null | undefined, slug?: string | null | undefined, id: any }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, analyticsCategoryName?: string | null | undefined, analyticsName?: string | null | undefined } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined }>, components?: { __typename?: 'ComponentsWrapperRecord', components: Array<{ __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'NewsletterRecord', id: any, emailPlaceholder?: string | null | undefined, showFirstTermsCheckbox?: any | null | undefined, showSecondTermsCheckbox?: any | null | undefined, subscribeButtonText?: string | null | undefined, showFirstTermsAbove?: any | null | undefined, showSecondTermsAbove?: any | null | undefined, headerText?: string | null | undefined, analyticsElementId?: string | null | undefined, newsletterHeader?: { __typename?: 'NewsletterModelHeaderField', value: any } | null | undefined, firstTerms?: { __typename?: 'NewsletterModelFirstTermsField', value: any } | null | undefined, secondTerms?: { __typename?: 'NewsletterModelSecondTermsField', value: any } | null | undefined, otherTerms?: { __typename?: 'NewsletterModelOtherTermsField', value: any } | null | undefined, completedText?: { __typename?: 'NewsletterModelCompletedTextField', value: any } | null | undefined, customData: Array<{ __typename?: 'KeyWithValueRecord', id: any, key?: string | null | undefined, value?: string | null | undefined }>, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ProductListComponentRecord', id: any, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, groupTitle?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', slug?: string | null | undefined, analyticsColorName?: string | null | undefined, title?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'ProductTagRecord', id: any, tag?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined }>, labels: Array<{ __typename?: 'ProductLabelRecord', label?: string | null | undefined, slug?: string | null | undefined, id: any }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, analyticsCategoryName?: string | null | undefined, analyticsName?: string | null | undefined } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'TabsComponentRecord', id: any, tabs: Array<{ __typename?: 'TabItemRecord', id: any, tabTitle?: string | null | undefined, tabComponents?: { __typename: 'BigTilesComponentRecord', id: any, bigTiles: Array<{ __typename?: 'BigTileRecord', id: any, header?: string | null | undefined, analyticsType?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, foregroundImages: Array<{ __typename?: 'FileField', id: any, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, links: Array<{ __typename?: 'LinkRecord', id: any, title?: string | null | undefined, url?: string | null | undefined }>, linkButton?: { __typename?: 'BottonLinkWithColorRecord', title?: string | null | undefined, url?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'ColumnContentComponentRecord', id: any, title?: string | null | undefined, showItemNumber?: any | null | undefined, centerItemContent?: any | null | undefined, itemWidth?: string | null | undefined, alignContent?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mediaItems: Array<{ __typename: 'MediaWithTextRecord', id: any, header?: string | null | undefined, media?: { __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined, text?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> } | { __typename: 'ExternalVideoRecord', id: any, fullPageWidth?: any | null | undefined, videoUrl?: { __typename?: 'VideoField', url: string, title: string, provider: string, width: any, height: any } | null | undefined } | { __typename: 'FaqComponentRecord', id: any, title?: string | null | undefined, questions: Array<{ __typename?: 'FaqQuestionRecord', id: any, question?: string | null | undefined, answer?: { __typename?: 'FaqQuestionModelAnswerField', value: any } | null | undefined, button?: { __typename?: 'LinkRecord', title?: string | null | undefined, url?: string | null | undefined } | null | undefined }> } | { __typename: 'FeaturedBlogPostComponentRecord', id: any, header?: string | null | undefined, subHeader?: string | null | undefined, articles: Array<{ __typename?: 'ArticleRecord', id: any, slug?: string | null | undefined, title?: string | null | undefined, section?: { __typename?: 'BlogSectionRecord', title?: string | null | undefined, slug?: string | null | undefined } | null | undefined, heroVisual?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'HeroImageComponentRecord', id: any, link?: string | null | undefined, analyticsPromoName?: string | null | undefined, media?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined, video?: { __typename?: 'UploadVideoField', muxPlaybackId: string, thumbnailUrl: string, streamingUrl: string } | null | undefined } | null | undefined } | { __typename: 'HomepageHeroComponentRecord', id: any, header?: string | null | undefined, description?: string | null | undefined, link?: string | null | undefined, linkText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, backgroundImageClickLink?: string | null | undefined, imageXCenter?: any | null | undefined, imageYCenter?: any | null | undefined, showOnMobile?: any | null | undefined, showOnDesktop?: any | null | undefined, analyticsPromoName?: string | null | undefined, mobileBackgroundImageClickLink?: string | null | undefined, mobileImageXCenter?: any | null | undefined, mobileImageYCenter?: any | null | undefined, mobileHorizontalPosition?: string | null | undefined, mobileVerticalPosition?: string | null | undefined, mobileAnalyticsPromoName?: string | null | undefined, backgroundImage?: { __typename?: 'FileField', url: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, buttonTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, mobileBackgroundImage?: { __typename?: 'FileField', url: string } | null | undefined } | { __typename: 'LinksAsCardsComponentRecord', id: any, title?: string | null | undefined, links: Array<{ __typename?: 'ImageLinkWithTextRecord', id: any, text?: string | null | undefined, url?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }> } | { __typename: 'ProductsSliderComponentRecord', id: any, header?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, products: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, title?: string | null | undefined, slug?: string | null | undefined, lowestPriceText?: string | null | undefined, productImages: Array<{ __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, category?: { __typename?: 'ProductCategoryRecord', analyticsCategoryName?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> } | { __typename: 'RichTextComponentRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextComponentModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SmallTilesComponentRecord', id: any, smallTiles: Array<{ __typename?: 'SmallTileRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, linkUrl?: string | null | undefined, linkText?: string | null | undefined, analyticsType?: string | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | { __typename: 'SplitContentComponentRecord', id: any, showSecondBlockFirstOnMobile?: any | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, content: Array<{ __typename: 'SplitContentImageRecord', id: any, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined } | { __typename: 'SplitContentTextRecord', id: any, buttonBeforeText?: any | null | undefined, textContent?: { __typename: 'RichTextBlockRecord', id: any, headingTextSize?: any | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textContent?: { __typename?: 'RichTextBlockModelTextContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', buttonText?: string | null | undefined, horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined } | null | undefined }> } | { __typename: 'SplitHeroComponentRecord', id: any, header?: string | null | undefined, bodyText?: string | null | undefined, options?: any | null | undefined, headerColor?: { __typename?: 'ColorField', hex: string } | null | undefined, bodyTextColor?: { __typename?: 'ColorField', hex: string } | null | undefined, image?: { __typename?: 'FileField', url: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined }> }> } | null | undefined, heroImage?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, heroImageMobile?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, promotionalCard?: { __typename: 'PromotionalCardRecord', url?: string | null | undefined, cardPosition?: any | null | undefined, image?: { __typename?: 'FileField', responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, text?: { __typename?: 'StructuredTextWithPositionRecord', horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, text?: { __typename?: 'StructuredTextWithPositionModelTextField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, button?: { __typename?: 'ButtonWithPositionRecord', horizontalPosition?: string | null | undefined, verticalPosition?: string | null | undefined, buttonText?: string | null | undefined, url?: string | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined } | null | undefined, plpItemBackgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, itemButton?: { __typename?: 'BottonLinkWithColorRecord', color?: { __typename?: 'ColorField', hex: string } | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined } | null | undefined, seo?: { __typename?: 'SeoRecord', seoMeta: Array<{ __typename?: 'Tag', attributes?: any | null | undefined, content?: string | null | undefined, tag: string }> } | null | undefined } | null | undefined };

export type ProductsByProductCategorySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type ProductsByProductCategorySlugQuery = { __typename?: 'Query', productCategory?: { __typename?: 'ProductCategoryRecord', _allReferencingProducts: Array<{ __typename?: 'ProductRecord', id: any, gtin?: string | null | undefined, bundleTag?: string | null | undefined, position?: any | null | undefined, shortDescription?: string | null | undefined, title?: string | null | undefined, groupTitle?: string | null | undefined, slug?: string | null | undefined, analyticsColorName?: string | null | undefined, productContent?: { __typename?: 'ProductModelProductContentField', blocks: Array<string>, links: Array<string>, value: any } | null | undefined, productImages: Array<{ __typename?: 'FileField', url: string, alt?: string | null | undefined, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined }>, color?: { __typename?: 'ColorField', hex: string } | null | undefined, colorVariants: Array<{ __typename?: 'ProductRecord', slug?: string | null | undefined, analyticsColorName?: string | null | undefined, title?: string | null | undefined, color?: { __typename?: 'ColorField', hex: string } | null | undefined }>, productBundles: Array<{ __typename?: 'ProductBundleRecord', bundleId?: string | null | undefined }>, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined, compatibleMachines: Array<{ __typename?: 'ProductRecord', id: any, title?: string | null | undefined, slug?: string | null | undefined, plpThumbnail?: { __typename?: 'FileField', url: string, responsiveImage?: { __typename?: 'ResponsiveImage', sizes: string, src: string, width: any, height: any, alt?: string | null | undefined, title?: string | null | undefined, base64?: string | null | undefined, aspectRatio: any, srcSet: string, webpSrcSet: string } | null | undefined } | null | undefined }>, tags: Array<{ __typename?: 'ProductTagRecord', id: any, tag?: string | null | undefined, backgroundColor?: { __typename?: 'ColorField', hex: string } | null | undefined, textColor?: { __typename?: 'ColorField', hex: string } | null | undefined }>, labels: Array<{ __typename?: 'ProductLabelRecord', label?: string | null | undefined, slug?: string | null | undefined, id: any }>, category?: { __typename?: 'ProductCategoryRecord', slug?: string | null | undefined, analyticsCategoryName?: string | null | undefined, analyticsName?: string | null | undefined } | null | undefined, comparisonData?: { __typename?: 'MachineComparisonRecord', howItWorks?: string | null | undefined, howToFizz?: string | null | undefined, cylinderInsertion?: string | null | undefined, bottleMaterial?: string | null | undefined, dishwasherSafeBottles?: string | null | undefined, compatibleBottles?: string | null | undefined, dimensions?: string | null | undefined } | null | undefined }> } | null | undefined };

export type SocialShareConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type SocialShareConfigurationQuery = { __typename?: 'Query', socialShareConfiguration?: { __typename?: 'SocialShareConfigurationRecord', linkedinShare?: any | null | undefined, facebookShare?: any | null | undefined } | null | undefined };

export const FaqComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment FaqComponent on FaqRecord {
  title
  questions {
    id
    question
    answer {
      value
    }
    button {
      title
      url
    }
  }
}
    `;
export const RichTextBlockFragmentDoc = /*#__PURE__*/ gql`
    fragment RichTextBlock on RichTextBlockRecord {
  __typename
  id
  textColor {
    hex
  }
  headingTextSize
  textContent {
    blocks
    links
    value
  }
  backgroundColor {
    hex
  }
}
    `;
export const DatoImageFragmentDoc = /*#__PURE__*/ gql`
    fragment DatoImage on ResponsiveImage {
  sizes
  src
  width
  height
  alt
  title
  base64
  aspectRatio
  srcSet
  webpSrcSet
}
    `;
export const MediaWithStructuredTextFragmentDoc = /*#__PURE__*/ gql`
    fragment MediaWithStructuredText on MediaWithStructuredTextRecord {
  id
  text {
    ...RichTextBlock
  }
  image {
    responsiveImage(imgixParams: {fit: max, auto: format}) {
      ...DatoImage
    }
  }
  video {
    video {
      thumbnailUrl
      streamingUrl
    }
  }
}
    `;
export const SliderWithImageAndStructuredTextFragmentDoc = /*#__PURE__*/ gql`
    fragment SliderWithImageAndStructuredText on SliderWithImageAndStructuredTextRecord {
  header
  slides {
    ...MediaWithStructuredText
  }
}
    `;
export const PromotionalCardFragmentDoc = /*#__PURE__*/ gql`
    fragment PromotionalCard on PromotionalCardRecord {
  __typename
  image {
    responsiveImage(imgixParams: {fit: max, auto: format}) {
      ...DatoImage
    }
  }
  text {
    horizontalPosition
    verticalPosition
    text {
      blocks
      links
      value
    }
    color {
      hex
    }
  }
  url
  button {
    horizontalPosition
    verticalPosition
    textColor {
      hex
    }
    backgroundColor {
      hex
    }
    buttonText
    url
  }
  cardPosition
}
    `;
export const SeoFragmentDoc = /*#__PURE__*/ gql`
    fragment Seo on SeoRecord {
  seoMeta: _seoMetaTags {
    attributes
    content
    tag
  }
}
    `;
export const ProductCategoryFragmentDoc = /*#__PURE__*/ gql`
    fragment ProductCategory on ProductCategoryRecord {
  id
  slug
  title
  style
  heroImage {
    responsiveImage(imgixParams: {fit: max, auto: format}) {
      ...DatoImage
    }
  }
  heroImageMobile {
    responsiveImage(imgixParams: {fit: max, auto: format}) {
      ...DatoImage
    }
  }
  heroText
  description
  promotionalCard {
    ...PromotionalCard
  }
  showCompatibleMachinesFilter
  analyticsName
  analyticsCategoryName
  plpItemBackgroundColor {
    hex
  }
  itemButton {
    color {
      hex
    }
    backgroundColor {
      hex
    }
  }
  seo {
    ...Seo
  }
}
    `;
export const RichTextComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment RichTextComponent on RichTextComponentRecord {
  __typename
  id
  textColor {
    hex
  }
  headingTextSize
  textContent {
    blocks
    links
    value
  }
  backgroundColor {
    hex
  }
}
    `;
export const LinksAsCardsComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment LinksAsCardsComponent on LinksAsCardsComponentRecord {
  id
  __typename
  title
  links {
    id
    image {
      responsiveImage(imgixParams: {fit: max, auto: format}) {
        ...DatoImage
      }
    }
    text
    url
  }
}
    `;
export const HeroImageComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment HeroImageComponent on HeroImageComponentRecord {
  __typename
  id
  media {
    url
    responsiveImage(imgixParams: {fit: max, auto: format}) {
      ...DatoImage
    }
    video {
      muxPlaybackId
      thumbnailUrl
      streamingUrl
    }
  }
  link
  analyticsPromoName
}
    `;
export const ColumnContentComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment ColumnContentComponent on ColumnContentComponentRecord {
  __typename
  id
  backgroundColor {
    hex
  }
  title
  showItemNumber
  centerItemContent
  itemWidth
  alignContent
  mediaItems {
    ... on MediaWithTextRecord {
      __typename
      id
      media {
        url
        alt
        responsiveImage(imgixParams: {fit: max, auto: format}) {
          ...DatoImage
        }
        video {
          muxPlaybackId
          thumbnailUrl
          streamingUrl
        }
      }
      header
      text {
        ...RichTextBlock
      }
    }
  }
}
    `;
export const ProductsSliderComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment ProductsSliderComponent on ProductsSliderComponentRecord {
  __typename
  id
  header
  backgroundColor {
    hex
  }
  products {
    id
    gtin
    title
    slug
    productImages {
      responsiveImage(imgixParams: {fit: crop, w: 260, h: 260, auto: format}) {
        ...DatoImage
      }
    }
    category {
      analyticsCategoryName
      slug
    }
    lowestPriceText
  }
}
    `;
export const CompatibleMachineFragmentDoc = /*#__PURE__*/ gql`
    fragment CompatibleMachine on ProductRecord {
  id
  title
  plpThumbnail {
    url
    responsiveImage(imgixParams: {fit: max, auto: format}) {
      ...DatoImage
    }
  }
  slug
}
    `;
export const DatoProductForCategoryPageFragmentDoc = /*#__PURE__*/ gql`
    fragment DatoProductForCategoryPage on ProductRecord {
  id
  gtin
  bundleTag
  position
  shortDescription
  productContent {
    blocks
    links
    value
  }
  productImages {
    url
    alt
    responsiveImage(imgixParams: {fit: max, auto: format}) {
      ...DatoImage
    }
  }
  title
  groupTitle
  slug
  color {
    hex
  }
  colorVariants {
    slug
    color {
      hex
    }
    analyticsColorName
    title
  }
  productBundles {
    bundleId
  }
  plpThumbnail {
    url
    responsiveImage(imgixParams: {fit: max, auto: format}) {
      ...DatoImage
    }
  }
  compatibleMachines {
    ...CompatibleMachine
  }
  tags {
    id
    tag
    backgroundColor {
      hex
    }
    textColor {
      hex
    }
  }
  labels {
    label
    slug
    id
  }
  analyticsColorName
  category {
    slug
    analyticsCategoryName
    analyticsName
  }
  comparisonData {
    howItWorks
    howToFizz
    cylinderInsertion
    bottleMaterial
    dishwasherSafeBottles
    compatibleBottles
    dimensions
  }
}
    `;
export const CollectionProductListComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment CollectionProductListComponent on ProductListComponentRecord {
  __typename
  id
  products {
    ...DatoProductForCategoryPage
  }
}
    `;
export const SplitContentImageFragmentDoc = /*#__PURE__*/ gql`
    fragment SplitContentImage on SplitContentImageRecord {
  __typename
  id
  image {
    responsiveImage(imgixParams: {fit: max, w: 1000, h: 1000, auto: format}) {
      ...DatoImage
    }
  }
  button {
    buttonText
    horizontalPosition
    verticalPosition
  }
}
    `;
export const SplitContentTextFragmentDoc = /*#__PURE__*/ gql`
    fragment SplitContentText on SplitContentTextRecord {
  __typename
  id
  textContent {
    ...RichTextBlock
  }
  buttonBeforeText
  button {
    buttonText
    horizontalPosition
    verticalPosition
  }
}
    `;
export const SplitContentComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment SplitContentComponent on SplitContentComponentRecord {
  id
  __typename
  backgroundColor {
    hex
  }
  showSecondBlockFirstOnMobile
  content {
    ... on SplitContentImageRecord {
      ...SplitContentImage
    }
    ... on SplitContentTextRecord {
      ...SplitContentText
    }
  }
}
    `;
export const SplitHeroComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment SplitHeroComponent on SplitHeroComponentRecord {
  __typename
  id
  header
  headerColor {
    hex
  }
  bodyText
  bodyTextColor {
    hex
  }
  options
  image {
    url
  }
  backgroundColor {
    hex
  }
}
    `;
export const BigTilesComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment BigTilesComponent on BigTilesComponentRecord {
  __typename
  id
  bigTiles {
    id
    backgroundImage {
      responsiveImage(imgixParams: {fit: crop, w: 670, h: 670, auto: format}) {
        ...DatoImage
      }
    }
    header
    headerColor {
      hex
    }
    foregroundImages {
      id
      responsiveImage(imgixParams: {fit: max, w: 200, h: 500, auto: format}) {
        ...DatoImage
      }
    }
    links {
      id
      title
      url
    }
    linkButton {
      title
      color {
        hex
      }
      url
    }
    analyticsType
  }
  backgroundColor {
    hex
  }
}
    `;
export const SmallTilesComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment SmallTilesComponent on SmallTilesComponentRecord {
  __typename
  id
  smallTiles {
    id
    header
    bodyText
    linkUrl
    linkText
    image {
      responsiveImage(imgixParams: {fit: max, auto: format}) {
        ...DatoImage
      }
    }
    analyticsType
  }
  backgroundColor {
    hex
  }
}
    `;
export const HomepageHeroComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment HomepageHeroComponent on HomepageHeroComponentRecord {
  __typename
  id
  header
  description
  link
  linkText
  horizontalPosition
  verticalPosition
  backgroundImage {
    url
  }
  backgroundImageClickLink
  imageXCenter
  imageYCenter
  showOnMobile
  showOnDesktop
  textColor {
    hex
  }
  buttonBackgroundColor {
    hex
  }
  buttonTextColor {
    hex
  }
  analyticsPromoName
  mobileBackgroundImage {
    url
  }
  mobileBackgroundImageClickLink
  mobileImageXCenter
  mobileImageYCenter
  mobileHorizontalPosition
  mobileVerticalPosition
  mobileAnalyticsPromoName
}
    `;
export const FeaturedBlogPostComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment FeaturedBlogPostComponent on FeaturedBlogPostComponentRecord {
  __typename
  id
  articles {
    id
    slug
    section {
      title
      slug
    }
    title
    heroVisual {
      responsiveImage(imgixParams: {fit: max, auto: format}) {
        ...DatoImage
      }
    }
  }
  backgroundColor {
    hex
  }
  header
  subHeader
}
    `;
export const ExternalVideoComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment ExternalVideoComponent on ExternalVideoRecord {
  __typename
  id
  videoUrl {
    url
    title
    provider
    width
    height
  }
  fullPageWidth
}
    `;
export const TabFaqComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment TabFaqComponent on FaqComponentRecord {
  __typename
  id
  title
  questions {
    id
    question
    answer {
      value
    }
    button {
      title
      url
    }
  }
}
    `;
export const TabsComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment TabsComponent on TabsComponentRecord {
  __typename
  id
  tabs {
    id
    tabTitle
    tabComponents {
      ... on RichTextComponentRecord {
        ...RichTextComponent
      }
      ... on LinksAsCardsComponentRecord {
        ...LinksAsCardsComponent
      }
      ... on HeroImageComponentRecord {
        ...HeroImageComponent
      }
      ... on ColumnContentComponentRecord {
        ...ColumnContentComponent
      }
      ... on ProductsSliderComponentRecord {
        ...ProductsSliderComponent
      }
      ... on SplitContentComponentRecord {
        ...SplitContentComponent
      }
      ... on SplitHeroComponentRecord {
        ...SplitHeroComponent
      }
      ... on BigTilesComponentRecord {
        ...BigTilesComponent
      }
      ... on SmallTilesComponentRecord {
        ...SmallTilesComponent
      }
      ... on HomepageHeroComponentRecord {
        ...HomepageHeroComponent
      }
      ... on FeaturedBlogPostComponentRecord {
        ...FeaturedBlogPostComponent
      }
      ... on ExternalVideoRecord {
        ...ExternalVideoComponent
      }
      ... on FaqComponentRecord {
        ...TabFaqComponent
      }
    }
  }
}
    `;
export const NewsletterFragmentDoc = /*#__PURE__*/ gql`
    fragment Newsletter on NewsletterRecord {
  __typename
  id
  newsletterHeader: header {
    value
  }
  emailPlaceholder
  firstTerms {
    value
  }
  showFirstTermsCheckbox
  secondTerms {
    value
  }
  showSecondTermsCheckbox
  subscribeButtonText
  showFirstTermsAbove
  showSecondTermsAbove
  otherTerms {
    value
  }
  completedText {
    value
  }
  customData {
    id
    key
    value
  }
  headerText
  backgroundImage {
    responsiveImage(imgixParams: {fit: max, auto: format}) {
      ...DatoImage
    }
  }
  backgroundColor {
    hex
  }
  analyticsElementId
}
    `;
export const ComponentsWrapperFragmentDoc = /*#__PURE__*/ gql`
    fragment ComponentsWrapper on ComponentsWrapperRecord {
  components {
    ... on RichTextComponentRecord {
      ...RichTextComponent
    }
    ... on LinksAsCardsComponentRecord {
      ...LinksAsCardsComponent
    }
    ... on HeroImageComponentRecord {
      ...HeroImageComponent
    }
    ... on ColumnContentComponentRecord {
      ...ColumnContentComponent
    }
    ... on ProductsSliderComponentRecord {
      ...ProductsSliderComponent
    }
    ... on ProductListComponentRecord {
      ...CollectionProductListComponent
    }
    ... on SplitContentComponentRecord {
      ...SplitContentComponent
    }
    ... on SplitHeroComponentRecord {
      ...SplitHeroComponent
    }
    ... on BigTilesComponentRecord {
      ...BigTilesComponent
    }
    ... on SmallTilesComponentRecord {
      ...SmallTilesComponent
    }
    ... on HomepageHeroComponentRecord {
      ...HomepageHeroComponent
    }
    ... on FeaturedBlogPostComponentRecord {
      ...FeaturedBlogPostComponent
    }
    ... on ExternalVideoRecord {
      ...ExternalVideoComponent
    }
    ... on TabsComponentRecord {
      ...TabsComponent
    }
    ... on FaqComponentRecord {
      ...TabFaqComponent
    }
    ... on NewsletterRecord {
      ...Newsletter
    }
  }
}
    `;
export const CollectionPageFragmentDoc = /*#__PURE__*/ gql`
    fragment CollectionPage on CollectionPageRecord {
  id
  slug
  title
  components {
    ...ComponentsWrapper
  }
  seo {
    ...Seo
  }
}
    `;
export const ArticlesBySectionDocument = /*#__PURE__*/ gql`
    query ArticlesBySection($sectionId: ItemId, $skip: IntType, $first: IntType) {
  allArticles(filter: {section: {eq: $sectionId}}, skip: $skip, first: $first) {
    id
    slug
    title
    heroVisual {
      responsiveImage(imgixParams: {fit: max, auto: format}) {
        ...DatoImage
      }
    }
  }
  _allArticlesMeta(filter: {section: {eq: $sectionId}}) {
    count
  }
}
    ${DatoImageFragmentDoc}`;
export const BlogPageDocument = /*#__PURE__*/ gql`
    query BlogPage {
  blogPage {
    pageTitle
    topNewsletter {
      ...Newsletter
    }
    bodyNewsletter {
      ...Newsletter
    }
    components {
      ...ComponentsWrapper
    }
    seo {
      ...Seo
    }
    heroVisual {
      responsiveImage(imgixParams: {fit: max, auto: format}) {
        ...DatoImage
      }
    }
  }
}
    ${NewsletterFragmentDoc}
${DatoImageFragmentDoc}
${ComponentsWrapperFragmentDoc}
${RichTextComponentFragmentDoc}
${LinksAsCardsComponentFragmentDoc}
${HeroImageComponentFragmentDoc}
${ColumnContentComponentFragmentDoc}
${RichTextBlockFragmentDoc}
${ProductsSliderComponentFragmentDoc}
${CollectionProductListComponentFragmentDoc}
${DatoProductForCategoryPageFragmentDoc}
${CompatibleMachineFragmentDoc}
${SplitContentComponentFragmentDoc}
${SplitContentImageFragmentDoc}
${SplitContentTextFragmentDoc}
${SplitHeroComponentFragmentDoc}
${BigTilesComponentFragmentDoc}
${SmallTilesComponentFragmentDoc}
${HomepageHeroComponentFragmentDoc}
${FeaturedBlogPostComponentFragmentDoc}
${ExternalVideoComponentFragmentDoc}
${TabsComponentFragmentDoc}
${TabFaqComponentFragmentDoc}
${SeoFragmentDoc}`;
export const CategoryComponentsBySlugDocument = /*#__PURE__*/ gql`
    query CategoryComponentsBySlug($slug: String) {
  productCategory(filter: {slug: {eq: $slug}}) {
    id
    components {
      ...ComponentsWrapper
    }
  }
}
    ${ComponentsWrapperFragmentDoc}
${RichTextComponentFragmentDoc}
${LinksAsCardsComponentFragmentDoc}
${DatoImageFragmentDoc}
${HeroImageComponentFragmentDoc}
${ColumnContentComponentFragmentDoc}
${RichTextBlockFragmentDoc}
${ProductsSliderComponentFragmentDoc}
${CollectionProductListComponentFragmentDoc}
${DatoProductForCategoryPageFragmentDoc}
${CompatibleMachineFragmentDoc}
${SplitContentComponentFragmentDoc}
${SplitContentImageFragmentDoc}
${SplitContentTextFragmentDoc}
${SplitHeroComponentFragmentDoc}
${BigTilesComponentFragmentDoc}
${SmallTilesComponentFragmentDoc}
${HomepageHeroComponentFragmentDoc}
${FeaturedBlogPostComponentFragmentDoc}
${ExternalVideoComponentFragmentDoc}
${TabsComponentFragmentDoc}
${TabFaqComponentFragmentDoc}
${NewsletterFragmentDoc}`;
export const CollectionPageBySlugDocument = /*#__PURE__*/ gql`
    query CollectionPageBySlug($slug: String) {
  collectionPage(filter: {slug: {eq: $slug}}) {
    ...CollectionPage
  }
}
    ${CollectionPageFragmentDoc}
${ComponentsWrapperFragmentDoc}
${RichTextComponentFragmentDoc}
${LinksAsCardsComponentFragmentDoc}
${DatoImageFragmentDoc}
${HeroImageComponentFragmentDoc}
${ColumnContentComponentFragmentDoc}
${RichTextBlockFragmentDoc}
${ProductsSliderComponentFragmentDoc}
${CollectionProductListComponentFragmentDoc}
${DatoProductForCategoryPageFragmentDoc}
${CompatibleMachineFragmentDoc}
${SplitContentComponentFragmentDoc}
${SplitContentImageFragmentDoc}
${SplitContentTextFragmentDoc}
${SplitHeroComponentFragmentDoc}
${BigTilesComponentFragmentDoc}
${SmallTilesComponentFragmentDoc}
${HomepageHeroComponentFragmentDoc}
${FeaturedBlogPostComponentFragmentDoc}
${ExternalVideoComponentFragmentDoc}
${TabsComponentFragmentDoc}
${TabFaqComponentFragmentDoc}
${NewsletterFragmentDoc}
${SeoFragmentDoc}`;
export const CartPageDocument = /*#__PURE__*/ gql`
    query CartPage {
  cartPage {
    components {
      ...ComponentsWrapper
    }
    checkoutPaymentImages {
      responsiveImage(imgixParams: {fit: max, auto: format}) {
        ...DatoImage
      }
    }
    seo {
      ...Seo
    }
  }
}
    ${ComponentsWrapperFragmentDoc}
${RichTextComponentFragmentDoc}
${LinksAsCardsComponentFragmentDoc}
${DatoImageFragmentDoc}
${HeroImageComponentFragmentDoc}
${ColumnContentComponentFragmentDoc}
${RichTextBlockFragmentDoc}
${ProductsSliderComponentFragmentDoc}
${CollectionProductListComponentFragmentDoc}
${DatoProductForCategoryPageFragmentDoc}
${CompatibleMachineFragmentDoc}
${SplitContentComponentFragmentDoc}
${SplitContentImageFragmentDoc}
${SplitContentTextFragmentDoc}
${SplitHeroComponentFragmentDoc}
${BigTilesComponentFragmentDoc}
${SmallTilesComponentFragmentDoc}
${HomepageHeroComponentFragmentDoc}
${FeaturedBlogPostComponentFragmentDoc}
${ExternalVideoComponentFragmentDoc}
${TabsComponentFragmentDoc}
${TabFaqComponentFragmentDoc}
${NewsletterFragmentDoc}
${SeoFragmentDoc}`;
export const GasExchangePageDocument = /*#__PURE__*/ gql`
    query GasExchangePage {
  gasExchangePage {
    pageBackgroundColor {
      hex
    }
    title {
      title
      description
    }
    gasSelectorText
    recommendedCylindersText
    peopleSelect {
      options {
        id
        label
        value
      }
    }
    bottlesSelect {
      options {
        id
        label
        value
      }
    }
    customCylinders {
      id
      image {
        responsiveImage(imgixParams: {fit: max, auto: format}) {
          ...DatoImage
        }
      }
      title
      description
      price
      buttonText
      buttonUrl
      compatibleMachines {
        ...CompatibleMachine
      }
    }
    components {
      ...ComponentsWrapper
    }
    seo {
      ...Seo
    }
    lowestPriceText
  }
}
    ${DatoImageFragmentDoc}
${CompatibleMachineFragmentDoc}
${ComponentsWrapperFragmentDoc}
${RichTextComponentFragmentDoc}
${LinksAsCardsComponentFragmentDoc}
${HeroImageComponentFragmentDoc}
${ColumnContentComponentFragmentDoc}
${RichTextBlockFragmentDoc}
${ProductsSliderComponentFragmentDoc}
${CollectionProductListComponentFragmentDoc}
${DatoProductForCategoryPageFragmentDoc}
${SplitContentComponentFragmentDoc}
${SplitContentImageFragmentDoc}
${SplitContentTextFragmentDoc}
${SplitHeroComponentFragmentDoc}
${BigTilesComponentFragmentDoc}
${SmallTilesComponentFragmentDoc}
${HomepageHeroComponentFragmentDoc}
${FeaturedBlogPostComponentFragmentDoc}
${ExternalVideoComponentFragmentDoc}
${TabsComponentFragmentDoc}
${TabFaqComponentFragmentDoc}
${NewsletterFragmentDoc}
${SeoFragmentDoc}`;
export const LabelBySlugDocument = /*#__PURE__*/ gql`
    query LabelBySlug($slug: String) {
  productLabel(filter: {slug: {eq: $slug}}) {
    id
    label
    slug
  }
}
    `;
export const LegalBySlugDocument = /*#__PURE__*/ gql`
    query LegalBySlug($slug: String) {
  legal(filter: {slug: {eq: $slug}}) {
    legalSection {
      heading
      content {
        value
      }
    }
    slug
    seo {
      ...Seo
    }
  }
}
    ${SeoFragmentDoc}`;
export const LoginPageDocument = /*#__PURE__*/ gql`
    query LoginPage {
  loginPage {
    seo {
      ...Seo
    }
  }
}
    ${SeoFragmentDoc}`;
export const Page404Document = /*#__PURE__*/ gql`
    query Page404 {
  page404 {
    components {
      ...ComponentsWrapper
    }
  }
}
    ${ComponentsWrapperFragmentDoc}
${RichTextComponentFragmentDoc}
${LinksAsCardsComponentFragmentDoc}
${DatoImageFragmentDoc}
${HeroImageComponentFragmentDoc}
${ColumnContentComponentFragmentDoc}
${RichTextBlockFragmentDoc}
${ProductsSliderComponentFragmentDoc}
${CollectionProductListComponentFragmentDoc}
${DatoProductForCategoryPageFragmentDoc}
${CompatibleMachineFragmentDoc}
${SplitContentComponentFragmentDoc}
${SplitContentImageFragmentDoc}
${SplitContentTextFragmentDoc}
${SplitHeroComponentFragmentDoc}
${BigTilesComponentFragmentDoc}
${SmallTilesComponentFragmentDoc}
${HomepageHeroComponentFragmentDoc}
${FeaturedBlogPostComponentFragmentDoc}
${ExternalVideoComponentFragmentDoc}
${TabsComponentFragmentDoc}
${TabFaqComponentFragmentDoc}
${NewsletterFragmentDoc}`;
export const ProductPageContentBySlugDocument = /*#__PURE__*/ gql`
    query ProductPageContentBySlug($slug: String) {
  product(filter: {slug: {eq: $slug}}) {
    components {
      ...ComponentsWrapper
    }
    faq {
      ...FaqComponent
    }
    seo {
      ...Seo
    }
  }
}
    ${ComponentsWrapperFragmentDoc}
${RichTextComponentFragmentDoc}
${LinksAsCardsComponentFragmentDoc}
${DatoImageFragmentDoc}
${HeroImageComponentFragmentDoc}
${ColumnContentComponentFragmentDoc}
${RichTextBlockFragmentDoc}
${ProductsSliderComponentFragmentDoc}
${CollectionProductListComponentFragmentDoc}
${DatoProductForCategoryPageFragmentDoc}
${CompatibleMachineFragmentDoc}
${SplitContentComponentFragmentDoc}
${SplitContentImageFragmentDoc}
${SplitContentTextFragmentDoc}
${SplitHeroComponentFragmentDoc}
${BigTilesComponentFragmentDoc}
${SmallTilesComponentFragmentDoc}
${HomepageHeroComponentFragmentDoc}
${FeaturedBlogPostComponentFragmentDoc}
${ExternalVideoComponentFragmentDoc}
${TabsComponentFragmentDoc}
${TabFaqComponentFragmentDoc}
${NewsletterFragmentDoc}
${FaqComponentFragmentDoc}
${SeoFragmentDoc}`;
export const ProductsByGtinDocument = /*#__PURE__*/ gql`
    query ProductsByGtin($gtin: [String]) {
  allProducts(
    filter: {OR: [{gtin: {in: $gtin}}, {cylinderTypes: {any: {cylinderType: {gtin: {in: $gtin}}}}}]}
  ) {
    gtin
    slug
    category {
      analyticsCategoryName
      slug
    }
    cylinderTypes {
      gtin
      spareCylinder {
        gtin
      }
    }
  }
}
    `;
export const ProductsByGtinAndBundleTagDocument = /*#__PURE__*/ gql`
    query ProductsByGtinAndBundleTag($gtins: [String], $bundleTags: [String]) {
  allProducts(
    filter: {OR: [{gtin: {in: $gtins}}, {bundleTag: {in: $bundleTags}}, {productBundles: {any: {productBundle: {bundleId: {in: $bundleTags}}}}}, {cylinderTypes: {any: {cylinderType: {gtin: {in: $gtins}}}}}]}
  ) {
    bundleTag
    productBundles {
      bundleId
    }
    gtin
    slug
    category {
      analyticsCategoryName
      slug
    }
    cylinderTypes {
      gtin
      spareCylinder {
        gtin
      }
    }
    aboveTitlePromo {
      text
      textColor {
        hex
      }
    }
    belowTitlePromo {
      text
      textColor {
        hex
      }
    }
  }
}
    `;
export const RegisterPageDocument = /*#__PURE__*/ gql`
    query RegisterPage {
  registerPage {
    seo {
      ...Seo
    }
  }
}
    ${SeoFragmentDoc}`;
export const TranslationDocument = /*#__PURE__*/ gql`
    query Translation {
  translation {
    added
    removed
    addToCart
    nutritionInformation
    ingredients
    howManyDoYouNeed
    page404 {
      header
      description
      linkText
    }
    page500 {
      header
      description
      linkText
    }
    cartDiscountWarning
    cartEmpty
    startShopping
    yourCart
    freeShipping
    amountUntilFreeShipping
    checkout
    outOfStockError
    quantityUpdatedWarning
    remove
    subtotal
    shipping
    free
    taxes
    calculatedAtCheckout
    grandTotal
    checkoutWith
    filterBy
    comingSoon
    thanksForRegisteringMachine
    month
    months
    cylinder
    cylinders
    shopNow
    for
    viewCompatibility
    cylinderCompatibleWithTheFollowing
    bottleCompatibleWithTheFollowing
    compatibleWithAllAlternativeBrandSparklingWaterMakers
    gotIt
    doesBottleFitMachine
    compareTo
    startingAt
    unknownError
    thankYouNewsletter
    quickconnectFeatureText
    ordering
    edit
    delivery
    quantity
    review
    selectCylinderType
    orderSummary
    each
    orderQuantity
    addAnExtraCylinder
    weSuggestEveryCustomerHaveAtLeast
    addAnExtraCylinderToMyOrderFor
    co2TermsText
    pleaseSelectACylinder
    whichCylinderDoINeed
    continue
    addToCartFor
    iAlreadyHaveAnAccount
    useAtLeast8Characters {
      value
    }
    useAtLeast1UppercaseAnd1LowercaseLetter {
      value
    }
    useAtLeast2Numbers {
      value
    }
    useAtLeast1SpecialCharacter {
      value
    }
    chooseYourPack
    selectYourColor
    youSelected
    showMore
    showLess
    youAreRegisteringYour
    sparklingWaterMaker
    placeOfPurchase
    selectLocationPlaceholder
    dateOfPurchase
    createYourAccount
    firstName
    firstNamePlaceholder
    firstNameIsRequired
    lastName
    lastNamePlaceholder
    lastNameIsRequired
    emailAddress
    emailAddressPlaceholder
    emailIsRequired
    invalidEmail
    createAPassword
    createPasswordPlaceholder
    invalidPassword
    passwordIsRequired
    dateOfBirth
    linkConfirmationSubtext
    ageDisclaimerSubtext
    completeYourRegistration
    compatibleMachinesFilterMainHeading
    compatibleMachinesFilterEmptyFilterText
    compatibleMachinesFilterFilledFilterText
    compatibleMachinesFilterContainerHeading
    unknownRegistrationError
    termsAreRequired
    machineIsRequired
    purchasePlaceIsRequired
    purchaseDateIsRequired
    purchaseDate2Years
    invalidPurchaseDate
    howItWorksText
    howToFizzText
    cylinderInsertionText
    bottleMaterialText
    dishwasherSafeBottlesText
    compatibleBottlesText
    dimensionsText
    machineComparisonTitle {
      value
    }
    viewArticle
    quickLinks
    all
    colors
    price
    returnEmptyCylinder
    homepagePopup
    shareThisArticle
    selectOrderQuantity
    homepage
    blog
    pack
  }
}
    `;
export const allArticlesDocument = /*#__PURE__*/ gql`
    query allArticles($skip: IntType, $first: IntType) {
  allArticles(skip: $skip, first: $first) {
    id
    slug
    title
    _updatedAt
    section {
      slug
    }
    seo {
      seo {
        noIndex
      }
    }
    heroVisual {
      url
    }
  }
}
    `;
export const AllBlogSectionsDocument = /*#__PURE__*/ gql`
    query AllBlogSections($skip: IntType, $first: IntType) {
  allBlogSections(skip: $skip, first: $first) {
    id
    title
    filterText
    shouldAppearAsCategoryFilter
    _updatedAt
    heroVisual {
      responsiveImage(imgixParams: {fit: max, auto: format}) {
        ...DatoImage
      }
    }
    mainArticleTitle {
      value
    }
    mainArticleTitleText
    mainArticleSummary {
      value
    }
    seo {
      ...Seo
    }
    mainArticle {
      id
      slug
      title
      heroVisual {
        responsiveImage(imgixParams: {fit: max, auto: format}) {
          ...DatoImage
        }
      }
    }
    secondaryArticles {
      id
      slug
      title
      heroVisual {
        responsiveImage(imgixParams: {fit: max, auto: format}) {
          ...DatoImage
        }
      }
    }
    slug
  }
  _allBlogSectionsMeta {
    count
  }
}
    ${DatoImageFragmentDoc}
${SeoFragmentDoc}`;
export const AllProdctLabelsDocument = /*#__PURE__*/ gql`
    query AllProdctLabels {
  allProductLabels {
    id
    label
    slug
  }
}
    `;
export const AllPopupsDocument = /*#__PURE__*/ gql`
    query AllPopups {
  allPopups {
    buttonText
    disclaimerText {
      value
    }
    heroImage {
      url
    }
    imageOnLeftSide
    mainText {
      value
      blocks {
        showCheckbox
        legalText {
          value
        }
        id
      }
    }
    inputFields {
      inputFieldPlaceholder
      inputType
    }
    welcomeText {
      value
    }
    showPopupAfter
  }
}
    `;
export const AllProductsDocument = /*#__PURE__*/ gql`
    query AllProducts($skip: IntType, $first: IntType) {
  allProducts(skip: $skip, first: $first) {
    _updatedAt
    gtin
    position
    shortDescription
    productContent {
      blocks
      links
      value
    }
    productImages {
      url
      alt
      responsiveImage(imgixParams: {fit: max, auto: format}) {
        ...DatoImage
      }
    }
    plpThumbnail {
      url
      responsiveImage(imgixParams: {fit: max, auto: format}) {
        ...DatoImage
      }
    }
    title
    slug
    category {
      analyticsCategoryName
      slug
    }
    colorVariants {
      color {
        hex
      }
    }
    color {
      hex
    }
    comparisonData {
      howItWorks
      howToFizz
      cylinderInsertion
      bottleMaterial
      dishwasherSafeBottles
      compatibleBottles
      dimensions
    }
    cylinderTypes {
      gtin
      spareCylinder {
        gtin
      }
    }
    seo {
      seo {
        noIndex
      }
    }
  }
  _allProductsMeta {
    count
  }
}
    ${DatoImageFragmentDoc}`;
export const allCollectionPagesDocument = /*#__PURE__*/ gql`
    query allCollectionPages($skip: IntType, $first: IntType) {
  allCollectionPages(skip: $skip, first: $first) {
    slug
    title
    _updatedAt
    seo {
      seo {
        noIndex
      }
    }
  }
  _allCollectionPagesMeta {
    count
  }
}
    `;
export const allLandingPagesDocument = /*#__PURE__*/ gql`
    query allLandingPages($skip: IntType, $first: IntType) {
  allLandingPages(skip: $skip, first: $first) {
    title
    slug
    _updatedAt
    _seoMetaTags {
      tag
      content
      attributes
    }
    seo {
      seo {
        noIndex
      }
    }
  }
  _allLandingPagesMeta {
    count
  }
}
    `;
export const allProductCategoriesDocument = /*#__PURE__*/ gql`
    query allProductCategories($skip: IntType, $first: IntType) {
  allProductCategories(skip: $skip, first: $first) {
    slug
    title
    _updatedAt
    seo {
      seo {
        noIndex
      }
    }
  }
  _allProductCategoriesMeta {
    count
  }
}
    `;
export const ArticleBySlugDocument = /*#__PURE__*/ gql`
    query ArticleBySlug($slug: String) {
  article(filter: {slug: {eq: $slug}}) {
    id
    slug
    content {
      value
      blocks {
        ... on ImageRecord {
          id
          __typename
          image {
            responsiveImage(imgixParams: {fit: max, auto: format}) {
              ...DatoImage
            }
          }
        }
        ... on VideoRecord {
          id
          __typename
          video {
            video {
              muxPlaybackId
              thumbnailUrl
              streamingUrl
            }
          }
        }
      }
      links {
        ... on RichTextComponentRecord {
          ...RichTextComponent
        }
        ... on LinksAsCardsComponentRecord {
          ...LinksAsCardsComponent
        }
        ... on HeroImageComponentRecord {
          ...HeroImageComponent
        }
        ... on ColumnContentComponentRecord {
          ...ColumnContentComponent
        }
        ... on ProductsSliderComponentRecord {
          ...ProductsSliderComponent
        }
        ... on SplitContentComponentRecord {
          ...SplitContentComponent
        }
        ... on SplitHeroComponentRecord {
          ...SplitHeroComponent
        }
        ... on BigTilesComponentRecord {
          ...BigTilesComponent
        }
        ... on SmallTilesComponentRecord {
          ...SmallTilesComponent
        }
        ... on HomepageHeroComponentRecord {
          ...HomepageHeroComponent
        }
        ... on FeaturedBlogPostComponentRecord {
          ...FeaturedBlogPostComponent
        }
        ... on ExternalVideoRecord {
          ...ExternalVideoComponent
        }
        ... on FaqComponentRecord {
          ...TabFaqComponent
        }
      }
    }
    title
    heroVisual {
      responsiveImage(imgixParams: {fit: max, auto: format}) {
        ...DatoImage
      }
    }
    featuredProducts {
      productImages {
        url
        width
      }
      shortDescription
      slug
      title
      category {
        slug
      }
    }
    featuredProductDirection
    seo {
      ...Seo
    }
    section {
      slug
    }
  }
}
    ${DatoImageFragmentDoc}
${RichTextComponentFragmentDoc}
${LinksAsCardsComponentFragmentDoc}
${HeroImageComponentFragmentDoc}
${ColumnContentComponentFragmentDoc}
${RichTextBlockFragmentDoc}
${ProductsSliderComponentFragmentDoc}
${SplitContentComponentFragmentDoc}
${SplitContentImageFragmentDoc}
${SplitContentTextFragmentDoc}
${SplitHeroComponentFragmentDoc}
${BigTilesComponentFragmentDoc}
${SmallTilesComponentFragmentDoc}
${HomepageHeroComponentFragmentDoc}
${FeaturedBlogPostComponentFragmentDoc}
${ExternalVideoComponentFragmentDoc}
${TabFaqComponentFragmentDoc}
${SeoFragmentDoc}`;
export const ArticleComponentsBySlugDocument = /*#__PURE__*/ gql`
    query ArticleComponentsBySlug($slug: String) {
  article(filter: {slug: {eq: $slug}}) {
    id
    slug
    components {
      ...ComponentsWrapper
    }
  }
}
    ${ComponentsWrapperFragmentDoc}
${RichTextComponentFragmentDoc}
${LinksAsCardsComponentFragmentDoc}
${DatoImageFragmentDoc}
${HeroImageComponentFragmentDoc}
${ColumnContentComponentFragmentDoc}
${RichTextBlockFragmentDoc}
${ProductsSliderComponentFragmentDoc}
${CollectionProductListComponentFragmentDoc}
${DatoProductForCategoryPageFragmentDoc}
${CompatibleMachineFragmentDoc}
${SplitContentComponentFragmentDoc}
${SplitContentImageFragmentDoc}
${SplitContentTextFragmentDoc}
${SplitHeroComponentFragmentDoc}
${BigTilesComponentFragmentDoc}
${SmallTilesComponentFragmentDoc}
${HomepageHeroComponentFragmentDoc}
${FeaturedBlogPostComponentFragmentDoc}
${ExternalVideoComponentFragmentDoc}
${TabsComponentFragmentDoc}
${TabFaqComponentFragmentDoc}
${NewsletterFragmentDoc}`;
export const DesktopHeaderDocument = /*#__PURE__*/ gql`
    query DesktopHeader {
  desktopHeader {
    leftDropdownItems {
      id
      title
      headerLeftSingleDropdown {
        id
        customTextColor
        backgroundColor {
          hex
        }
        url
        linkText
        image {
          url
          alt
        }
      }
    }
    middleLinks {
      id
      title
      url
    }
    rightLinks {
      id
      url
      title
    }
    promotionalBar
    promotionalBarLink
    promotionalBarTextColor {
      hex
    }
    promotionalBarBackgroundColor {
      hex
    }
  }
}
    `;
export const FooterDocument = /*#__PURE__*/ gql`
    query Footer {
  footer {
    id
    firstColumnHeading
    secondColumnHeading
    thirdColumnHeading
    firstColumnLinks {
      url
      title
    }
    secondColumnLinks {
      url
      title
    }
    thirdColumnLinks {
      url
      title
    }
    newsletter {
      ...Newsletter
    }
    copyrightInfo {
      value
    }
    socialMediaLinks {
      id
      image {
        responsiveImage(imgixParams: {fit: max, auto: format, w: 38, h: 38}) {
          ...DatoImage
        }
      }
      url
    }
  }
}
    ${NewsletterFragmentDoc}
${DatoImageFragmentDoc}`;
export const HomePageDocument = /*#__PURE__*/ gql`
    query HomePage {
  homePage {
    components {
      ...ComponentsWrapper
    }
    seo {
      ...Seo
    }
  }
}
    ${ComponentsWrapperFragmentDoc}
${RichTextComponentFragmentDoc}
${LinksAsCardsComponentFragmentDoc}
${DatoImageFragmentDoc}
${HeroImageComponentFragmentDoc}
${ColumnContentComponentFragmentDoc}
${RichTextBlockFragmentDoc}
${ProductsSliderComponentFragmentDoc}
${CollectionProductListComponentFragmentDoc}
${DatoProductForCategoryPageFragmentDoc}
${CompatibleMachineFragmentDoc}
${SplitContentComponentFragmentDoc}
${SplitContentImageFragmentDoc}
${SplitContentTextFragmentDoc}
${SplitHeroComponentFragmentDoc}
${BigTilesComponentFragmentDoc}
${SmallTilesComponentFragmentDoc}
${HomepageHeroComponentFragmentDoc}
${FeaturedBlogPostComponentFragmentDoc}
${ExternalVideoComponentFragmentDoc}
${TabsComponentFragmentDoc}
${TabFaqComponentFragmentDoc}
${NewsletterFragmentDoc}
${SeoFragmentDoc}`;
export const LandingPageBySlugDocument = /*#__PURE__*/ gql`
    query LandingPageBySlug($slug: String) {
  landingPage(filter: {slug: {eq: $slug}}) {
    title
    slug
    content
    components {
      ...ComponentsWrapper
    }
    seo {
      ...Seo
    }
  }
}
    ${ComponentsWrapperFragmentDoc}
${RichTextComponentFragmentDoc}
${LinksAsCardsComponentFragmentDoc}
${DatoImageFragmentDoc}
${HeroImageComponentFragmentDoc}
${ColumnContentComponentFragmentDoc}
${RichTextBlockFragmentDoc}
${ProductsSliderComponentFragmentDoc}
${CollectionProductListComponentFragmentDoc}
${DatoProductForCategoryPageFragmentDoc}
${CompatibleMachineFragmentDoc}
${SplitContentComponentFragmentDoc}
${SplitContentImageFragmentDoc}
${SplitContentTextFragmentDoc}
${SplitHeroComponentFragmentDoc}
${BigTilesComponentFragmentDoc}
${SmallTilesComponentFragmentDoc}
${HomepageHeroComponentFragmentDoc}
${FeaturedBlogPostComponentFragmentDoc}
${ExternalVideoComponentFragmentDoc}
${TabsComponentFragmentDoc}
${TabFaqComponentFragmentDoc}
${NewsletterFragmentDoc}
${SeoFragmentDoc}`;
export const MachineBySlugDocument = /*#__PURE__*/ gql`
    query MachineBySlug($slug: String) {
  machine(filter: {slug: {eq: $slug}}) {
    id
    slug
    name
    components {
      ...ComponentsWrapper
    }
    seo {
      ...Seo
    }
  }
}
    ${ComponentsWrapperFragmentDoc}
${RichTextComponentFragmentDoc}
${LinksAsCardsComponentFragmentDoc}
${DatoImageFragmentDoc}
${HeroImageComponentFragmentDoc}
${ColumnContentComponentFragmentDoc}
${RichTextBlockFragmentDoc}
${ProductsSliderComponentFragmentDoc}
${CollectionProductListComponentFragmentDoc}
${DatoProductForCategoryPageFragmentDoc}
${CompatibleMachineFragmentDoc}
${SplitContentComponentFragmentDoc}
${SplitContentImageFragmentDoc}
${SplitContentTextFragmentDoc}
${SplitHeroComponentFragmentDoc}
${BigTilesComponentFragmentDoc}
${SmallTilesComponentFragmentDoc}
${HomepageHeroComponentFragmentDoc}
${FeaturedBlogPostComponentFragmentDoc}
${ExternalVideoComponentFragmentDoc}
${TabsComponentFragmentDoc}
${TabFaqComponentFragmentDoc}
${NewsletterFragmentDoc}
${SeoFragmentDoc}`;
export const MachineRegistrationDocument = /*#__PURE__*/ gql`
    query MachineRegistration {
  machineRegistrationPage {
    headerText
    subHeaderText
    header {
      ...RichTextBlock
    }
    machinesHeader
    machineBannerBackground {
      responsiveImage(imgixParams: {fit: max, w: 500, h: 500, auto: format}) {
        ...DatoImage
      }
    }
    machines {
      id
      name
      slug
      gtin
      image {
        responsiveImage(imgixParams: {fit: max, w: 300, h: 650, auto: format}) {
          ...DatoImage
        }
      }
    }
    machineDetailsHeader
    purchaseLocation {
      id
      value
      label
    }
    emailSubscriptionText {
      ...RichTextBlock
    }
    termsOfServiceText {
      ...RichTextBlock
    }
    benefitsOfAccount {
      ...SliderWithImageAndStructuredText
    }
    seo {
      ...Seo
    }
    customData {
      id
      key
      value
    }
  }
}
    ${RichTextBlockFragmentDoc}
${DatoImageFragmentDoc}
${SliderWithImageAndStructuredTextFragmentDoc}
${MediaWithStructuredTextFragmentDoc}
${SeoFragmentDoc}`;
export const MobileHeaderDocument = /*#__PURE__*/ gql`
    query MobileHeader {
  mobileHeader {
    customHeaderLinks {
      id
      title
      url
      openMenu
      color {
        hex
      }
    }
    mobileMenuCategories {
      id
      title
      image {
        responsiveImage(imgixParams: {fit: max, auto: format}) {
          ...DatoImage
        }
      }
      content {
        id
        linkText
        textColor
        backgroundColor {
          hex
        }
        url
        image {
          responsiveImage(imgixParams: {fit: max, auto: format}) {
            ...DatoImage
          }
        }
      }
    }
    bottomMenuLinks {
      id
      title
      url
      color {
        hex
      }
    }
    bottomMenuColoredLink {
      id
      title
      url
      color {
        hex
      }
    }
    promotionalBar
    promotionalBarLink
    promotionalBarTextColor {
      hex
    }
    promotionalBarBackgroundColor {
      hex
    }
  }
}
    ${DatoImageFragmentDoc}`;
export const ProductBySlugDocument = /*#__PURE__*/ gql`
    query ProductBySlug($slug: String) {
  product(filter: {slug: {eq: $slug}}) {
    components {
      ...ComponentsWrapper
    }
    faq {
      ...FaqComponent
    }
    seo {
      ...Seo
    }
    gtin
    bundleTag
    position
    shortDescription
    productContent {
      blocks
      links
      value
    }
    heroTitle
    heroDescription
    heroImage {
      responsiveImage(imgixParams: {fit: max, auto: format}) {
        ...DatoImage
      }
    }
    productImages {
      responsiveImage(imgixParams: {fit: max, auto: format}) {
        ...DatoImage
      }
    }
    title
    slug
    color {
      hex
    }
    category {
      style
      analyticsName
      analyticsCategoryName
      slug
    }
    colorVariants {
      title
      slug
      color {
        hex
      }
      analyticsColorName
    }
    analyticsColorName
    nutrition {
      image {
        responsiveImage(imgixParams: {fit: max, auto: format}) {
          ...DatoImage
        }
      }
      ingredients {
        value
      }
    }
    productBundles {
      title
      bundleImage {
        responsiveImage(imgixParams: {fit: max, auto: format}) {
          ...DatoImage
        }
      }
      bundleId
      bundleItems {
        amount
        title
        image {
          responsiveImage(imgixParams: {fit: max, auto: format}) {
            ...DatoImage
          }
        }
      }
      lowestPriceText
      description {
        header
        text
      }
    }
    productBenefits {
      image {
        responsiveImage(imgixParams: {fit: max, auto: format}) {
          ...DatoImage
        }
      }
      text
    }
    cylinderTypes {
      gtin
      image {
        responsiveImage(imgixParams: {fit: max, auto: format}) {
          ...DatoImage
        }
      }
      title
      description
      blueBoxText
      cylinderTextDescription {
        header
        text
      }
      spareCylinder {
        image {
          responsiveImage(imgixParams: {fit: max, auto: format}) {
            ...DatoImage
          }
        }
        title
        gtin
        lowestPriceText
      }
      compatibleMachines {
        ...CompatibleMachine
      }
      lowestPriceText
    }
    compatibleMachines {
      ...CompatibleMachine
    }
    cylinderQuantityOptions {
      amount
      extraText
      promotionalText
    }
    cylinderFrequencyOptions {
      periodLengthNumber
      periodLengthText
    }
    cylinderSelectionInfo
    comparisonData {
      howItWorks
      howToFizz
      cylinderInsertion
      bottleMaterial
      dishwasherSafeBottles
      compatibleBottles
      dimensions
    }
    lowestPriceText
    product3dModel {
      url
    }
    product3dPoster {
      responsiveImage(imgixParams: {fit: max, auto: format}) {
        ...DatoImage
      }
    }
    returnPolicy {
      policy {
        value
      }
    }
  }
}
    ${ComponentsWrapperFragmentDoc}
${RichTextComponentFragmentDoc}
${LinksAsCardsComponentFragmentDoc}
${DatoImageFragmentDoc}
${HeroImageComponentFragmentDoc}
${ColumnContentComponentFragmentDoc}
${RichTextBlockFragmentDoc}
${ProductsSliderComponentFragmentDoc}
${CollectionProductListComponentFragmentDoc}
${DatoProductForCategoryPageFragmentDoc}
${CompatibleMachineFragmentDoc}
${SplitContentComponentFragmentDoc}
${SplitContentImageFragmentDoc}
${SplitContentTextFragmentDoc}
${SplitHeroComponentFragmentDoc}
${BigTilesComponentFragmentDoc}
${SmallTilesComponentFragmentDoc}
${HomepageHeroComponentFragmentDoc}
${FeaturedBlogPostComponentFragmentDoc}
${ExternalVideoComponentFragmentDoc}
${TabsComponentFragmentDoc}
${TabFaqComponentFragmentDoc}
${NewsletterFragmentDoc}
${FaqComponentFragmentDoc}
${SeoFragmentDoc}`;
export const ProductCategoryBySlugDocument = /*#__PURE__*/ gql`
    query ProductCategoryBySlug($slug: String) {
  productCategory(filter: {slug: {eq: $slug}}) {
    ...ProductCategory
    _allReferencingProducts(first: 100) {
      ...DatoProductForCategoryPage
    }
    components {
      ...ComponentsWrapper
    }
  }
}
    ${ProductCategoryFragmentDoc}
${DatoImageFragmentDoc}
${PromotionalCardFragmentDoc}
${SeoFragmentDoc}
${DatoProductForCategoryPageFragmentDoc}
${CompatibleMachineFragmentDoc}
${ComponentsWrapperFragmentDoc}
${RichTextComponentFragmentDoc}
${LinksAsCardsComponentFragmentDoc}
${HeroImageComponentFragmentDoc}
${ColumnContentComponentFragmentDoc}
${RichTextBlockFragmentDoc}
${ProductsSliderComponentFragmentDoc}
${CollectionProductListComponentFragmentDoc}
${SplitContentComponentFragmentDoc}
${SplitContentImageFragmentDoc}
${SplitContentTextFragmentDoc}
${SplitHeroComponentFragmentDoc}
${BigTilesComponentFragmentDoc}
${SmallTilesComponentFragmentDoc}
${HomepageHeroComponentFragmentDoc}
${FeaturedBlogPostComponentFragmentDoc}
${ExternalVideoComponentFragmentDoc}
${TabsComponentFragmentDoc}
${TabFaqComponentFragmentDoc}
${NewsletterFragmentDoc}`;
export const ProductsByProductCategorySlugDocument = /*#__PURE__*/ gql`
    query ProductsByProductCategorySlug($slug: String) {
  productCategory(filter: {slug: {eq: $slug}}) {
    _allReferencingProducts(first: 100) {
      ...DatoProductForCategoryPage
    }
  }
}
    ${DatoProductForCategoryPageFragmentDoc}
${DatoImageFragmentDoc}
${CompatibleMachineFragmentDoc}`;
export const SocialShareConfigurationDocument = /*#__PURE__*/ gql`
    query SocialShareConfiguration {
  socialShareConfiguration {
    linkedinShare
    facebookShare
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    ArticlesBySection(variables?: ArticlesBySectionQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ArticlesBySectionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArticlesBySectionQuery>(ArticlesBySectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArticlesBySection', 'query');
    },
    BlogPage(variables?: BlogPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BlogPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogPageQuery>(BlogPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogPage', 'query');
    },
    CategoryComponentsBySlug(variables?: CategoryComponentsBySlugQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CategoryComponentsBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CategoryComponentsBySlugQuery>(CategoryComponentsBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CategoryComponentsBySlug', 'query');
    },
    CollectionPageBySlug(variables?: CollectionPageBySlugQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CollectionPageBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CollectionPageBySlugQuery>(CollectionPageBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CollectionPageBySlug', 'query');
    },
    CartPage(variables?: CartPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CartPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CartPageQuery>(CartPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CartPage', 'query');
    },
    GasExchangePage(variables?: GasExchangePageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GasExchangePageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GasExchangePageQuery>(GasExchangePageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GasExchangePage', 'query');
    },
    LabelBySlug(variables?: LabelBySlugQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<LabelBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LabelBySlugQuery>(LabelBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LabelBySlug', 'query');
    },
    LegalBySlug(variables?: LegalBySlugQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<LegalBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LegalBySlugQuery>(LegalBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LegalBySlug', 'query');
    },
    LoginPage(variables?: LoginPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<LoginPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginPageQuery>(LoginPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LoginPage', 'query');
    },
    Page404(variables?: Page404QueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Page404Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Page404Query>(Page404Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Page404', 'query');
    },
    ProductPageContentBySlug(variables?: ProductPageContentBySlugQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ProductPageContentBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductPageContentBySlugQuery>(ProductPageContentBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ProductPageContentBySlug', 'query');
    },
    ProductsByGtin(variables?: ProductsByGtinQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ProductsByGtinQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductsByGtinQuery>(ProductsByGtinDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ProductsByGtin', 'query');
    },
    ProductsByGtinAndBundleTag(variables?: ProductsByGtinAndBundleTagQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ProductsByGtinAndBundleTagQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductsByGtinAndBundleTagQuery>(ProductsByGtinAndBundleTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ProductsByGtinAndBundleTag', 'query');
    },
    RegisterPage(variables?: RegisterPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RegisterPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegisterPageQuery>(RegisterPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RegisterPage', 'query');
    },
    Translation(variables?: TranslationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<TranslationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TranslationQuery>(TranslationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Translation', 'query');
    },
    allArticles(variables?: allArticlesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<allArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<allArticlesQuery>(allArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'allArticles', 'query');
    },
    AllBlogSections(variables?: AllBlogSectionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AllBlogSectionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllBlogSectionsQuery>(AllBlogSectionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AllBlogSections', 'query');
    },
    AllProdctLabels(variables?: AllProdctLabelsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AllProdctLabelsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllProdctLabelsQuery>(AllProdctLabelsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AllProdctLabels', 'query');
    },
    AllPopups(variables?: AllPopupsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AllPopupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllPopupsQuery>(AllPopupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AllPopups', 'query');
    },
    AllProducts(variables?: AllProductsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AllProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllProductsQuery>(AllProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AllProducts', 'query');
    },
    allCollectionPages(variables?: allCollectionPagesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<allCollectionPagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<allCollectionPagesQuery>(allCollectionPagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'allCollectionPages', 'query');
    },
    allLandingPages(variables?: allLandingPagesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<allLandingPagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<allLandingPagesQuery>(allLandingPagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'allLandingPages', 'query');
    },
    allProductCategories(variables?: allProductCategoriesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<allProductCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<allProductCategoriesQuery>(allProductCategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'allProductCategories', 'query');
    },
    ArticleBySlug(variables?: ArticleBySlugQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ArticleBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArticleBySlugQuery>(ArticleBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArticleBySlug', 'query');
    },
    ArticleComponentsBySlug(variables?: ArticleComponentsBySlugQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ArticleComponentsBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArticleComponentsBySlugQuery>(ArticleComponentsBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArticleComponentsBySlug', 'query');
    },
    DesktopHeader(variables?: DesktopHeaderQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DesktopHeaderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DesktopHeaderQuery>(DesktopHeaderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DesktopHeader', 'query');
    },
    Footer(variables?: FooterQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FooterQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FooterQuery>(FooterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Footer', 'query');
    },
    HomePage(variables?: HomePageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<HomePageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<HomePageQuery>(HomePageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'HomePage', 'query');
    },
    LandingPageBySlug(variables?: LandingPageBySlugQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<LandingPageBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LandingPageBySlugQuery>(LandingPageBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LandingPageBySlug', 'query');
    },
    MachineBySlug(variables?: MachineBySlugQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MachineBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MachineBySlugQuery>(MachineBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MachineBySlug', 'query');
    },
    MachineRegistration(variables?: MachineRegistrationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MachineRegistrationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MachineRegistrationQuery>(MachineRegistrationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MachineRegistration', 'query');
    },
    MobileHeader(variables?: MobileHeaderQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MobileHeaderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MobileHeaderQuery>(MobileHeaderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MobileHeader', 'query');
    },
    ProductBySlug(variables?: ProductBySlugQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ProductBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductBySlugQuery>(ProductBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ProductBySlug', 'query');
    },
    ProductCategoryBySlug(variables?: ProductCategoryBySlugQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ProductCategoryBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductCategoryBySlugQuery>(ProductCategoryBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ProductCategoryBySlug', 'query');
    },
    ProductsByProductCategorySlug(variables?: ProductsByProductCategorySlugQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ProductsByProductCategorySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductsByProductCategorySlugQuery>(ProductsByProductCategorySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ProductsByProductCategorySlug', 'query');
    },
    SocialShareConfiguration(variables?: SocialShareConfigurationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SocialShareConfigurationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SocialShareConfigurationQuery>(SocialShareConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SocialShareConfiguration', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;